import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Bytes: any;
  DateTime: Date;
  Decimal: number;
  Json: any;
};

export type AdditionalRob = {
  __typename?: 'AdditionalROB';
  N_Fuel_Type: FuelType;
  N_Fuel_volume: Scalars['Decimal'];
  id: Scalars['Int'];
};

export type AdditionalRobForArrival = {
  __typename?: 'AdditionalROBForArrival';
  A_Fuel_Type: FuelType;
  A_Fuel_volume: Scalars['Decimal'];
  id: Scalars['Int'];
};

export type AdditionalRobForDeparture = {
  __typename?: 'AdditionalROBForDeparture';
  D_Fuel_Type: FuelType;
  D_Fuel_volume: Scalars['Decimal'];
  id: Scalars['Int'];
};

export type AdditionalRobForArrivalInput = {
  A_Fuel_Type: FuelType;
  A_Fuel_volume: Scalars['Decimal'];
  id: Scalars['Int'];
};

export type AdditionalRobForDepartureInput = {
  D_Fuel_Type: FuelType;
  D_Fuel_volume: Scalars['Decimal'];
  id: Scalars['Int'];
};

export type AdditionalRobInput = {
  N_Fuel_Type: FuelType;
  N_Fuel_volume: Scalars['Decimal'];
  id: Scalars['Int'];
};

export enum AnalysisFilterType {
  Filter1 = 'FILTER1',
  Filter2 = 'FILTER2',
  Filter3 = 'FILTER3',
  Filter4 = 'FILTER4'
}

export type AnalysisSearchParameter = {
  __typename?: 'AnalysisSearchParameter';
  AnalysisSearchParameterDetail?: Maybe<Array<Maybe<AnalysisSearchParameterDetail>>>;
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  title: Scalars['String'];
  updated_at: Scalars['DateTime'];
};

export type AnalysisSearchParameterDetail = {
  __typename?: 'AnalysisSearchParameterDetail';
  created_at: Scalars['DateTime'];
  filter_type: AnalysisFilterType;
  from_bf_scale?: Maybe<Scalars['Decimal']>;
  from_dateTime: Scalars['DateTime'];
  from_hrs_propelling?: Maybe<Scalars['Decimal']>;
  from_me_rpm?: Maybe<Scalars['Decimal']>;
  imo_no: Scalars['String'];
  n_LorB?: Maybe<LorB>;
  n_steam_mode?: Maybe<Scalars['String']>;
  n_voy?: Maybe<Scalars['String']>;
  to_bf_scale?: Maybe<Scalars['Decimal']>;
  to_dateTime: Scalars['DateTime'];
  to_hrs_propelling?: Maybe<Scalars['Decimal']>;
  to_me_rpm?: Maybe<Scalars['Decimal']>;
  updated_at: Scalars['DateTime'];
};

export type AnalysisSearchParameterDetailInput = {
  filter_type: AnalysisFilterType;
  from_bf_scale?: InputMaybe<Scalars['Decimal']>;
  from_dateTime: Scalars['DateTime'];
  from_hrs_propelling?: InputMaybe<Scalars['Decimal']>;
  from_me_rpm?: InputMaybe<Scalars['Decimal']>;
  imo_no: Scalars['String'];
  n_LorB?: InputMaybe<LorB>;
  n_steam_mode?: InputMaybe<Scalars['String']>;
  n_voy?: InputMaybe<Scalars['String']>;
  to_bf_scale?: InputMaybe<Scalars['Decimal']>;
  to_dateTime: Scalars['DateTime'];
  to_hrs_propelling?: InputMaybe<Scalars['Decimal']>;
  to_me_rpm?: InputMaybe<Scalars['Decimal']>;
};

export type AnalysisSearchParameterInput = {
  AnalysisSearchParameterDetailInput?: InputMaybe<Array<InputMaybe<AnalysisSearchParameterDetailInput>>>;
  id: Scalars['Int'];
  title: Scalars['String'];
};

export type Arrival = {
  __typename?: 'Arrival';
  A_Additional_ROB?: Maybe<Array<Maybe<AdditionalRobForArrival>>>;
  A_Arrival_Date_Time: Scalars['DateTime'];
  A_Arrival_Port: Scalars['String'];
  A_Berthed: Scalars['DateTime'];
  A_Distance_by_OG: Scalars['Decimal'];
  A_Draft_Aft: Scalars['Decimal'];
  A_Draft_Fore: Scalars['Decimal'];
  A_ETB: Scalars['DateTime'];
  A_ETC: Scalars['DateTime'];
  A_ETD: Scalars['DateTime'];
  A_EU_UK_port?: Maybe<EUorUk>;
  A_FO_CO2_emission: Scalars['Decimal'];
  A_FO_Consumption_per_day_B_and_Inc: Scalars['Decimal'];
  A_FO_Consumption_per_day_GE: Scalars['Decimal'];
  A_FO_Consumption_per_day_ME: Scalars['Decimal'];
  A_Hrs_since_Last_Noon: Scalars['Decimal'];
  A_LorB: LorB;
  A_MGO_CO2_emission: Scalars['Decimal'];
  A_MGO_Consumption_per_day_B_and_Inc: Scalars['Decimal'];
  A_MGO_Consumption_per_day_GE: Scalars['Decimal'];
  A_MGO_Consumption_per_day_ME: Scalars['Decimal'];
  A_Port_L_U?: Maybe<LorU>;
  A_ROB_FO: Scalars['Decimal'];
  A_ROB_FW: Scalars['Decimal'];
  A_ROB_GESO: Scalars['Decimal'];
  A_ROB_MECO: Scalars['Decimal'];
  A_ROB_MESO: Scalars['Decimal'];
  A_ROB_MGO: Scalars['Decimal'];
  A_ROB_at_Arrival_FO: Scalars['Decimal'];
  A_ROB_at_Arrival_FW: Scalars['Decimal'];
  A_ROB_at_Arrival_GESO: Scalars['Decimal'];
  A_ROB_at_Arrival_MECO: Scalars['Decimal'];
  A_ROB_at_Arrival_MESO: Scalars['Decimal'];
  A_ROB_at_Arrival_MGO: Scalars['Decimal'];
  A_Remark?: Maybe<Scalars['String']>;
  A_SB_or_Stop: Scalars['DateTime'];
  A_Spare_1?: Maybe<Scalars['String']>;
  A_Spare_1_unit_name?: Maybe<Scalars['String']>;
  A_Spare_2?: Maybe<Scalars['String']>;
  A_Spare_2_unit_name?: Maybe<Scalars['String']>;
  A_Spare_3?: Maybe<Scalars['String']>;
  A_Spare_3_unit_name?: Maybe<Scalars['String']>;
  A_Spare_4?: Maybe<Scalars['String']>;
  A_Spare_4_unit_name?: Maybe<Scalars['String']>;
  A_Spare_5?: Maybe<Scalars['String']>;
  A_Spare_5_unit_name?: Maybe<Scalars['String']>;
  A_Spare_6?: Maybe<Scalars['String']>;
  A_Spare_6_unit_name?: Maybe<Scalars['String']>;
  A_Spare_7?: Maybe<Scalars['String']>;
  A_Spare_7_unit_name?: Maybe<Scalars['String']>;
  A_Spare_8?: Maybe<Scalars['String']>;
  A_Spare_8_unit_name?: Maybe<Scalars['String']>;
  A_Spare_9?: Maybe<Scalars['String']>;
  A_Spare_9_unit_name?: Maybe<Scalars['String']>;
  A_Spare_10?: Maybe<Scalars['String']>;
  A_Spare_10_unit_name?: Maybe<Scalars['String']>;
  A_Spare_11?: Maybe<Scalars['String']>;
  A_Spare_11_unit_name?: Maybe<Scalars['String']>;
  A_Spare_12?: Maybe<Scalars['String']>;
  A_Spare_12_unit_name?: Maybe<Scalars['String']>;
  A_Spare_13?: Maybe<Scalars['String']>;
  A_Spare_13_unit_name?: Maybe<Scalars['String']>;
  A_Spare_14?: Maybe<Scalars['String']>;
  A_Spare_14_unit_name?: Maybe<Scalars['String']>;
  A_Spare_15?: Maybe<Scalars['String']>;
  A_Spare_15_unit_name?: Maybe<Scalars['String']>;
  A_Spare_16?: Maybe<Scalars['String']>;
  A_Spare_16_unit_name?: Maybe<Scalars['String']>;
  A_Spare_17?: Maybe<Scalars['String']>;
  A_Spare_17_unit_name?: Maybe<Scalars['String']>;
  A_Spare_18?: Maybe<Scalars['String']>;
  A_Spare_18_unit_name?: Maybe<Scalars['String']>;
  A_Spare_19?: Maybe<Scalars['String']>;
  A_Spare_19_unit_name?: Maybe<Scalars['String']>;
  A_Spare_20?: Maybe<Scalars['String']>;
  A_Spare_20_unit_name?: Maybe<Scalars['String']>;
  A_Time_Zone: Scalars['String'];
  A_UNLOC?: Maybe<Scalars['String']>;
  A_Vessel_Name: Scalars['String'];
  A_Voy: Scalars['String'];
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  ship: Ship;
  ship_id: Scalars['Int'];
  updated_at: Scalars['DateTime'];
  user: User;
  user_id: Scalars['Int'];
};

export type ArrivalInput = {
  A_Additional_ROB?: InputMaybe<Array<InputMaybe<AdditionalRobForArrivalInput>>>;
  A_Arrival_Date_Time: Scalars['DateTime'];
  A_Arrival_Port: Scalars['String'];
  A_Berthed: Scalars['DateTime'];
  A_Distance_by_OG: Scalars['Decimal'];
  A_Draft_Aft: Scalars['Decimal'];
  A_Draft_Fore: Scalars['Decimal'];
  A_ETB: Scalars['DateTime'];
  A_ETC: Scalars['DateTime'];
  A_ETD: Scalars['DateTime'];
  A_EU_UK_port?: InputMaybe<EUorUk>;
  A_FO_CO2_emission: Scalars['Decimal'];
  A_FO_Consumption_per_day_B_and_Inc: Scalars['Decimal'];
  A_FO_Consumption_per_day_GE: Scalars['Decimal'];
  A_FO_Consumption_per_day_ME: Scalars['Decimal'];
  A_Hrs_since_Last_Noon: Scalars['Decimal'];
  A_LorB: LorB;
  A_MGO_CO2_emission: Scalars['Decimal'];
  A_MGO_Consumption_per_day_B_and_Inc: Scalars['Decimal'];
  A_MGO_Consumption_per_day_GE: Scalars['Decimal'];
  A_MGO_Consumption_per_day_ME: Scalars['Decimal'];
  A_Port_L_U?: InputMaybe<LorU>;
  A_ROB_FO: Scalars['Decimal'];
  A_ROB_FW: Scalars['Decimal'];
  A_ROB_GESO: Scalars['Decimal'];
  A_ROB_MECO: Scalars['Decimal'];
  A_ROB_MESO: Scalars['Decimal'];
  A_ROB_MGO: Scalars['Decimal'];
  A_ROB_at_Arrival_FO: Scalars['Decimal'];
  A_ROB_at_Arrival_FW: Scalars['Decimal'];
  A_ROB_at_Arrival_GESO: Scalars['Decimal'];
  A_ROB_at_Arrival_MECO: Scalars['Decimal'];
  A_ROB_at_Arrival_MESO: Scalars['Decimal'];
  A_ROB_at_Arrival_MGO: Scalars['Decimal'];
  A_Remark?: InputMaybe<Scalars['String']>;
  A_SB_or_Stop: Scalars['DateTime'];
  A_Spare_1?: InputMaybe<Scalars['String']>;
  A_Spare_1_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_2?: InputMaybe<Scalars['String']>;
  A_Spare_2_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_3?: InputMaybe<Scalars['String']>;
  A_Spare_3_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_4?: InputMaybe<Scalars['String']>;
  A_Spare_4_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_5?: InputMaybe<Scalars['String']>;
  A_Spare_5_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_6?: InputMaybe<Scalars['String']>;
  A_Spare_6_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_7?: InputMaybe<Scalars['String']>;
  A_Spare_7_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_8?: InputMaybe<Scalars['String']>;
  A_Spare_8_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_9?: InputMaybe<Scalars['String']>;
  A_Spare_9_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_10?: InputMaybe<Scalars['String']>;
  A_Spare_10_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_11?: InputMaybe<Scalars['String']>;
  A_Spare_11_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_12?: InputMaybe<Scalars['String']>;
  A_Spare_12_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_13?: InputMaybe<Scalars['String']>;
  A_Spare_13_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_14?: InputMaybe<Scalars['String']>;
  A_Spare_14_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_15?: InputMaybe<Scalars['String']>;
  A_Spare_15_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_16?: InputMaybe<Scalars['String']>;
  A_Spare_16_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_17?: InputMaybe<Scalars['String']>;
  A_Spare_17_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_18?: InputMaybe<Scalars['String']>;
  A_Spare_18_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_19?: InputMaybe<Scalars['String']>;
  A_Spare_19_unit_name?: InputMaybe<Scalars['String']>;
  A_Spare_20?: InputMaybe<Scalars['String']>;
  A_Spare_20_unit_name?: InputMaybe<Scalars['String']>;
  A_Time_Zone: Scalars['String'];
  A_UNLOC?: InputMaybe<Scalars['String']>;
  A_Vessel_Name: Scalars['String'];
  A_Voy: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  ship_id: Scalars['Int'];
};

export type Bunkering = {
  __typename?: 'Bunkering';
  B_Bunkering_Date_time: Scalars['DateTime'];
  B_Density_1?: Maybe<Scalars['Decimal']>;
  B_Density_2?: Maybe<Scalars['Decimal']>;
  B_Density_3?: Maybe<Scalars['Decimal']>;
  B_Density_4?: Maybe<Scalars['Decimal']>;
  B_Density_5?: Maybe<Scalars['Decimal']>;
  B_Density_6?: Maybe<Scalars['Decimal']>;
  B_Density_7?: Maybe<Scalars['Decimal']>;
  B_Density_8?: Maybe<Scalars['Decimal']>;
  B_Density_9?: Maybe<Scalars['Decimal']>;
  B_Density_10?: Maybe<Scalars['Decimal']>;
  B_EUorUK?: Maybe<EUorUk>;
  B_Filename?: Maybe<Scalars['String']>;
  B_Fuel_name_1?: Maybe<FuelType>;
  B_Fuel_name_2?: Maybe<FuelType>;
  B_Fuel_name_3?: Maybe<FuelType>;
  B_Fuel_name_4?: Maybe<FuelType>;
  B_Fuel_name_5?: Maybe<FuelType>;
  B_Fuel_name_6?: Maybe<FuelType>;
  B_Fuel_name_7?: Maybe<FuelType>;
  B_Fuel_name_8?: Maybe<FuelType>;
  B_Fuel_name_9?: Maybe<FuelType>;
  B_Fuel_name_10?: Maybe<FuelType>;
  B_LatLong: Scalars['String'];
  B_Mass_1?: Maybe<Scalars['Decimal']>;
  B_Mass_2?: Maybe<Scalars['Decimal']>;
  B_Mass_3?: Maybe<Scalars['Decimal']>;
  B_Mass_4?: Maybe<Scalars['Decimal']>;
  B_Mass_5?: Maybe<Scalars['Decimal']>;
  B_Mass_6?: Maybe<Scalars['Decimal']>;
  B_Mass_7?: Maybe<Scalars['Decimal']>;
  B_Mass_8?: Maybe<Scalars['Decimal']>;
  B_Mass_9?: Maybe<Scalars['Decimal']>;
  B_Mass_10?: Maybe<Scalars['Decimal']>;
  B_PortName: Scalars['String'];
  B_Port_LorU: LorU;
  B_Timezone: Scalars['String'];
  B_UNLOC: Scalars['String'];
  B_Vessel_Name: Scalars['String'];
  B_Volume_1?: Maybe<Scalars['Decimal']>;
  B_Volume_2?: Maybe<Scalars['Decimal']>;
  B_Volume_3?: Maybe<Scalars['Decimal']>;
  B_Volume_4?: Maybe<Scalars['Decimal']>;
  B_Volume_5?: Maybe<Scalars['Decimal']>;
  B_Volume_6?: Maybe<Scalars['Decimal']>;
  B_Volume_7?: Maybe<Scalars['Decimal']>;
  B_Volume_8?: Maybe<Scalars['Decimal']>;
  B_Volume_9?: Maybe<Scalars['Decimal']>;
  B_Volume_10?: Maybe<Scalars['Decimal']>;
  B_Voy: Scalars['String'];
  id: Scalars['Int'];
  ship: Ship;
  ship_id: Scalars['Int'];
  user: User;
  user_id: Scalars['Int'];
};

export type BunkeringInput = {
  B_Bunkering_Date_time: Scalars['DateTime'];
  B_Density_1?: InputMaybe<Scalars['Decimal']>;
  B_Density_2?: InputMaybe<Scalars['Decimal']>;
  B_Density_3?: InputMaybe<Scalars['Decimal']>;
  B_Density_4?: InputMaybe<Scalars['Decimal']>;
  B_Density_5?: InputMaybe<Scalars['Decimal']>;
  B_Density_6?: InputMaybe<Scalars['Decimal']>;
  B_Density_7?: InputMaybe<Scalars['Decimal']>;
  B_Density_8?: InputMaybe<Scalars['Decimal']>;
  B_Density_9?: InputMaybe<Scalars['Decimal']>;
  B_Density_10?: InputMaybe<Scalars['Decimal']>;
  B_EUorUK?: InputMaybe<EUorUk>;
  B_Filename?: InputMaybe<Scalars['String']>;
  B_Fuel_name_1?: InputMaybe<FuelType>;
  B_Fuel_name_2?: InputMaybe<FuelType>;
  B_Fuel_name_3?: InputMaybe<FuelType>;
  B_Fuel_name_4?: InputMaybe<FuelType>;
  B_Fuel_name_5?: InputMaybe<FuelType>;
  B_Fuel_name_6?: InputMaybe<FuelType>;
  B_Fuel_name_7?: InputMaybe<FuelType>;
  B_Fuel_name_8?: InputMaybe<FuelType>;
  B_Fuel_name_9?: InputMaybe<FuelType>;
  B_Fuel_name_10?: InputMaybe<FuelType>;
  B_LatLong: Scalars['String'];
  B_Mass_1?: InputMaybe<Scalars['Decimal']>;
  B_Mass_2?: InputMaybe<Scalars['Decimal']>;
  B_Mass_3?: InputMaybe<Scalars['Decimal']>;
  B_Mass_4?: InputMaybe<Scalars['Decimal']>;
  B_Mass_5?: InputMaybe<Scalars['Decimal']>;
  B_Mass_6?: InputMaybe<Scalars['Decimal']>;
  B_Mass_7?: InputMaybe<Scalars['Decimal']>;
  B_Mass_8?: InputMaybe<Scalars['Decimal']>;
  B_Mass_9?: InputMaybe<Scalars['Decimal']>;
  B_Mass_10?: InputMaybe<Scalars['Decimal']>;
  B_PortName: Scalars['String'];
  B_Port_LorU: LorU;
  B_Timezone: Scalars['String'];
  B_UNLOC: Scalars['String'];
  B_Vessel_Name: Scalars['String'];
  B_Volume_1?: InputMaybe<Scalars['Decimal']>;
  B_Volume_2?: InputMaybe<Scalars['Decimal']>;
  B_Volume_3?: InputMaybe<Scalars['Decimal']>;
  B_Volume_4?: InputMaybe<Scalars['Decimal']>;
  B_Volume_5?: InputMaybe<Scalars['Decimal']>;
  B_Volume_6?: InputMaybe<Scalars['Decimal']>;
  B_Volume_7?: InputMaybe<Scalars['Decimal']>;
  B_Volume_8?: InputMaybe<Scalars['Decimal']>;
  B_Volume_9?: InputMaybe<Scalars['Decimal']>;
  B_Volume_10?: InputMaybe<Scalars['Decimal']>;
  B_Voy: Scalars['String'];
  id: Scalars['Int'];
  ship_id: Scalars['Int'];
};

export type Cargo = {
  __typename?: 'Cargo';
  C_Cargo_Port: Scalars['String'];
  C_DateTime: Scalars['DateTime'];
  C_Displacement?: Maybe<Scalars['Decimal']>;
  C_EU_UK_port: EUorUk;
  C_Filename?: Maybe<Scalars['String']>;
  C_Latitude: Scalars['String'];
  C_Loading_Lane_metres?: Maybe<Scalars['Decimal']>;
  C_Loading_Mass?: Maybe<Scalars['Decimal']>;
  C_Loading_Number_of_Passengers?: Maybe<Scalars['Int']>;
  C_Loading_TEU_Empty?: Maybe<Scalars['Int']>;
  C_Loading_TEU_Full?: Maybe<Scalars['Int']>;
  C_Loading_Unit?: Maybe<Scalars['Int']>;
  C_Loading_Volume?: Maybe<Scalars['Decimal']>;
  C_Longitude: Scalars['String'];
  C_Port_L_U: LorU;
  C_Timezone: Scalars['String'];
  C_Total_Lane_metres?: Maybe<Scalars['Decimal']>;
  C_Total_Mass?: Maybe<Scalars['Decimal']>;
  C_Total_Number_of_Passengers?: Maybe<Scalars['Int']>;
  C_Total_ROB?: Maybe<Scalars['Decimal']>;
  C_Total_TEU_Empty?: Maybe<Scalars['Int']>;
  C_Total_TEU_Full?: Maybe<Scalars['Int']>;
  C_Total_Unit?: Maybe<Scalars['Int']>;
  C_Total_Volume?: Maybe<Scalars['Decimal']>;
  C_UNLOC: Scalars['String'];
  C_Unloading_Lane_metres?: Maybe<Scalars['Decimal']>;
  C_Unloading_Mass?: Maybe<Scalars['Decimal']>;
  C_Unloading_Number_of_Passengers?: Maybe<Scalars['Int']>;
  C_Unloading_TEU_Empty?: Maybe<Scalars['Int']>;
  C_Unloading_TEU_Full?: Maybe<Scalars['Int']>;
  C_Unloading_Unit?: Maybe<Scalars['Int']>;
  C_Unloading_Volume?: Maybe<Scalars['Decimal']>;
  C_Voyage_No: Scalars['String'];
  C_Water_density?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  imo_no: Scalars['String'];
};

export enum CargoFormRequired {
  NotRequired = 'NOT_REQUIRED',
  Optional = 'OPTIONAL',
  Required = 'REQUIRED'
}

export type CargoFormSetting = {
  __typename?: 'CargoFormSetting';
  C_Lane_metres: CargoFormRequired;
  C_Mass: CargoFormRequired;
  C_Number_of_Passengers: CargoFormRequired;
  C_TEU_Empty: CargoFormRequired;
  C_TEU_Full: CargoFormRequired;
  C_Unit: CargoFormRequired;
  C_Volume: CargoFormRequired;
  type_of_ship_cii: TypeOfShipCii;
};

export type CargoInput = {
  C_Cargo_Port: Scalars['String'];
  C_DateTime: Scalars['DateTime'];
  C_Displacement?: InputMaybe<Scalars['Decimal']>;
  C_EU_UK_port: EUorUk;
  C_Filename?: InputMaybe<Scalars['String']>;
  C_Latitude: Scalars['String'];
  C_Loading_Lane_metres?: InputMaybe<Scalars['Decimal']>;
  C_Loading_Mass?: InputMaybe<Scalars['Decimal']>;
  C_Loading_Number_of_Passengers?: InputMaybe<Scalars['Int']>;
  C_Loading_TEU_Empty?: InputMaybe<Scalars['Int']>;
  C_Loading_TEU_Full?: InputMaybe<Scalars['Int']>;
  C_Loading_Unit?: InputMaybe<Scalars['Int']>;
  C_Loading_Volume?: InputMaybe<Scalars['Decimal']>;
  C_Longitude: Scalars['String'];
  C_Port_L_U: LorU;
  C_Timezone: Scalars['String'];
  C_Total_Lane_metres?: InputMaybe<Scalars['Decimal']>;
  C_Total_Mass?: InputMaybe<Scalars['Decimal']>;
  C_Total_Number_of_Passengers?: InputMaybe<Scalars['Int']>;
  C_Total_ROB?: InputMaybe<Scalars['Decimal']>;
  C_Total_TEU_Empty?: InputMaybe<Scalars['Int']>;
  C_Total_TEU_Full?: InputMaybe<Scalars['Int']>;
  C_Total_Unit?: InputMaybe<Scalars['Int']>;
  C_Total_Volume?: InputMaybe<Scalars['Decimal']>;
  C_UNLOC: Scalars['String'];
  C_Unloading_Lane_metres?: InputMaybe<Scalars['Decimal']>;
  C_Unloading_Mass?: InputMaybe<Scalars['Decimal']>;
  C_Unloading_Number_of_Passengers?: InputMaybe<Scalars['Int']>;
  C_Unloading_TEU_Empty?: InputMaybe<Scalars['Int']>;
  C_Unloading_TEU_Full?: InputMaybe<Scalars['Int']>;
  C_Unloading_Unit?: InputMaybe<Scalars['Int']>;
  C_Unloading_Volume?: InputMaybe<Scalars['Decimal']>;
  C_Voyage_No: Scalars['String'];
  C_Water_density?: InputMaybe<Scalars['Decimal']>;
  id: Scalars['Int'];
};

export type CheckDuplicateNoonReportInput = {
  N_DateTime: Scalars['DateTime'];
  N_Voy: Scalars['String'];
  ship_id: Scalars['Int'];
};

export type CheckDuplicateNoonReportListInput = {
  CheckDuplicateNoonReportListInput?: InputMaybe<Array<InputMaybe<CheckDuplicateNoonReportInput>>>;
};

export type CheckDuplicateNoonReportListResponse = {
  __typename?: 'CheckDuplicateNoonReportListResponse';
  duplicatedNoonReports?: Maybe<Array<Maybe<CheckDuplicateNoonReportResponse>>>;
};

export type CheckDuplicateNoonReportResponse = {
  __typename?: 'CheckDuplicateNoonReportResponse';
  N_DateTime: Scalars['DateTime'];
  N_Voy: Scalars['String'];
  ship_id: Scalars['Int'];
};

export type CreateArrivalListInput = {
  ArrivalListInput?: InputMaybe<Array<InputMaybe<ArrivalInput>>>;
  email?: InputMaybe<Scalars['String']>;
};

export type CreateArrivalListResponse = {
  __typename?: 'CreateArrivalListResponse';
  CreateArrivalListStatus: QueryStatus;
  createdArrivalCount: Scalars['Int'];
};

export type CreateBunkeringListInput = {
  BunkeringInput?: InputMaybe<Array<InputMaybe<BunkeringInput>>>;
  IMO_No?: InputMaybe<Scalars['String']>;
};

export type CreateBunkeringListResponse = {
  __typename?: 'CreateBunkeringListResponse';
  CreateBunkeringListStatus: QueryStatus;
  createdBunkeringCount: Scalars['Int'];
  uploadFilePaths: Array<Maybe<UploadFilePaths>>;
};

export type CreateCargoListInput = {
  CargoListInput?: InputMaybe<Array<InputMaybe<CargoInput>>>;
  IMO_No?: InputMaybe<Scalars['String']>;
};

export type CreateCargoListResponse = {
  __typename?: 'CreateCargoListResponse';
  CreateCargoListStatus: QueryStatus;
  createdCargoCount: Scalars['Int'];
  uploadFilePaths: Array<Maybe<UploadFilePaths>>;
};

export type CreateDepartureListInput = {
  DepartureListInput?: InputMaybe<Array<InputMaybe<DepartureInput>>>;
  email?: InputMaybe<Scalars['String']>;
};

export type CreateDepartureListResponse = {
  __typename?: 'CreateDepartureListResponse';
  CreateDepartureListStatus: QueryStatus;
  createdDepartureCount: Scalars['Int'];
};

export type CreateErrorDataInput = {
  ErrorData?: InputMaybe<Scalars['String']>;
  ErrorDataType?: InputMaybe<Scalars['String']>;
};

export type CreateFrontendShipDataInput = {
  FrontendShipData?: InputMaybe<Scalars['String']>;
  IMONO: Scalars['String'];
};

export type CreateReferenceDataInput = {
  ReferenceDataListInput?: InputMaybe<Array<InputMaybe<ReferenceDataInput>>>;
};

export type CreateReferenceDataResponse = {
  __typename?: 'CreateReferenceDataResponse';
  count?: Maybe<Scalars['Int']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type CreateReportListInput = {
  ReportListInput?: InputMaybe<Array<InputMaybe<ReportInput>>>;
  email?: InputMaybe<Scalars['String']>;
};

export type CreateReportListResponse = {
  __typename?: 'CreateReportListResponse';
  CreateReportListStatus: QueryStatus;
  createdReportCount: Scalars['Int'];
  uploadFilePaths: Array<Maybe<UploadFilePaths>>;
};

export type Departure = {
  __typename?: 'Departure';
  D_Additional_ROB?: Maybe<Array<Maybe<AdditionalRobForDeparture>>>;
  D_Cargo_Name: Scalars['String'];
  D_Cargo_Qtty: Scalars['Decimal'];
  D_Departure_Date_Time: Scalars['DateTime'];
  D_Departure_Port: Scalars['String'];
  D_Draft_Aft: Scalars['Decimal'];
  D_Draft_Fore: Scalars['Decimal'];
  D_ETA: Scalars['DateTime'];
  D_ETB: Scalars['DateTime'];
  D_ETC: Scalars['DateTime'];
  D_ETD: Scalars['DateTime'];
  D_EU_UK_port?: Maybe<EUorUk>;
  D_Last_Voy: Scalars['String'];
  D_LorB: LorB;
  D_Next_Port_Name: Scalars['String'];
  D_Port_L_U?: Maybe<LorU>;
  D_ROB_FO: Scalars['Decimal'];
  D_ROB_FW: Scalars['Decimal'];
  D_ROB_GESO: Scalars['Decimal'];
  D_ROB_MECO: Scalars['Decimal'];
  D_ROB_MESO: Scalars['Decimal'];
  D_ROB_MGO: Scalars['Decimal'];
  D_RU_Date_Time: Scalars['DateTime'];
  D_Remark?: Maybe<Scalars['String']>;
  D_Spare_1?: Maybe<Scalars['String']>;
  D_Spare_1_unit_name?: Maybe<Scalars['String']>;
  D_Spare_2?: Maybe<Scalars['String']>;
  D_Spare_2_unit_name?: Maybe<Scalars['String']>;
  D_Spare_3?: Maybe<Scalars['String']>;
  D_Spare_3_unit_name?: Maybe<Scalars['String']>;
  D_Spare_4?: Maybe<Scalars['String']>;
  D_Spare_4_unit_name?: Maybe<Scalars['String']>;
  D_Spare_5?: Maybe<Scalars['String']>;
  D_Spare_5_unit_name?: Maybe<Scalars['String']>;
  D_Spare_6?: Maybe<Scalars['String']>;
  D_Spare_6_unit_name?: Maybe<Scalars['String']>;
  D_Spare_7?: Maybe<Scalars['String']>;
  D_Spare_7_unit_name?: Maybe<Scalars['String']>;
  D_Spare_8?: Maybe<Scalars['String']>;
  D_Spare_8_unit_name?: Maybe<Scalars['String']>;
  D_Spare_9?: Maybe<Scalars['String']>;
  D_Spare_9_unit_name?: Maybe<Scalars['String']>;
  D_Spare_10?: Maybe<Scalars['String']>;
  D_Spare_10_unit_name?: Maybe<Scalars['String']>;
  D_Spare_11?: Maybe<Scalars['String']>;
  D_Spare_11_unit_name?: Maybe<Scalars['String']>;
  D_Spare_12?: Maybe<Scalars['String']>;
  D_Spare_12_unit_name?: Maybe<Scalars['String']>;
  D_Spare_13?: Maybe<Scalars['String']>;
  D_Spare_13_unit_name?: Maybe<Scalars['String']>;
  D_Spare_14?: Maybe<Scalars['String']>;
  D_Spare_14_unit_name?: Maybe<Scalars['String']>;
  D_Spare_15?: Maybe<Scalars['String']>;
  D_Spare_15_unit_name?: Maybe<Scalars['String']>;
  D_Spare_16?: Maybe<Scalars['String']>;
  D_Spare_16_unit_name?: Maybe<Scalars['String']>;
  D_Spare_17?: Maybe<Scalars['String']>;
  D_Spare_17_unit_name?: Maybe<Scalars['String']>;
  D_Spare_18?: Maybe<Scalars['String']>;
  D_Spare_18_unit_name?: Maybe<Scalars['String']>;
  D_Spare_19?: Maybe<Scalars['String']>;
  D_Spare_19_unit_name?: Maybe<Scalars['String']>;
  D_Spare_20?: Maybe<Scalars['String']>;
  D_Spare_20_unit_name?: Maybe<Scalars['String']>;
  D_Time_Zone: Scalars['String'];
  D_UNLOC?: Maybe<Scalars['String']>;
  D_Vessel_Name: Scalars['String'];
  D_Voy: Scalars['String'];
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  ship: Ship;
  ship_id: Scalars['Int'];
  updated_at: Scalars['DateTime'];
  user: User;
  user_id: Scalars['Int'];
};

export type DepartureInput = {
  D_Additional_ROB?: InputMaybe<Array<InputMaybe<AdditionalRobForDepartureInput>>>;
  D_Cargo_Name: Scalars['String'];
  D_Cargo_Qtty: Scalars['Decimal'];
  D_Departure_Date_Time: Scalars['DateTime'];
  D_Departure_Port: Scalars['String'];
  D_Draft_Aft: Scalars['Decimal'];
  D_Draft_Fore: Scalars['Decimal'];
  D_ETA: Scalars['DateTime'];
  D_ETB: Scalars['DateTime'];
  D_ETC: Scalars['DateTime'];
  D_ETD: Scalars['DateTime'];
  D_EU_UK_port?: InputMaybe<EUorUk>;
  D_Last_Voy: Scalars['String'];
  D_LorB: LorB;
  D_Next_Port_Name: Scalars['String'];
  D_Port_L_U?: InputMaybe<LorU>;
  D_ROB_FO: Scalars['Decimal'];
  D_ROB_FW: Scalars['Decimal'];
  D_ROB_GESO: Scalars['Decimal'];
  D_ROB_MECO: Scalars['Decimal'];
  D_ROB_MESO: Scalars['Decimal'];
  D_ROB_MGO: Scalars['Decimal'];
  D_RU_Date_Time: Scalars['DateTime'];
  D_Remark?: InputMaybe<Scalars['String']>;
  D_Spare_1?: InputMaybe<Scalars['String']>;
  D_Spare_1_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_2?: InputMaybe<Scalars['String']>;
  D_Spare_2_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_3?: InputMaybe<Scalars['String']>;
  D_Spare_3_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_4?: InputMaybe<Scalars['String']>;
  D_Spare_4_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_5?: InputMaybe<Scalars['String']>;
  D_Spare_5_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_6?: InputMaybe<Scalars['String']>;
  D_Spare_6_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_7?: InputMaybe<Scalars['String']>;
  D_Spare_7_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_8?: InputMaybe<Scalars['String']>;
  D_Spare_8_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_9?: InputMaybe<Scalars['String']>;
  D_Spare_9_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_10?: InputMaybe<Scalars['String']>;
  D_Spare_10_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_11?: InputMaybe<Scalars['String']>;
  D_Spare_11_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_12?: InputMaybe<Scalars['String']>;
  D_Spare_12_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_13?: InputMaybe<Scalars['String']>;
  D_Spare_13_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_14?: InputMaybe<Scalars['String']>;
  D_Spare_14_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_15?: InputMaybe<Scalars['String']>;
  D_Spare_15_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_16?: InputMaybe<Scalars['String']>;
  D_Spare_16_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_17?: InputMaybe<Scalars['String']>;
  D_Spare_17_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_18?: InputMaybe<Scalars['String']>;
  D_Spare_18_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_19?: InputMaybe<Scalars['String']>;
  D_Spare_19_unit_name?: InputMaybe<Scalars['String']>;
  D_Spare_20?: InputMaybe<Scalars['String']>;
  D_Spare_20_unit_name?: InputMaybe<Scalars['String']>;
  D_Time_Zone: Scalars['String'];
  D_UNLOC?: InputMaybe<Scalars['String']>;
  D_Vessel_Name: Scalars['String'];
  D_Voy: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  ship_id: Scalars['Int'];
};

export type DownloadBunkeringFileResponse = {
  __typename?: 'DownloadBunkeringFileResponse';
  bunkeringFileId: Scalars['Int'];
  url: Scalars['String'];
};

export type DownloadCargoFileResponse = {
  __typename?: 'DownloadCargoFileResponse';
  cargoFileId: Scalars['Int'];
  url: Scalars['String'];
};

export type DownloadRobFileResponse = {
  __typename?: 'DownloadRobFileResponse';
  robFileId: Scalars['Int'];
  url: Scalars['String'];
};

export enum EUorUk {
  Eu = 'EU',
  Uk = 'UK'
}

export enum FoFuelType {
  Hsfo = 'HSFO',
  Uvlsfo = 'UVLSFO',
  Vlsfo = 'VLSFO'
}

export enum FuelType {
  EeOh = 'EeOH',
  Hsfo = 'HSFO',
  Lfo = 'LFO',
  Lng = 'LNG',
  Lpgb = 'LPGB',
  Lpgp = 'LPGP',
  Lsmdo = 'LSMDO',
  Lsmgo = 'LSMGO',
  Mdo = 'MDO',
  Mgo = 'MGO',
  MeOh = 'MeOH',
  Other = 'Other',
  Uvlsfo = 'UVLSFO',
  Vlsfo = 'VLSFO'
}

export enum LorB {
  Ballast = 'Ballast',
  Laden = 'Laden'
}

export enum LorU {
  N = 'N',
  S = 'S',
  Y = 'Y'
}

export enum MePowerMeasurementMethod {
  FuelIndex = 'FUEL_INDEX',
  PressureMeasurementInstrument = 'PRESSURE_MEASUREMENT_INSTRUMENT',
  ShaftPowerMeter = 'SHAFT_POWER_METER'
}

export enum MgoFuelType {
  Lsmgo = 'LSMGO',
  Mgo = 'MGO'
}

export type Mutation = {
  __typename?: 'Mutation';
  createArrivalList?: Maybe<CreateArrivalListResponse>;
  createBunkeringList?: Maybe<CreateBunkeringListResponse>;
  createCargoList?: Maybe<CreateCargoListResponse>;
  createDepartureList?: Maybe<CreateDepartureListResponse>;
  createErrorData: Scalars['Boolean'];
  createFrontendShipData: Scalars['Boolean'];
  createReferenceData?: Maybe<CreateReferenceDataResponse>;
  createReportList: CreateReportListResponse;
  deleteAnalysisSearchParameter: Scalars['Boolean'];
  sendReportToMrv?: Maybe<SendReportToMrvResponse>;
  updateAnalysisSearchParameterTitle?: Maybe<AnalysisSearchParameter>;
  updateArrival?: Maybe<UpdateArrivalResponse>;
  updateBunkering?: Maybe<UpdateBunkeringResponse>;
  updateCargo?: Maybe<UpdateCargoResponse>;
  updateDeparture?: Maybe<UpdateDepartureResponse>;
  updateReport: UpdateReportResponse;
  upsertAnalysisSearchParameter: Scalars['Boolean'];
};


export type MutationCreateArrivalListArgs = {
  input?: InputMaybe<CreateArrivalListInput>;
};


export type MutationCreateBunkeringListArgs = {
  input?: InputMaybe<CreateBunkeringListInput>;
};


export type MutationCreateCargoListArgs = {
  input?: InputMaybe<CreateCargoListInput>;
};


export type MutationCreateDepartureListArgs = {
  input?: InputMaybe<CreateDepartureListInput>;
};


export type MutationCreateErrorDataArgs = {
  input?: InputMaybe<CreateErrorDataInput>;
};


export type MutationCreateFrontendShipDataArgs = {
  input?: InputMaybe<CreateFrontendShipDataInput>;
};


export type MutationCreateReferenceDataArgs = {
  input?: InputMaybe<CreateReferenceDataInput>;
};


export type MutationCreateReportListArgs = {
  input: CreateReportListInput;
};


export type MutationDeleteAnalysisSearchParameterArgs = {
  delete_id: Scalars['Int'];
};


export type MutationSendReportToMrvArgs = {
  input?: InputMaybe<SendReportToMrvInput>;
};


export type MutationUpdateAnalysisSearchParameterTitleArgs = {
  input?: InputMaybe<AnalysisSearchParameterInput>;
};


export type MutationUpdateArrivalArgs = {
  input?: InputMaybe<ArrivalInput>;
};


export type MutationUpdateBunkeringArgs = {
  input?: InputMaybe<BunkeringInput>;
};


export type MutationUpdateCargoArgs = {
  input?: InputMaybe<CargoInput>;
};


export type MutationUpdateDepartureArgs = {
  input?: InputMaybe<DepartureInput>;
};


export type MutationUpdateReportArgs = {
  input: ReportInput;
};


export type MutationUpsertAnalysisSearchParameterArgs = {
  input?: InputMaybe<AnalysisSearchParameterInput>;
};

export enum NonExistentImoNo {
  NonExistentImoNo = 'NON_EXISTENT_IMO_NO'
}

export type Organization = {
  __typename?: 'Organization';
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organizationShipsMapping: Array<OrganizationShipsMapping>;
  updated_at: Scalars['DateTime'];
  user: Array<User>;
};

export type OrganizationShipsMapping = {
  __typename?: 'OrganizationShipsMapping';
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  imo_no: Scalars['String'];
  organization: Organization;
  organization_id: Scalars['Int'];
  ship: Ship;
  updated_at: Scalars['DateTime'];
};

export enum OtherFuelType {
  EeOh = 'EeOH',
  Lfo = 'LFO',
  Lng = 'LNG',
  Lpgb = 'LPGB',
  Lpgp = 'LPGP',
  Lsmdo = 'LSMDO',
  Mdo = 'MDO',
  MeOh = 'MeOH',
  Other = 'Other'
}

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  arrivalList?: Maybe<ArrivalListResponse>;
  bunkeringList?: Maybe<BunkeringListResponse>;
  cargoList?: Maybe<CargoListResponse>;
  checkDuplicateNoonReportList: CheckDuplicateNoonReportListResponse;
  checkOnline: Scalars['Boolean'];
  departureList?: Maybe<DepartureListResponse>;
  downloadBunkeringFile: DownloadBunkeringFileResponse;
  downloadCargoFile: DownloadCargoFileResponse;
  downloadRobFile: DownloadRobFileResponse;
  getAnalysisSearchParameter: Array<Maybe<AnalysisSearchParameter>>;
  getArrival?: Maybe<Arrival>;
  getBunkering?: Maybe<Bunkering>;
  getCargoFormSettingInfo?: Maybe<Ship>;
  getDeparture?: Maybe<Departure>;
  getOwnerArrival?: Maybe<Arrival>;
  getOwnerBunkering?: Maybe<Bunkering>;
  getOwnerDeparture?: Maybe<Departure>;
  getOwnerReport?: Maybe<Report>;
  getReport?: Maybe<Report>;
  organization?: Maybe<Organization>;
  referenceDataList?: Maybe<Array<Maybe<ReferenceData>>>;
  reportList?: Maybe<ReportListResponse>;
  shipList?: Maybe<Array<Maybe<Ship>>>;
};


export type QueryArrivalListArgs = {
  input?: InputMaybe<ArrivalListInput>;
};


export type QueryBunkeringListArgs = {
  input?: InputMaybe<BunkeringListInput>;
};


export type QueryCargoListArgs = {
  input?: InputMaybe<CargoListInput>;
};


export type QueryCheckDuplicateNoonReportListArgs = {
  input: CheckDuplicateNoonReportListInput;
};


export type QueryDepartureListArgs = {
  input?: InputMaybe<DepartureListInput>;
};


export type QueryDownloadBunkeringFileArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadCargoFileArgs = {
  id: Scalars['Int'];
};


export type QueryDownloadRobFileArgs = {
  id: Scalars['Int'];
};


export type QueryGetAnalysisSearchParameterArgs = {
  renderString: Scalars['String'];
};


export type QueryGetArrivalArgs = {
  input?: InputMaybe<GetArrivalInput>;
};


export type QueryGetBunkeringArgs = {
  input?: InputMaybe<GetBunkeringInput>;
};


export type QueryGetCargoFormSettingInfoArgs = {
  input?: InputMaybe<GetCargoFormSettingInfoInput>;
};


export type QueryGetDepartureArgs = {
  input?: InputMaybe<GetDepartureInput>;
};


export type QueryGetOwnerArrivalArgs = {
  input?: InputMaybe<GetOwnerArrivalInput>;
};


export type QueryGetOwnerBunkeringArgs = {
  input?: InputMaybe<GetOwnerBunkeringInput>;
};


export type QueryGetOwnerDepartureArgs = {
  input?: InputMaybe<GetOwnerDepartureInput>;
};


export type QueryGetOwnerReportArgs = {
  input?: InputMaybe<GetOwnerReportInput>;
};


export type QueryGetReportArgs = {
  input?: InputMaybe<GetReportInput>;
};


export type QueryReferenceDataListArgs = {
  input?: InputMaybe<ReferenceDataListInput>;
};


export type QueryReportListArgs = {
  input?: InputMaybe<ReportListInput>;
};


export type QueryShipListArgs = {
  filter?: InputMaybe<ShipListFiler>;
};

export enum QueryStatus {
  Auth0Error = 'AUTH0_ERROR',
  DuplicateError = 'DUPLICATE_ERROR',
  FailGetUploadUrl = 'FAIL_GET_UPLOAD_URL',
  IncorrectInput = 'INCORRECT_INPUT',
  ServerError = 'SERVER_ERROR',
  Success = 'SUCCESS'
}

export type ReferenceData = {
  __typename?: 'ReferenceData';
  Speed_OG: Scalars['Decimal'];
  created_at: Scalars['DateTime'];
  dataType: ReferenceDataType;
  fuel_consumption_Ballast?: Maybe<Scalars['Decimal']>;
  fuel_consumption_Laden?: Maybe<Scalars['Decimal']>;
  fuel_consumption_Unique?: Maybe<Scalars['Decimal']>;
  id: Scalars['Int'];
  ship: Ship;
  ship_id: Scalars['Int'];
  updated_at: Scalars['DateTime'];
};

export type ReferenceDataInput = {
  IMO_No: Scalars['String'];
  Speed_OG: Scalars['Decimal'];
  dataType: ReferenceDataType;
  fuel_consumption_Ballast?: InputMaybe<Scalars['Decimal']>;
  fuel_consumption_Laden?: InputMaybe<Scalars['Decimal']>;
  fuel_consumption_Unique?: InputMaybe<Scalars['Decimal']>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export enum ReferenceDataType {
  Foc = 'Foc',
  Speed = 'Speed'
}

export type Report = {
  __typename?: 'Report';
  N_Additional_ROB?: Maybe<Array<Maybe<AdditionalRob>>>;
  N_BF_scale?: Maybe<Scalars['Decimal']>;
  N_DateTime: Scalars['DateTime'];
  N_Dist_OG: Scalars['Decimal'];
  N_Dist_to_go?: Maybe<Scalars['Decimal']>;
  N_ETA?: Maybe<Scalars['DateTime']>;
  N_ETB?: Maybe<Scalars['DateTime']>;
  N_ETD?: Maybe<Scalars['DateTime']>;
  N_EU_UK_port?: Maybe<EUorUk>;
  N_FO_Additional_FuelType_1?: Maybe<FoFuelType>;
  N_FO_Additional_FuelType_2?: Maybe<FoFuelType>;
  N_FO_Additional_FuelType_3?: Maybe<FoFuelType>;
  N_FO_Additional_FuelType_4?: Maybe<FoFuelType>;
  N_FO_Additional_FuelType_5?: Maybe<FoFuelType>;
  N_FO_Additional_Usage_1?: Maybe<Scalars['String']>;
  N_FO_Additional_Usage_2?: Maybe<Scalars['String']>;
  N_FO_Additional_Usage_3?: Maybe<Scalars['String']>;
  N_FO_Additional_Usage_4?: Maybe<Scalars['String']>;
  N_FO_Additional_Usage_5?: Maybe<Scalars['String']>;
  N_FO_Additional_volume_1?: Maybe<Scalars['Decimal']>;
  N_FO_Additional_volume_2?: Maybe<Scalars['Decimal']>;
  N_FO_Additional_volume_3?: Maybe<Scalars['Decimal']>;
  N_FO_Additional_volume_4?: Maybe<Scalars['Decimal']>;
  N_FO_Additional_volume_5?: Maybe<Scalars['Decimal']>;
  N_FO_CO2_emission: Scalars['Decimal'];
  N_FO_CO2_emission_per_unit: Scalars['Decimal'];
  N_FO_Consumption_per_day_BInc: Scalars['Decimal'];
  N_FO_Consumption_per_day_GE: Scalars['Decimal'];
  N_FO_Consumption_per_day_ME: Scalars['Decimal'];
  N_Hrs_propelling: Scalars['Decimal'];
  N_LO_Consumption_per_day_GESO: Scalars['Decimal'];
  N_LO_Consumption_per_day_MECO: Scalars['Decimal'];
  N_LO_Consumption_per_day_MESO: Scalars['Decimal'];
  N_LatLong: Scalars['String'];
  N_LorB: LorB;
  N_ME_Fuel_index?: Maybe<Scalars['Decimal']>;
  N_ME_RPM?: Maybe<Scalars['Decimal']>;
  N_ME_Revolution: Scalars['Decimal'];
  N_ME_horsepower?: Maybe<Scalars['Decimal']>;
  N_ME_power?: Maybe<Scalars['Decimal']>;
  N_ME_power_measurement_method?: Maybe<MePowerMeasurementMethod>;
  N_ME_rpm_ave: Scalars['Decimal'];
  N_ME_rpm_total?: Maybe<Scalars['Decimal']>;
  N_MGO_Additional_FuelType_1?: Maybe<MgoFuelType>;
  N_MGO_Additional_FuelType_2?: Maybe<MgoFuelType>;
  N_MGO_Additional_FuelType_3?: Maybe<MgoFuelType>;
  N_MGO_Additional_FuelType_4?: Maybe<MgoFuelType>;
  N_MGO_Additional_FuelType_5?: Maybe<MgoFuelType>;
  N_MGO_Additional_Usage_1?: Maybe<Scalars['String']>;
  N_MGO_Additional_Usage_2?: Maybe<Scalars['String']>;
  N_MGO_Additional_Usage_3?: Maybe<Scalars['String']>;
  N_MGO_Additional_Usage_4?: Maybe<Scalars['String']>;
  N_MGO_Additional_Usage_5?: Maybe<Scalars['String']>;
  N_MGO_Additional_volume_1?: Maybe<Scalars['Decimal']>;
  N_MGO_Additional_volume_2?: Maybe<Scalars['Decimal']>;
  N_MGO_Additional_volume_3?: Maybe<Scalars['Decimal']>;
  N_MGO_Additional_volume_4?: Maybe<Scalars['Decimal']>;
  N_MGO_Additional_volume_5?: Maybe<Scalars['Decimal']>;
  N_MGO_CO2_emission: Scalars['Decimal'];
  N_MGO_CO2_emission_per_unit: Scalars['Decimal'];
  N_MGO_Consumption_per_day_Boiler: Scalars['Decimal'];
  N_MGO_Consumption_per_day_GE: Scalars['Decimal'];
  N_MGO_Consumption_per_day_ME: Scalars['Decimal'];
  N_Next_port?: Maybe<Scalars['String']>;
  N_Noon_Course?: Maybe<Scalars['Decimal']>;
  N_Noon_Port?: Maybe<Scalars['String']>;
  N_Other_Additional_FuelType_1?: Maybe<OtherFuelType>;
  N_Other_Additional_FuelType_2?: Maybe<OtherFuelType>;
  N_Other_Additional_FuelType_3?: Maybe<OtherFuelType>;
  N_Other_Additional_FuelType_4?: Maybe<OtherFuelType>;
  N_Other_Additional_FuelType_5?: Maybe<OtherFuelType>;
  N_Other_Additional_Usage_1?: Maybe<Scalars['String']>;
  N_Other_Additional_Usage_2?: Maybe<Scalars['String']>;
  N_Other_Additional_Usage_3?: Maybe<Scalars['String']>;
  N_Other_Additional_Usage_4?: Maybe<Scalars['String']>;
  N_Other_Additional_Usage_5?: Maybe<Scalars['String']>;
  N_Other_Additional_volume_1?: Maybe<Scalars['Decimal']>;
  N_Other_Additional_volume_2?: Maybe<Scalars['Decimal']>;
  N_Other_Additional_volume_3?: Maybe<Scalars['Decimal']>;
  N_Other_Additional_volume_4?: Maybe<Scalars['Decimal']>;
  N_Other_Additional_volume_5?: Maybe<Scalars['Decimal']>;
  N_Port_L_U?: Maybe<LorU>;
  N_ROB_FO: Scalars['Decimal'];
  N_ROB_FW: Scalars['Decimal'];
  N_ROB_Filename?: Maybe<Scalars['String']>;
  N_ROB_GESO: Scalars['Decimal'];
  N_ROB_MECO: Scalars['Decimal'];
  N_ROB_MESO: Scalars['Decimal'];
  N_ROB_MGO: Scalars['Decimal'];
  N_Remark?: Maybe<Scalars['String']>;
  N_Running_hours_GE_SCR: Scalars['Decimal'];
  N_Running_hours_ME_EGR?: Maybe<Scalars['Decimal']>;
  N_Running_hours_SOx_scrubber?: Maybe<Scalars['Decimal']>;
  N_Slip: Scalars['Decimal'];
  N_Spare_1?: Maybe<Scalars['String']>;
  N_Spare_1_unit_name?: Maybe<Scalars['String']>;
  N_Spare_2?: Maybe<Scalars['String']>;
  N_Spare_2_unit_name?: Maybe<Scalars['String']>;
  N_Spare_3?: Maybe<Scalars['String']>;
  N_Spare_3_unit_name?: Maybe<Scalars['String']>;
  N_Spare_4?: Maybe<Scalars['String']>;
  N_Spare_4_unit_name?: Maybe<Scalars['String']>;
  N_Spare_5?: Maybe<Scalars['String']>;
  N_Spare_5_unit_name?: Maybe<Scalars['String']>;
  N_Spare_6?: Maybe<Scalars['String']>;
  N_Spare_6_unit_name?: Maybe<Scalars['String']>;
  N_Spare_7?: Maybe<Scalars['String']>;
  N_Spare_7_unit_name?: Maybe<Scalars['String']>;
  N_Spare_8?: Maybe<Scalars['String']>;
  N_Spare_8_unit_name?: Maybe<Scalars['String']>;
  N_Spare_9?: Maybe<Scalars['String']>;
  N_Spare_9_unit_name?: Maybe<Scalars['String']>;
  N_Spare_10?: Maybe<Scalars['String']>;
  N_Spare_10_unit_name?: Maybe<Scalars['String']>;
  N_Spare_11?: Maybe<Scalars['String']>;
  N_Spare_11_unit_name?: Maybe<Scalars['String']>;
  N_Spare_12?: Maybe<Scalars['String']>;
  N_Spare_12_unit_name?: Maybe<Scalars['String']>;
  N_Spare_13?: Maybe<Scalars['String']>;
  N_Spare_13_unit_name?: Maybe<Scalars['String']>;
  N_Spare_14?: Maybe<Scalars['String']>;
  N_Spare_14_unit_name?: Maybe<Scalars['String']>;
  N_Spare_15?: Maybe<Scalars['String']>;
  N_Spare_15_unit_name?: Maybe<Scalars['String']>;
  N_Spare_16?: Maybe<Scalars['String']>;
  N_Spare_16_unit_name?: Maybe<Scalars['String']>;
  N_Spare_17?: Maybe<Scalars['String']>;
  N_Spare_17_unit_name?: Maybe<Scalars['String']>;
  N_Spare_18?: Maybe<Scalars['String']>;
  N_Spare_18_unit_name?: Maybe<Scalars['String']>;
  N_Spare_19?: Maybe<Scalars['String']>;
  N_Spare_19_unit_name?: Maybe<Scalars['String']>;
  N_Spare_20?: Maybe<Scalars['String']>;
  N_Spare_20_unit_name?: Maybe<Scalars['String']>;
  N_Speed_OG: Scalars['Decimal'];
  N_Speed_OW: Scalars['Decimal'];
  N_Steam_mode: Scalars['String'];
  N_Swell?: Maybe<Scalars['Decimal']>;
  N_TimeZone: Scalars['String'];
  N_UNLOC?: Maybe<Scalars['String']>;
  N_Vessel_name: Scalars['String'];
  N_Voy: Scalars['String'];
  N_Weather?: Maybe<Scalars['String']>;
  N_Wind_direction?: Maybe<Scalars['Decimal']>;
  created_at: Scalars['DateTime'];
  id: Scalars['Int'];
  ship?: Maybe<Ship>;
  ship_id: Scalars['Int'];
  updated_at: Scalars['DateTime'];
  user: User;
  user_id: Scalars['Int'];
};

export type ReportInput = {
  N_Additional_ROB?: InputMaybe<Array<InputMaybe<AdditionalRobInput>>>;
  N_BF_scale?: InputMaybe<Scalars['Decimal']>;
  N_DateTime: Scalars['DateTime'];
  N_Dist_OG: Scalars['Decimal'];
  N_Dist_to_go?: InputMaybe<Scalars['Decimal']>;
  N_ETA?: InputMaybe<Scalars['DateTime']>;
  N_ETB?: InputMaybe<Scalars['DateTime']>;
  N_ETD?: InputMaybe<Scalars['DateTime']>;
  N_EU_UK_port?: InputMaybe<EUorUk>;
  N_FO_Additional_FuelType_1?: InputMaybe<FoFuelType>;
  N_FO_Additional_FuelType_2?: InputMaybe<FoFuelType>;
  N_FO_Additional_FuelType_3?: InputMaybe<FoFuelType>;
  N_FO_Additional_FuelType_4?: InputMaybe<FoFuelType>;
  N_FO_Additional_FuelType_5?: InputMaybe<FoFuelType>;
  N_FO_Additional_Usage_1?: InputMaybe<Scalars['String']>;
  N_FO_Additional_Usage_2?: InputMaybe<Scalars['String']>;
  N_FO_Additional_Usage_3?: InputMaybe<Scalars['String']>;
  N_FO_Additional_Usage_4?: InputMaybe<Scalars['String']>;
  N_FO_Additional_Usage_5?: InputMaybe<Scalars['String']>;
  N_FO_Additional_volume_1?: InputMaybe<Scalars['Decimal']>;
  N_FO_Additional_volume_2?: InputMaybe<Scalars['Decimal']>;
  N_FO_Additional_volume_3?: InputMaybe<Scalars['Decimal']>;
  N_FO_Additional_volume_4?: InputMaybe<Scalars['Decimal']>;
  N_FO_Additional_volume_5?: InputMaybe<Scalars['Decimal']>;
  N_FO_CO2_emission: Scalars['Decimal'];
  N_FO_CO2_emission_per_unit: Scalars['Decimal'];
  N_FO_Consumption_per_day_BInc: Scalars['Decimal'];
  N_FO_Consumption_per_day_GE: Scalars['Decimal'];
  N_FO_Consumption_per_day_ME: Scalars['Decimal'];
  N_Hrs_propelling: Scalars['Decimal'];
  N_LO_Consumption_per_day_GESO: Scalars['Decimal'];
  N_LO_Consumption_per_day_MECO: Scalars['Decimal'];
  N_LO_Consumption_per_day_MESO: Scalars['Decimal'];
  N_LatLong: Scalars['String'];
  N_LorB: LorB;
  N_ME_Fuel_index?: InputMaybe<Scalars['Decimal']>;
  N_ME_RPM?: InputMaybe<Scalars['Decimal']>;
  N_ME_Revolution: Scalars['Decimal'];
  N_ME_horsepower?: InputMaybe<Scalars['Decimal']>;
  N_ME_power?: InputMaybe<Scalars['Decimal']>;
  N_ME_power_measurement_method?: InputMaybe<MePowerMeasurementMethod>;
  N_ME_rpm_ave: Scalars['Decimal'];
  N_ME_rpm_total?: InputMaybe<Scalars['Decimal']>;
  N_MGO_Additional_FuelType_1?: InputMaybe<MgoFuelType>;
  N_MGO_Additional_FuelType_2?: InputMaybe<MgoFuelType>;
  N_MGO_Additional_FuelType_3?: InputMaybe<MgoFuelType>;
  N_MGO_Additional_FuelType_4?: InputMaybe<MgoFuelType>;
  N_MGO_Additional_FuelType_5?: InputMaybe<MgoFuelType>;
  N_MGO_Additional_Usage_1?: InputMaybe<Scalars['String']>;
  N_MGO_Additional_Usage_2?: InputMaybe<Scalars['String']>;
  N_MGO_Additional_Usage_3?: InputMaybe<Scalars['String']>;
  N_MGO_Additional_Usage_4?: InputMaybe<Scalars['String']>;
  N_MGO_Additional_Usage_5?: InputMaybe<Scalars['String']>;
  N_MGO_Additional_volume_1?: InputMaybe<Scalars['Decimal']>;
  N_MGO_Additional_volume_2?: InputMaybe<Scalars['Decimal']>;
  N_MGO_Additional_volume_3?: InputMaybe<Scalars['Decimal']>;
  N_MGO_Additional_volume_4?: InputMaybe<Scalars['Decimal']>;
  N_MGO_Additional_volume_5?: InputMaybe<Scalars['Decimal']>;
  N_MGO_CO2_emission: Scalars['Decimal'];
  N_MGO_CO2_emission_per_unit: Scalars['Decimal'];
  N_MGO_Consumption_per_day_Boiler: Scalars['Decimal'];
  N_MGO_Consumption_per_day_GE: Scalars['Decimal'];
  N_MGO_Consumption_per_day_ME: Scalars['Decimal'];
  N_Next_port?: InputMaybe<Scalars['String']>;
  N_Noon_Course?: InputMaybe<Scalars['Decimal']>;
  N_Noon_Port?: InputMaybe<Scalars['String']>;
  N_Other_Additional_FuelType_1?: InputMaybe<OtherFuelType>;
  N_Other_Additional_FuelType_2?: InputMaybe<OtherFuelType>;
  N_Other_Additional_FuelType_3?: InputMaybe<OtherFuelType>;
  N_Other_Additional_FuelType_4?: InputMaybe<OtherFuelType>;
  N_Other_Additional_FuelType_5?: InputMaybe<OtherFuelType>;
  N_Other_Additional_Usage_1?: InputMaybe<Scalars['String']>;
  N_Other_Additional_Usage_2?: InputMaybe<Scalars['String']>;
  N_Other_Additional_Usage_3?: InputMaybe<Scalars['String']>;
  N_Other_Additional_Usage_4?: InputMaybe<Scalars['String']>;
  N_Other_Additional_Usage_5?: InputMaybe<Scalars['String']>;
  N_Other_Additional_volume_1?: InputMaybe<Scalars['Decimal']>;
  N_Other_Additional_volume_2?: InputMaybe<Scalars['Decimal']>;
  N_Other_Additional_volume_3?: InputMaybe<Scalars['Decimal']>;
  N_Other_Additional_volume_4?: InputMaybe<Scalars['Decimal']>;
  N_Other_Additional_volume_5?: InputMaybe<Scalars['Decimal']>;
  N_Port_L_U?: InputMaybe<LorU>;
  N_ROB_FO: Scalars['Decimal'];
  N_ROB_FW: Scalars['Decimal'];
  N_ROB_Filename?: InputMaybe<Scalars['String']>;
  N_ROB_GESO: Scalars['Decimal'];
  N_ROB_MECO: Scalars['Decimal'];
  N_ROB_MESO: Scalars['Decimal'];
  N_ROB_MGO: Scalars['Decimal'];
  N_Remark?: InputMaybe<Scalars['String']>;
  N_Running_hours_GE_SCR: Scalars['Decimal'];
  N_Running_hours_ME_EGR?: InputMaybe<Scalars['Decimal']>;
  N_Running_hours_SOx_scrubber?: InputMaybe<Scalars['Decimal']>;
  N_Slip: Scalars['Decimal'];
  N_Spare_1?: InputMaybe<Scalars['String']>;
  N_Spare_1_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_2?: InputMaybe<Scalars['String']>;
  N_Spare_2_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_3?: InputMaybe<Scalars['String']>;
  N_Spare_3_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_4?: InputMaybe<Scalars['String']>;
  N_Spare_4_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_5?: InputMaybe<Scalars['String']>;
  N_Spare_5_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_6?: InputMaybe<Scalars['String']>;
  N_Spare_6_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_7?: InputMaybe<Scalars['String']>;
  N_Spare_7_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_8?: InputMaybe<Scalars['String']>;
  N_Spare_8_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_9?: InputMaybe<Scalars['String']>;
  N_Spare_9_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_10?: InputMaybe<Scalars['String']>;
  N_Spare_10_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_11?: InputMaybe<Scalars['String']>;
  N_Spare_11_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_12?: InputMaybe<Scalars['String']>;
  N_Spare_12_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_13?: InputMaybe<Scalars['String']>;
  N_Spare_13_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_14?: InputMaybe<Scalars['String']>;
  N_Spare_14_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_15?: InputMaybe<Scalars['String']>;
  N_Spare_15_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_16?: InputMaybe<Scalars['String']>;
  N_Spare_16_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_17?: InputMaybe<Scalars['String']>;
  N_Spare_17_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_18?: InputMaybe<Scalars['String']>;
  N_Spare_18_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_19?: InputMaybe<Scalars['String']>;
  N_Spare_19_unit_name?: InputMaybe<Scalars['String']>;
  N_Spare_20?: InputMaybe<Scalars['String']>;
  N_Spare_20_unit_name?: InputMaybe<Scalars['String']>;
  N_Speed_OG: Scalars['Decimal'];
  N_Speed_OW: Scalars['Decimal'];
  N_Steam_mode: Scalars['String'];
  N_Swell?: InputMaybe<Scalars['Decimal']>;
  N_TimeZone: Scalars['String'];
  N_UNLOC?: InputMaybe<Scalars['String']>;
  N_Vessel_name: Scalars['String'];
  N_Voy: Scalars['String'];
  N_Weather?: InputMaybe<Scalars['String']>;
  N_Wind_direction?: InputMaybe<Scalars['Decimal']>;
  id?: InputMaybe<Scalars['Int']>;
  ship_id: Scalars['Int'];
};

export type SendReportToMrvInput = {
  reportId: Scalars['Int'];
};

export type SendReportToMrvResponse = {
  __typename?: 'SendReportToMrvResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Ship = {
  __typename?: 'Ship';
  IMO_No: Scalars['String'];
  arrival: Array<Arrival>;
  cargoFormSetting?: Maybe<CargoFormSetting>;
  created_at: Scalars['DateTime'];
  departure: Array<Departure>;
  fo_fuel_type: FoFuelType;
  id: Scalars['Int'];
  is_mrv_portal_integration_target: Scalars['Boolean'];
  name: Scalars['String'];
  organizationShipsMapping: Array<OrganizationShipsMapping>;
  propeller_pitch: Scalars['Int'];
  report: Array<Report>;
  shipMaster?: Maybe<ShipMaster>;
  summer_deadweight: Scalars['Int'];
  type_of_ship_cii?: Maybe<TypeOfShipCii>;
  updated_at: Scalars['DateTime'];
};

export type ShipMaster = {
  __typename?: 'ShipMaster';
  IMONo: Scalars['String'];
  created_at: Scalars['DateTime'];
  lastUpdated: Scalars['DateTime'];
  updated_at: Scalars['DateTime'];
};

export enum SteamMode {
  Full = 'Full',
  Slow = 'Slow',
  Stop = 'Stop'
}

export enum TypeOfShipCii {
  BulkCarrier = 'bulk_carrier',
  CombinationCarrier = 'combination_carrier',
  ContainerShip = 'container_ship',
  CruisePassengerShip = 'cruise_passenger_ship',
  GasCarrier = 'gas_carrier',
  GeneralCargoShip = 'general_cargo_ship',
  LngCarrier = 'lng_carrier',
  RefrigeratedCargoCarrier = 'refrigerated_cargo_carrier',
  RoRoCargoShip = 'ro_ro_cargo_ship',
  RoRoCargoShipVc = 'ro_ro_cargo_ship_vc',
  RoRoPassengerShip = 'ro_ro_passenger_ship',
  Tanker = 'tanker'
}

export type UpdateArrivalResponse = {
  __typename?: 'UpdateArrivalResponse';
  Arrival?: Maybe<Arrival>;
};

export type UpdateBunkeringResponse = {
  __typename?: 'UpdateBunkeringResponse';
  Bunkering?: Maybe<Bunkering>;
  gcsFilePath: Scalars['String'];
  isFileUpload: Scalars['Boolean'];
};

export type UpdateCargoResponse = {
  __typename?: 'UpdateCargoResponse';
  Cargo?: Maybe<Cargo>;
  gcsFilePath: Scalars['String'];
  isFileUpload: Scalars['Boolean'];
};

export type UpdateDepartureResponse = {
  __typename?: 'UpdateDepartureResponse';
  Departure?: Maybe<Departure>;
};

export type UpdateReportResponse = {
  __typename?: 'UpdateReportResponse';
  Report?: Maybe<Report>;
  UpdateReportStatus: QueryStatus;
  gcsFilePath: Scalars['String'];
  isFileUpload: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  arrival: Array<Arrival>;
  created_at: Scalars['DateTime'];
  departure: Array<Departure>;
  email: Scalars['String'];
  id: Scalars['Int'];
  name: Scalars['String'];
  organization: Organization;
  organization_id: Scalars['Int'];
  report: Array<Report>;
  updated_at: Scalars['DateTime'];
};

export enum UserAuthCodes {
  Admin = 'ADMIN',
  Crew = 'CREW',
  Owner = 'OWNER'
}

export type ArrivalListInput = {
  A_Voy?: InputMaybe<Scalars['String']>;
  From_DateTime?: InputMaybe<Scalars['DateTime']>;
  IMO_No?: InputMaybe<Scalars['String']>;
  To_DateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Pagination>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type ArrivalListResponse = {
  __typename?: 'arrivalListResponse';
  arrivalList?: Maybe<Array<Maybe<Arrival>>>;
  totalPageCount?: Maybe<Scalars['Int']>;
};

export type BunkeringListInput = {
  B_Voy?: InputMaybe<Scalars['String']>;
  From_DateTime?: InputMaybe<Scalars['DateTime']>;
  IMO_No?: InputMaybe<Scalars['String']>;
  To_DateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Pagination>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type BunkeringListResponse = {
  __typename?: 'bunkeringListResponse';
  bunkeringList?: Maybe<Array<Maybe<Bunkering>>>;
  totalPageCount?: Maybe<Scalars['Int']>;
};

export type CargoListInput = {
  C_Voyage_No?: InputMaybe<Scalars['String']>;
  From_DateTime?: InputMaybe<Scalars['DateTime']>;
  IMO_No?: InputMaybe<Scalars['String']>;
  To_DateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Pagination>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type CargoListResponse = {
  __typename?: 'cargoListResponse';
  cargoList?: Maybe<Array<Maybe<Cargo>>>;
  totalPageCount?: Maybe<Scalars['Int']>;
};

export type DepartureListInput = {
  D_Voy?: InputMaybe<Scalars['String']>;
  From_DateTime?: InputMaybe<Scalars['DateTime']>;
  IMO_No?: InputMaybe<Scalars['String']>;
  To_DateTime?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Pagination>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type DepartureListResponse = {
  __typename?: 'departureListResponse';
  departureList?: Maybe<Array<Maybe<Departure>>>;
  totalPageCount?: Maybe<Scalars['Int']>;
};

export type GetArrivalInput = {
  id?: InputMaybe<Scalars['Int']>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type GetBunkeringInput = {
  id?: InputMaybe<Scalars['Int']>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type GetCargoFormSettingInfoInput = {
  IMO_No?: InputMaybe<Scalars['String']>;
};

export type GetDepartureInput = {
  id?: InputMaybe<Scalars['Int']>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type GetOwnerArrivalInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type GetOwnerBunkeringInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type GetOwnerDepartureInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type GetOwnerReportInput = {
  id?: InputMaybe<Scalars['Int']>;
};

export type GetReportInput = {
  id?: InputMaybe<Scalars['Int']>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type ReferenceDataListInput = {
  IMO_No?: InputMaybe<Scalars['String']>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type ReportListInput = {
  From_BF_scale?: InputMaybe<Scalars['Int']>;
  From_DateTime?: InputMaybe<Scalars['DateTime']>;
  From_Hrs_propelling?: InputMaybe<Scalars['Int']>;
  From_ME_RPM?: InputMaybe<Scalars['Int']>;
  IMO_No?: InputMaybe<Scalars['String']>;
  N_LorB?: InputMaybe<LorB>;
  N_Steam_mode?: InputMaybe<SteamMode>;
  N_Voy?: InputMaybe<Scalars['String']>;
  To_BF_scale?: InputMaybe<Scalars['Int']>;
  To_DateTime?: InputMaybe<Scalars['DateTime']>;
  To_Hrs_propelling?: InputMaybe<Scalars['Int']>;
  To_ME_RPM?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Pagination>;
  ship_id?: InputMaybe<Scalars['Int']>;
};

export type ReportListResponse = {
  __typename?: 'reportListResponse';
  reportList?: Maybe<Array<Maybe<Report>>>;
  totalPageCount?: Maybe<Scalars['Int']>;
};

export type ShipListFiler = {
  imo_no?: InputMaybe<Scalars['String']>;
};

export type UploadFilePaths = {
  __typename?: 'uploadFilePaths';
  dbFilePath: Scalars['String'];
  gcsFilePath: Scalars['String'];
};

export type CreateReferenceDataMutationVariables = Exact<{
  input: CreateReferenceDataInput;
}>;


export type CreateReferenceDataMutation = { __typename?: 'Mutation', createReferenceData?: { __typename?: 'CreateReferenceDataResponse', count?: number | null, success?: boolean | null } | null };

export type ArrivalListQueryVariables = Exact<{
  input: ArrivalListInput;
}>;


export type ArrivalListQuery = { __typename?: 'Query', arrivalList?: { __typename?: 'arrivalListResponse', totalPageCount?: number | null, arrivalList?: Array<{ __typename?: 'Arrival', id: number, A_Vessel_Name: string, A_Voy: string, A_LorB: LorB, A_Arrival_Port: string, A_EU_UK_port?: EUorUk | null, A_Port_L_U?: LorU | null, A_UNLOC?: string | null, A_Arrival_Date_Time: Date, A_SB_or_Stop: Date, A_Time_Zone: string, A_ETB: Date, A_ETC: Date, A_ETD: Date, A_Berthed: Date, A_ROB_at_Arrival_FO: number, A_ROB_at_Arrival_MGO: number, A_ROB_at_Arrival_MECO: number, A_ROB_at_Arrival_MESO: number, A_ROB_at_Arrival_GESO: number, A_ROB_at_Arrival_FW: number, A_Hrs_since_Last_Noon: number, A_Distance_by_OG: number, A_FO_Consumption_per_day_ME: number, A_FO_Consumption_per_day_GE: number, A_FO_Consumption_per_day_B_and_Inc: number, A_MGO_Consumption_per_day_ME: number, A_MGO_Consumption_per_day_GE: number, A_MGO_Consumption_per_day_B_and_Inc: number, A_ROB_FO: number, A_ROB_MGO: number, A_ROB_MECO: number, A_ROB_MESO: number, A_ROB_GESO: number, A_ROB_FW: number, A_Draft_Fore: number, A_Draft_Aft: number, A_FO_CO2_emission: number, A_MGO_CO2_emission: number, A_Remark?: string | null, A_Spare_1?: string | null, A_Spare_1_unit_name?: string | null, A_Spare_2?: string | null, A_Spare_2_unit_name?: string | null, A_Spare_3?: string | null, A_Spare_3_unit_name?: string | null, A_Spare_4?: string | null, A_Spare_4_unit_name?: string | null, A_Spare_5?: string | null, A_Spare_5_unit_name?: string | null, A_Spare_6?: string | null, A_Spare_6_unit_name?: string | null, A_Spare_7?: string | null, A_Spare_7_unit_name?: string | null, A_Spare_8?: string | null, A_Spare_8_unit_name?: string | null, A_Spare_9?: string | null, A_Spare_9_unit_name?: string | null, A_Spare_10?: string | null, A_Spare_10_unit_name?: string | null, A_Spare_11?: string | null, A_Spare_11_unit_name?: string | null, A_Spare_12?: string | null, A_Spare_12_unit_name?: string | null, A_Spare_13?: string | null, A_Spare_13_unit_name?: string | null, A_Spare_14?: string | null, A_Spare_14_unit_name?: string | null, A_Spare_15?: string | null, A_Spare_15_unit_name?: string | null, A_Spare_16?: string | null, A_Spare_16_unit_name?: string | null, A_Spare_17?: string | null, A_Spare_17_unit_name?: string | null, A_Spare_18?: string | null, A_Spare_18_unit_name?: string | null, A_Spare_19?: string | null, A_Spare_19_unit_name?: string | null, A_Spare_20?: string | null, A_Spare_20_unit_name?: string | null, A_Additional_ROB?: Array<{ __typename?: 'AdditionalROBForArrival', id: number, A_Fuel_Type: FuelType, A_Fuel_volume: number } | null> | null } | null> | null } | null };

export type BunkeringListQueryVariables = Exact<{
  input: BunkeringListInput;
}>;


export type BunkeringListQuery = { __typename?: 'Query', bunkeringList?: { __typename?: 'bunkeringListResponse', totalPageCount?: number | null, bunkeringList?: Array<{ __typename?: 'Bunkering', id: number, B_Vessel_Name: string, B_Voy: string, B_Timezone: string, B_Bunkering_Date_time: Date, B_LatLong: string, B_PortName: string, B_UNLOC: string, B_EUorUK?: EUorUk | null, B_Port_LorU: LorU, B_Fuel_name_1?: FuelType | null, B_Mass_1?: number | null, B_Volume_1?: number | null, B_Density_1?: number | null, B_Fuel_name_2?: FuelType | null, B_Mass_2?: number | null, B_Volume_2?: number | null, B_Density_2?: number | null, B_Fuel_name_3?: FuelType | null, B_Mass_3?: number | null, B_Volume_3?: number | null, B_Density_3?: number | null, B_Fuel_name_4?: FuelType | null, B_Mass_4?: number | null, B_Volume_4?: number | null, B_Density_4?: number | null, B_Fuel_name_5?: FuelType | null, B_Mass_5?: number | null, B_Volume_5?: number | null, B_Density_5?: number | null, B_Fuel_name_6?: FuelType | null, B_Mass_6?: number | null, B_Volume_6?: number | null, B_Density_6?: number | null, B_Fuel_name_7?: FuelType | null, B_Mass_7?: number | null, B_Volume_7?: number | null, B_Density_7?: number | null, B_Fuel_name_8?: FuelType | null, B_Mass_8?: number | null, B_Volume_8?: number | null, B_Density_8?: number | null, B_Fuel_name_9?: FuelType | null, B_Mass_9?: number | null, B_Volume_9?: number | null, B_Density_9?: number | null, B_Fuel_name_10?: FuelType | null, B_Mass_10?: number | null, B_Volume_10?: number | null, B_Density_10?: number | null } | null> | null } | null };

export type CargoListQueryVariables = Exact<{
  input: CargoListInput;
}>;


export type CargoListQuery = { __typename?: 'Query', cargoList?: { __typename?: 'cargoListResponse', totalPageCount?: number | null, cargoList?: Array<{ __typename?: 'Cargo', id: number, imo_no: string, C_Timezone: string, C_DateTime: Date, C_Latitude: string, C_Longitude: string, C_Voyage_No: string, C_Cargo_Port: string, C_UNLOC: string, C_EU_UK_port: EUorUk, C_Port_L_U: LorU, C_Loading_Mass?: number | null, C_Loading_TEU_Full?: number | null, C_Loading_TEU_Empty?: number | null, C_Loading_Unit?: number | null, C_Loading_Lane_metres?: number | null, C_Loading_Number_of_Passengers?: number | null, C_Loading_Volume?: number | null, C_Unloading_Mass?: number | null, C_Unloading_TEU_Full?: number | null, C_Unloading_TEU_Empty?: number | null, C_Unloading_Unit?: number | null, C_Unloading_Lane_metres?: number | null, C_Unloading_Number_of_Passengers?: number | null, C_Unloading_Volume?: number | null, C_Total_Mass?: number | null, C_Total_TEU_Full?: number | null, C_Total_TEU_Empty?: number | null, C_Total_Unit?: number | null, C_Total_Lane_metres?: number | null, C_Total_Number_of_Passengers?: number | null, C_Total_Volume?: number | null, C_Displacement?: number | null, C_Water_density?: number | null, C_Total_ROB?: number | null, C_Filename?: string | null } | null> | null } | null };

export type CheckDuplicateNoonReportListQueryVariables = Exact<{
  input: CheckDuplicateNoonReportListInput;
}>;


export type CheckDuplicateNoonReportListQuery = { __typename?: 'Query', checkDuplicateNoonReportList: { __typename?: 'CheckDuplicateNoonReportListResponse', duplicatedNoonReports?: Array<{ __typename?: 'CheckDuplicateNoonReportResponse', ship_id: number, N_Voy: string, N_DateTime: Date } | null> | null } };

export type CheckOnlineQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckOnlineQuery = { __typename?: 'Query', checkOnline: boolean };

export type CreateArrivalListMutationVariables = Exact<{
  input: CreateArrivalListInput;
}>;


export type CreateArrivalListMutation = { __typename?: 'Mutation', createArrivalList?: { __typename?: 'CreateArrivalListResponse', CreateArrivalListStatus: QueryStatus, createdArrivalCount: number } | null };

export type CreateBunkeringListMutationVariables = Exact<{
  input: CreateBunkeringListInput;
}>;


export type CreateBunkeringListMutation = { __typename?: 'Mutation', createBunkeringList?: { __typename?: 'CreateBunkeringListResponse', createdBunkeringCount: number, CreateBunkeringListStatus: QueryStatus, uploadFilePaths: Array<{ __typename?: 'uploadFilePaths', dbFilePath: string, gcsFilePath: string } | null> } | null };

export type CreateCargoListMutationVariables = Exact<{
  input: CreateCargoListInput;
}>;


export type CreateCargoListMutation = { __typename?: 'Mutation', createCargoList?: { __typename?: 'CreateCargoListResponse', createdCargoCount: number, CreateCargoListStatus: QueryStatus, uploadFilePaths: Array<{ __typename?: 'uploadFilePaths', dbFilePath: string, gcsFilePath: string } | null> } | null };

export type CreateDepartureListMutationVariables = Exact<{
  input: CreateDepartureListInput;
}>;


export type CreateDepartureListMutation = { __typename?: 'Mutation', createDepartureList?: { __typename?: 'CreateDepartureListResponse', CreateDepartureListStatus: QueryStatus, createdDepartureCount: number } | null };

export type CreateErrorDataMutationVariables = Exact<{
  input: CreateErrorDataInput;
}>;


export type CreateErrorDataMutation = { __typename?: 'Mutation', createErrorData: boolean };

export type CreateFrontendShipDataMutationVariables = Exact<{
  input: CreateFrontendShipDataInput;
}>;


export type CreateFrontendShipDataMutation = { __typename?: 'Mutation', createFrontendShipData: boolean };

export type CreateReportListMutationVariables = Exact<{
  input: CreateReportListInput;
}>;


export type CreateReportListMutation = { __typename?: 'Mutation', createReportList: { __typename?: 'CreateReportListResponse', CreateReportListStatus: QueryStatus, createdReportCount: number, uploadFilePaths: Array<{ __typename?: 'uploadFilePaths', dbFilePath: string, gcsFilePath: string } | null> } };

export type DeleteAnalysisSearchParameterMutationVariables = Exact<{
  delete_id: Scalars['Int'];
}>;


export type DeleteAnalysisSearchParameterMutation = { __typename?: 'Mutation', deleteAnalysisSearchParameter: boolean };

export type DepartureListQueryVariables = Exact<{
  input: DepartureListInput;
}>;


export type DepartureListQuery = { __typename?: 'Query', departureList?: { __typename?: 'departureListResponse', totalPageCount?: number | null, departureList?: Array<{ __typename?: 'Departure', id: number, D_Vessel_Name: string, D_Voy: string, D_Last_Voy: string, D_LorB: LorB, D_Departure_Port: string, D_EU_UK_port?: EUorUk | null, D_Port_L_U?: LorU | null, D_UNLOC?: string | null, D_Departure_Date_Time: Date, D_RU_Date_Time: Date, D_Time_Zone: string, D_ROB_FO: number, D_ROB_MGO: number, D_ROB_MECO: number, D_ROB_MESO: number, D_ROB_GESO: number, D_ROB_FW: number, D_Cargo_Name: string, D_Cargo_Qtty: number, D_Draft_Fore: number, D_Draft_Aft: number, D_Next_Port_Name: string, D_ETA: Date, D_ETB: Date, D_ETC: Date, D_ETD: Date, D_Remark?: string | null, D_Spare_1?: string | null, D_Spare_1_unit_name?: string | null, D_Spare_2?: string | null, D_Spare_2_unit_name?: string | null, D_Spare_3?: string | null, D_Spare_3_unit_name?: string | null, D_Spare_4?: string | null, D_Spare_4_unit_name?: string | null, D_Spare_5?: string | null, D_Spare_5_unit_name?: string | null, D_Spare_6?: string | null, D_Spare_6_unit_name?: string | null, D_Spare_7?: string | null, D_Spare_7_unit_name?: string | null, D_Spare_8?: string | null, D_Spare_8_unit_name?: string | null, D_Spare_9?: string | null, D_Spare_9_unit_name?: string | null, D_Spare_10?: string | null, D_Spare_10_unit_name?: string | null, D_Spare_11?: string | null, D_Spare_11_unit_name?: string | null, D_Spare_12?: string | null, D_Spare_12_unit_name?: string | null, D_Spare_13?: string | null, D_Spare_13_unit_name?: string | null, D_Spare_14?: string | null, D_Spare_14_unit_name?: string | null, D_Spare_15?: string | null, D_Spare_15_unit_name?: string | null, D_Spare_16?: string | null, D_Spare_16_unit_name?: string | null, D_Spare_17?: string | null, D_Spare_17_unit_name?: string | null, D_Spare_18?: string | null, D_Spare_18_unit_name?: string | null, D_Spare_19?: string | null, D_Spare_19_unit_name?: string | null, D_Spare_20?: string | null, D_Spare_20_unit_name?: string | null, D_Additional_ROB?: Array<{ __typename?: 'AdditionalROBForDeparture', id: number, D_Fuel_Type: FuelType, D_Fuel_volume: number } | null> | null } | null> | null } | null };

export type DownloadBunkeringFileQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadBunkeringFileQuery = { __typename?: 'Query', downloadBunkeringFile: { __typename?: 'DownloadBunkeringFileResponse', bunkeringFileId: number, url: string } };

export type DownloadCargoFileQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadCargoFileQuery = { __typename?: 'Query', downloadCargoFile: { __typename?: 'DownloadCargoFileResponse', cargoFileId: number, url: string } };

export type DownloadRobFileQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DownloadRobFileQuery = { __typename?: 'Query', downloadRobFile: { __typename?: 'DownloadRobFileResponse', robFileId: number, url: string } };

export type GetAnalysisSearchParameterQueryVariables = Exact<{
  renderString: Scalars['String'];
}>;


export type GetAnalysisSearchParameterQuery = { __typename?: 'Query', getAnalysisSearchParameter: Array<{ __typename?: 'AnalysisSearchParameter', id: number, title: string, created_at: Date, AnalysisSearchParameterDetail?: Array<{ __typename?: 'AnalysisSearchParameterDetail', filter_type: AnalysisFilterType, imo_no: string, n_voy?: string | null, from_dateTime: Date, to_dateTime: Date, from_bf_scale?: number | null, to_bf_scale?: number | null, from_me_rpm?: number | null, to_me_rpm?: number | null, from_hrs_propelling?: number | null, to_hrs_propelling?: number | null, n_LorB?: LorB | null, n_steam_mode?: string | null } | null> | null } | null> };

export type GetArrivalQueryVariables = Exact<{
  input: GetArrivalInput;
}>;


export type GetArrivalQuery = { __typename?: 'Query', getArrival?: { __typename?: 'Arrival', id: number, ship_id: number, A_Vessel_Name: string, A_Voy: string, A_LorB: LorB, A_Arrival_Port: string, A_EU_UK_port?: EUorUk | null, A_Port_L_U?: LorU | null, A_UNLOC?: string | null, A_Arrival_Date_Time: Date, A_SB_or_Stop: Date, A_Time_Zone: string, A_ETB: Date, A_ETC: Date, A_ETD: Date, A_Berthed: Date, A_ROB_at_Arrival_FO: number, A_ROB_at_Arrival_MGO: number, A_ROB_at_Arrival_MECO: number, A_ROB_at_Arrival_MESO: number, A_ROB_at_Arrival_GESO: number, A_ROB_at_Arrival_FW: number, A_Hrs_since_Last_Noon: number, A_Distance_by_OG: number, A_FO_Consumption_per_day_ME: number, A_FO_Consumption_per_day_GE: number, A_FO_Consumption_per_day_B_and_Inc: number, A_MGO_Consumption_per_day_ME: number, A_MGO_Consumption_per_day_GE: number, A_MGO_Consumption_per_day_B_and_Inc: number, A_ROB_FO: number, A_ROB_MGO: number, A_ROB_MECO: number, A_ROB_MESO: number, A_ROB_GESO: number, A_ROB_FW: number, A_Draft_Fore: number, A_Draft_Aft: number, A_FO_CO2_emission: number, A_MGO_CO2_emission: number, A_Remark?: string | null, A_Spare_1?: string | null, A_Spare_1_unit_name?: string | null, A_Spare_2?: string | null, A_Spare_2_unit_name?: string | null, A_Spare_3?: string | null, A_Spare_3_unit_name?: string | null, A_Spare_4?: string | null, A_Spare_4_unit_name?: string | null, A_Spare_5?: string | null, A_Spare_5_unit_name?: string | null, A_Spare_6?: string | null, A_Spare_6_unit_name?: string | null, A_Spare_7?: string | null, A_Spare_7_unit_name?: string | null, A_Spare_8?: string | null, A_Spare_8_unit_name?: string | null, A_Spare_9?: string | null, A_Spare_9_unit_name?: string | null, A_Spare_10?: string | null, A_Spare_10_unit_name?: string | null, A_Spare_11?: string | null, A_Spare_11_unit_name?: string | null, A_Spare_12?: string | null, A_Spare_12_unit_name?: string | null, A_Spare_13?: string | null, A_Spare_13_unit_name?: string | null, A_Spare_14?: string | null, A_Spare_14_unit_name?: string | null, A_Spare_15?: string | null, A_Spare_15_unit_name?: string | null, A_Spare_16?: string | null, A_Spare_16_unit_name?: string | null, A_Spare_17?: string | null, A_Spare_17_unit_name?: string | null, A_Spare_18?: string | null, A_Spare_18_unit_name?: string | null, A_Spare_19?: string | null, A_Spare_19_unit_name?: string | null, A_Spare_20?: string | null, A_Spare_20_unit_name?: string | null, A_Additional_ROB?: Array<{ __typename?: 'AdditionalROBForArrival', id: number, A_Fuel_Type: FuelType, A_Fuel_volume: number } | null> | null } | null };

export type GetBunkeringQueryVariables = Exact<{
  input: GetBunkeringInput;
}>;


export type GetBunkeringQuery = { __typename?: 'Query', getBunkering?: { __typename?: 'Bunkering', id: number, ship_id: number, B_Vessel_Name: string, B_Voy: string, B_Timezone: string, B_Bunkering_Date_time: Date, B_LatLong: string, B_PortName: string, B_UNLOC: string, B_EUorUK?: EUorUk | null, B_Port_LorU: LorU, B_Fuel_name_1?: FuelType | null, B_Mass_1?: number | null, B_Volume_1?: number | null, B_Density_1?: number | null, B_Fuel_name_2?: FuelType | null, B_Mass_2?: number | null, B_Volume_2?: number | null, B_Density_2?: number | null, B_Fuel_name_3?: FuelType | null, B_Mass_3?: number | null, B_Volume_3?: number | null, B_Density_3?: number | null, B_Fuel_name_4?: FuelType | null, B_Mass_4?: number | null, B_Volume_4?: number | null, B_Density_4?: number | null, B_Fuel_name_5?: FuelType | null, B_Mass_5?: number | null, B_Volume_5?: number | null, B_Density_5?: number | null, B_Fuel_name_6?: FuelType | null, B_Mass_6?: number | null, B_Volume_6?: number | null, B_Density_6?: number | null, B_Fuel_name_7?: FuelType | null, B_Mass_7?: number | null, B_Volume_7?: number | null, B_Density_7?: number | null, B_Fuel_name_8?: FuelType | null, B_Mass_8?: number | null, B_Volume_8?: number | null, B_Density_8?: number | null, B_Fuel_name_9?: FuelType | null, B_Mass_9?: number | null, B_Volume_9?: number | null, B_Density_9?: number | null, B_Fuel_name_10?: FuelType | null, B_Mass_10?: number | null, B_Volume_10?: number | null, B_Density_10?: number | null, B_Filename?: string | null } | null };

export type GetCargoFormSettingInfoQueryVariables = Exact<{
  input: GetCargoFormSettingInfoInput;
}>;


export type GetCargoFormSettingInfoQuery = { __typename?: 'Query', getCargoFormSettingInfo?: { __typename?: 'Ship', type_of_ship_cii?: TypeOfShipCii | null, fo_fuel_type: FoFuelType, is_mrv_portal_integration_target: boolean, cargoFormSetting?: { __typename?: 'CargoFormSetting', type_of_ship_cii: TypeOfShipCii, C_Mass: CargoFormRequired, C_TEU_Full: CargoFormRequired, C_TEU_Empty: CargoFormRequired, C_Unit: CargoFormRequired, C_Lane_metres: CargoFormRequired, C_Number_of_Passengers: CargoFormRequired, C_Volume: CargoFormRequired } | null } | null };

export type GetDepartureQueryVariables = Exact<{
  input: GetDepartureInput;
}>;


export type GetDepartureQuery = { __typename?: 'Query', getDeparture?: { __typename?: 'Departure', id: number, ship_id: number, D_Vessel_Name: string, D_Voy: string, D_Last_Voy: string, D_LorB: LorB, D_Departure_Port: string, D_EU_UK_port?: EUorUk | null, D_Port_L_U?: LorU | null, D_UNLOC?: string | null, D_Departure_Date_Time: Date, D_RU_Date_Time: Date, D_Time_Zone: string, D_ROB_FO: number, D_ROB_MGO: number, D_ROB_MECO: number, D_ROB_MESO: number, D_ROB_GESO: number, D_ROB_FW: number, D_Cargo_Name: string, D_Cargo_Qtty: number, D_Draft_Fore: number, D_Draft_Aft: number, D_Next_Port_Name: string, D_ETA: Date, D_ETB: Date, D_ETC: Date, D_ETD: Date, D_Remark?: string | null, D_Spare_1?: string | null, D_Spare_1_unit_name?: string | null, D_Spare_2?: string | null, D_Spare_2_unit_name?: string | null, D_Spare_3?: string | null, D_Spare_3_unit_name?: string | null, D_Spare_4?: string | null, D_Spare_4_unit_name?: string | null, D_Spare_5?: string | null, D_Spare_5_unit_name?: string | null, D_Spare_6?: string | null, D_Spare_6_unit_name?: string | null, D_Spare_7?: string | null, D_Spare_7_unit_name?: string | null, D_Spare_8?: string | null, D_Spare_8_unit_name?: string | null, D_Spare_9?: string | null, D_Spare_9_unit_name?: string | null, D_Spare_10?: string | null, D_Spare_10_unit_name?: string | null, D_Spare_11?: string | null, D_Spare_11_unit_name?: string | null, D_Spare_12?: string | null, D_Spare_12_unit_name?: string | null, D_Spare_13?: string | null, D_Spare_13_unit_name?: string | null, D_Spare_14?: string | null, D_Spare_14_unit_name?: string | null, D_Spare_15?: string | null, D_Spare_15_unit_name?: string | null, D_Spare_16?: string | null, D_Spare_16_unit_name?: string | null, D_Spare_17?: string | null, D_Spare_17_unit_name?: string | null, D_Spare_18?: string | null, D_Spare_18_unit_name?: string | null, D_Spare_19?: string | null, D_Spare_19_unit_name?: string | null, D_Spare_20?: string | null, D_Spare_20_unit_name?: string | null, D_Additional_ROB?: Array<{ __typename?: 'AdditionalROBForDeparture', id: number, D_Fuel_Type: FuelType, D_Fuel_volume: number } | null> | null } | null };

export type GetOwnerArrivalQueryVariables = Exact<{
  input: GetOwnerArrivalInput;
}>;


export type GetOwnerArrivalQuery = { __typename?: 'Query', getOwnerArrival?: { __typename?: 'Arrival', id: number, ship_id: number, A_Vessel_Name: string, A_Voy: string, A_LorB: LorB, A_Arrival_Port: string, A_EU_UK_port?: EUorUk | null, A_Port_L_U?: LorU | null, A_UNLOC?: string | null, A_Arrival_Date_Time: Date, A_SB_or_Stop: Date, A_Time_Zone: string, A_ETB: Date, A_ETC: Date, A_ETD: Date, A_Berthed: Date, A_ROB_at_Arrival_FO: number, A_ROB_at_Arrival_MGO: number, A_ROB_at_Arrival_MECO: number, A_ROB_at_Arrival_MESO: number, A_ROB_at_Arrival_GESO: number, A_ROB_at_Arrival_FW: number, A_Hrs_since_Last_Noon: number, A_Distance_by_OG: number, A_FO_Consumption_per_day_ME: number, A_FO_Consumption_per_day_GE: number, A_FO_Consumption_per_day_B_and_Inc: number, A_MGO_Consumption_per_day_ME: number, A_MGO_Consumption_per_day_GE: number, A_MGO_Consumption_per_day_B_and_Inc: number, A_ROB_FO: number, A_ROB_MGO: number, A_ROB_MECO: number, A_ROB_MESO: number, A_ROB_GESO: number, A_ROB_FW: number, A_Draft_Fore: number, A_Draft_Aft: number, A_FO_CO2_emission: number, A_MGO_CO2_emission: number, A_Remark?: string | null, A_Spare_1?: string | null, A_Spare_1_unit_name?: string | null, A_Spare_2?: string | null, A_Spare_2_unit_name?: string | null, A_Spare_3?: string | null, A_Spare_3_unit_name?: string | null, A_Spare_4?: string | null, A_Spare_4_unit_name?: string | null, A_Spare_5?: string | null, A_Spare_5_unit_name?: string | null, A_Spare_6?: string | null, A_Spare_6_unit_name?: string | null, A_Spare_7?: string | null, A_Spare_7_unit_name?: string | null, A_Spare_8?: string | null, A_Spare_8_unit_name?: string | null, A_Spare_9?: string | null, A_Spare_9_unit_name?: string | null, A_Spare_10?: string | null, A_Spare_10_unit_name?: string | null, A_Spare_11?: string | null, A_Spare_11_unit_name?: string | null, A_Spare_12?: string | null, A_Spare_12_unit_name?: string | null, A_Spare_13?: string | null, A_Spare_13_unit_name?: string | null, A_Spare_14?: string | null, A_Spare_14_unit_name?: string | null, A_Spare_15?: string | null, A_Spare_15_unit_name?: string | null, A_Spare_16?: string | null, A_Spare_16_unit_name?: string | null, A_Spare_17?: string | null, A_Spare_17_unit_name?: string | null, A_Spare_18?: string | null, A_Spare_18_unit_name?: string | null, A_Spare_19?: string | null, A_Spare_19_unit_name?: string | null, A_Spare_20?: string | null, A_Spare_20_unit_name?: string | null, A_Additional_ROB?: Array<{ __typename?: 'AdditionalROBForArrival', id: number, A_Fuel_Type: FuelType, A_Fuel_volume: number } | null> | null } | null };

export type GetOwnerBunkeringQueryVariables = Exact<{
  input: GetOwnerBunkeringInput;
}>;


export type GetOwnerBunkeringQuery = { __typename?: 'Query', getOwnerBunkering?: { __typename?: 'Bunkering', id: number, ship_id: number, B_Vessel_Name: string, B_Voy: string, B_Timezone: string, B_Bunkering_Date_time: Date, B_LatLong: string, B_PortName: string, B_UNLOC: string, B_EUorUK?: EUorUk | null, B_Port_LorU: LorU, B_Fuel_name_1?: FuelType | null, B_Mass_1?: number | null, B_Volume_1?: number | null, B_Density_1?: number | null, B_Fuel_name_2?: FuelType | null, B_Mass_2?: number | null, B_Volume_2?: number | null, B_Density_2?: number | null, B_Fuel_name_3?: FuelType | null, B_Mass_3?: number | null, B_Volume_3?: number | null, B_Density_3?: number | null, B_Fuel_name_4?: FuelType | null, B_Mass_4?: number | null, B_Volume_4?: number | null, B_Density_4?: number | null, B_Fuel_name_5?: FuelType | null, B_Mass_5?: number | null, B_Volume_5?: number | null, B_Density_5?: number | null, B_Fuel_name_6?: FuelType | null, B_Mass_6?: number | null, B_Volume_6?: number | null, B_Density_6?: number | null, B_Fuel_name_7?: FuelType | null, B_Mass_7?: number | null, B_Volume_7?: number | null, B_Density_7?: number | null, B_Fuel_name_8?: FuelType | null, B_Mass_8?: number | null, B_Volume_8?: number | null, B_Density_8?: number | null, B_Fuel_name_9?: FuelType | null, B_Mass_9?: number | null, B_Volume_9?: number | null, B_Density_9?: number | null, B_Fuel_name_10?: FuelType | null, B_Mass_10?: number | null, B_Volume_10?: number | null, B_Density_10?: number | null, B_Filename?: string | null } | null };

export type GetOwnerDepartureQueryVariables = Exact<{
  input: GetOwnerDepartureInput;
}>;


export type GetOwnerDepartureQuery = { __typename?: 'Query', getOwnerDeparture?: { __typename?: 'Departure', id: number, ship_id: number, D_Vessel_Name: string, D_Voy: string, D_Last_Voy: string, D_LorB: LorB, D_Departure_Port: string, D_EU_UK_port?: EUorUk | null, D_Port_L_U?: LorU | null, D_UNLOC?: string | null, D_Departure_Date_Time: Date, D_RU_Date_Time: Date, D_Time_Zone: string, D_ROB_FO: number, D_ROB_MGO: number, D_ROB_MECO: number, D_ROB_MESO: number, D_ROB_GESO: number, D_ROB_FW: number, D_Cargo_Name: string, D_Cargo_Qtty: number, D_Draft_Fore: number, D_Draft_Aft: number, D_Next_Port_Name: string, D_ETA: Date, D_ETB: Date, D_ETC: Date, D_ETD: Date, D_Remark?: string | null, D_Spare_1?: string | null, D_Spare_1_unit_name?: string | null, D_Spare_2?: string | null, D_Spare_2_unit_name?: string | null, D_Spare_3?: string | null, D_Spare_3_unit_name?: string | null, D_Spare_4?: string | null, D_Spare_4_unit_name?: string | null, D_Spare_5?: string | null, D_Spare_5_unit_name?: string | null, D_Spare_6?: string | null, D_Spare_6_unit_name?: string | null, D_Spare_7?: string | null, D_Spare_7_unit_name?: string | null, D_Spare_8?: string | null, D_Spare_8_unit_name?: string | null, D_Spare_9?: string | null, D_Spare_9_unit_name?: string | null, D_Spare_10?: string | null, D_Spare_10_unit_name?: string | null, D_Spare_11?: string | null, D_Spare_11_unit_name?: string | null, D_Spare_12?: string | null, D_Spare_12_unit_name?: string | null, D_Spare_13?: string | null, D_Spare_13_unit_name?: string | null, D_Spare_14?: string | null, D_Spare_14_unit_name?: string | null, D_Spare_15?: string | null, D_Spare_15_unit_name?: string | null, D_Spare_16?: string | null, D_Spare_16_unit_name?: string | null, D_Spare_17?: string | null, D_Spare_17_unit_name?: string | null, D_Spare_18?: string | null, D_Spare_18_unit_name?: string | null, D_Spare_19?: string | null, D_Spare_19_unit_name?: string | null, D_Spare_20?: string | null, D_Spare_20_unit_name?: string | null, D_Additional_ROB?: Array<{ __typename?: 'AdditionalROBForDeparture', id: number, D_Fuel_Type: FuelType, D_Fuel_volume: number } | null> | null } | null };

export type GetOwnerReportQueryVariables = Exact<{
  input: GetOwnerReportInput;
}>;


export type GetOwnerReportQuery = { __typename?: 'Query', getOwnerReport?: { __typename?: 'Report', id: number, ship_id: number, N_Vessel_name: string, N_Voy: string, N_LorB: LorB, N_Noon_Port?: string | null, N_UNLOC?: string | null, N_EU_UK_port?: EUorUk | null, N_Port_L_U?: LorU | null, N_DateTime: Date, N_TimeZone: string, N_LatLong: string, N_Steam_mode: string, N_Hrs_propelling: number, N_Dist_OG: number, N_Speed_OG: number, N_Speed_OW: number, N_ME_rpm_ave: number, N_ME_rpm_total?: number | null, N_ME_Revolution: number, N_Slip: number, N_FO_Consumption_per_day_ME: number, N_FO_Consumption_per_day_GE: number, N_FO_Consumption_per_day_BInc: number, N_FO_Additional_FuelType_1?: FoFuelType | null, N_FO_Additional_Usage_1?: string | null, N_FO_Additional_volume_1?: number | null, N_FO_Additional_FuelType_2?: FoFuelType | null, N_FO_Additional_Usage_2?: string | null, N_FO_Additional_volume_2?: number | null, N_FO_Additional_FuelType_3?: FoFuelType | null, N_FO_Additional_Usage_3?: string | null, N_FO_Additional_volume_3?: number | null, N_FO_Additional_FuelType_4?: FoFuelType | null, N_FO_Additional_Usage_4?: string | null, N_FO_Additional_volume_4?: number | null, N_FO_Additional_FuelType_5?: FoFuelType | null, N_FO_Additional_Usage_5?: string | null, N_FO_Additional_volume_5?: number | null, N_MGO_Consumption_per_day_ME: number, N_MGO_Consumption_per_day_GE: number, N_MGO_Consumption_per_day_Boiler: number, N_MGO_Additional_FuelType_1?: MgoFuelType | null, N_MGO_Additional_Usage_1?: string | null, N_MGO_Additional_volume_1?: number | null, N_MGO_Additional_FuelType_2?: MgoFuelType | null, N_MGO_Additional_Usage_2?: string | null, N_MGO_Additional_volume_2?: number | null, N_MGO_Additional_FuelType_3?: MgoFuelType | null, N_MGO_Additional_Usage_3?: string | null, N_MGO_Additional_volume_3?: number | null, N_MGO_Additional_FuelType_4?: MgoFuelType | null, N_MGO_Additional_Usage_4?: string | null, N_MGO_Additional_volume_4?: number | null, N_MGO_Additional_FuelType_5?: MgoFuelType | null, N_MGO_Additional_Usage_5?: string | null, N_MGO_Additional_volume_5?: number | null, N_LO_Consumption_per_day_MECO: number, N_LO_Consumption_per_day_MESO: number, N_LO_Consumption_per_day_GESO: number, N_Other_Additional_FuelType_1?: OtherFuelType | null, N_Other_Additional_Usage_1?: string | null, N_Other_Additional_volume_1?: number | null, N_Other_Additional_FuelType_2?: OtherFuelType | null, N_Other_Additional_Usage_2?: string | null, N_Other_Additional_volume_2?: number | null, N_Other_Additional_FuelType_3?: OtherFuelType | null, N_Other_Additional_Usage_3?: string | null, N_Other_Additional_volume_3?: number | null, N_Other_Additional_FuelType_4?: OtherFuelType | null, N_Other_Additional_Usage_4?: string | null, N_Other_Additional_volume_4?: number | null, N_Other_Additional_FuelType_5?: OtherFuelType | null, N_Other_Additional_Usage_5?: string | null, N_Other_Additional_volume_5?: number | null, N_ROB_Filename?: string | null, N_Weather?: string | null, N_Wind_direction?: number | null, N_BF_scale?: number | null, N_Swell?: number | null, N_Noon_Course?: number | null, N_Dist_to_go?: number | null, N_Next_port?: string | null, N_ETA?: Date | null, N_ETB?: Date | null, N_ETD?: Date | null, N_ME_Fuel_index?: number | null, N_ME_RPM?: number | null, N_ME_horsepower?: number | null, N_ME_power?: number | null, N_ME_power_measurement_method?: MePowerMeasurementMethod | null, N_Running_hours_SOx_scrubber?: number | null, N_Running_hours_ME_EGR?: number | null, N_Running_hours_GE_SCR: number, N_ROB_FO: number, N_ROB_MGO: number, N_ROB_MECO: number, N_ROB_MESO: number, N_ROB_GESO: number, N_ROB_FW: number, N_FO_CO2_emission_per_unit: number, N_MGO_CO2_emission_per_unit: number, N_FO_CO2_emission: number, N_MGO_CO2_emission: number, N_Remark?: string | null, N_Spare_1?: string | null, N_Spare_1_unit_name?: string | null, N_Spare_2?: string | null, N_Spare_2_unit_name?: string | null, N_Spare_3?: string | null, N_Spare_3_unit_name?: string | null, N_Spare_4?: string | null, N_Spare_4_unit_name?: string | null, N_Spare_5?: string | null, N_Spare_5_unit_name?: string | null, N_Spare_6?: string | null, N_Spare_6_unit_name?: string | null, N_Spare_7?: string | null, N_Spare_7_unit_name?: string | null, N_Spare_8?: string | null, N_Spare_8_unit_name?: string | null, N_Spare_9?: string | null, N_Spare_9_unit_name?: string | null, N_Spare_10?: string | null, N_Spare_10_unit_name?: string | null, N_Spare_11?: string | null, N_Spare_11_unit_name?: string | null, N_Spare_12?: string | null, N_Spare_12_unit_name?: string | null, N_Spare_13?: string | null, N_Spare_13_unit_name?: string | null, N_Spare_14?: string | null, N_Spare_14_unit_name?: string | null, N_Spare_15?: string | null, N_Spare_15_unit_name?: string | null, N_Spare_16?: string | null, N_Spare_16_unit_name?: string | null, N_Spare_17?: string | null, N_Spare_17_unit_name?: string | null, N_Spare_18?: string | null, N_Spare_18_unit_name?: string | null, N_Spare_19?: string | null, N_Spare_19_unit_name?: string | null, N_Spare_20?: string | null, N_Spare_20_unit_name?: string | null, ship?: { __typename?: 'Ship', fo_fuel_type: FoFuelType } | null, N_Additional_ROB?: Array<{ __typename?: 'AdditionalROB', id: number, N_Fuel_Type: FuelType, N_Fuel_volume: number } | null> | null } | null };

export type GetReportQueryVariables = Exact<{
  input: GetReportInput;
}>;


export type GetReportQuery = { __typename?: 'Query', getReport?: { __typename?: 'Report', id: number, ship_id: number, N_Vessel_name: string, N_Voy: string, N_LorB: LorB, N_Noon_Port?: string | null, N_UNLOC?: string | null, N_EU_UK_port?: EUorUk | null, N_Port_L_U?: LorU | null, N_DateTime: Date, N_TimeZone: string, N_LatLong: string, N_Steam_mode: string, N_Hrs_propelling: number, N_Dist_OG: number, N_Speed_OG: number, N_Speed_OW: number, N_ME_rpm_ave: number, N_ME_rpm_total?: number | null, N_ME_Revolution: number, N_Slip: number, N_FO_Consumption_per_day_ME: number, N_FO_Consumption_per_day_GE: number, N_FO_Consumption_per_day_BInc: number, N_FO_Additional_FuelType_1?: FoFuelType | null, N_FO_Additional_Usage_1?: string | null, N_FO_Additional_volume_1?: number | null, N_FO_Additional_FuelType_2?: FoFuelType | null, N_FO_Additional_Usage_2?: string | null, N_FO_Additional_volume_2?: number | null, N_FO_Additional_FuelType_3?: FoFuelType | null, N_FO_Additional_Usage_3?: string | null, N_FO_Additional_volume_3?: number | null, N_FO_Additional_FuelType_4?: FoFuelType | null, N_FO_Additional_Usage_4?: string | null, N_FO_Additional_volume_4?: number | null, N_FO_Additional_FuelType_5?: FoFuelType | null, N_FO_Additional_Usage_5?: string | null, N_FO_Additional_volume_5?: number | null, N_MGO_Consumption_per_day_ME: number, N_MGO_Consumption_per_day_GE: number, N_MGO_Consumption_per_day_Boiler: number, N_MGO_Additional_FuelType_1?: MgoFuelType | null, N_MGO_Additional_Usage_1?: string | null, N_MGO_Additional_volume_1?: number | null, N_MGO_Additional_FuelType_2?: MgoFuelType | null, N_MGO_Additional_Usage_2?: string | null, N_MGO_Additional_volume_2?: number | null, N_MGO_Additional_FuelType_3?: MgoFuelType | null, N_MGO_Additional_Usage_3?: string | null, N_MGO_Additional_volume_3?: number | null, N_MGO_Additional_FuelType_4?: MgoFuelType | null, N_MGO_Additional_Usage_4?: string | null, N_MGO_Additional_volume_4?: number | null, N_MGO_Additional_FuelType_5?: MgoFuelType | null, N_MGO_Additional_Usage_5?: string | null, N_MGO_Additional_volume_5?: number | null, N_LO_Consumption_per_day_MECO: number, N_LO_Consumption_per_day_MESO: number, N_LO_Consumption_per_day_GESO: number, N_Other_Additional_FuelType_1?: OtherFuelType | null, N_Other_Additional_Usage_1?: string | null, N_Other_Additional_volume_1?: number | null, N_Other_Additional_FuelType_2?: OtherFuelType | null, N_Other_Additional_Usage_2?: string | null, N_Other_Additional_volume_2?: number | null, N_Other_Additional_FuelType_3?: OtherFuelType | null, N_Other_Additional_Usage_3?: string | null, N_Other_Additional_volume_3?: number | null, N_Other_Additional_FuelType_4?: OtherFuelType | null, N_Other_Additional_Usage_4?: string | null, N_Other_Additional_volume_4?: number | null, N_Other_Additional_FuelType_5?: OtherFuelType | null, N_Other_Additional_Usage_5?: string | null, N_Other_Additional_volume_5?: number | null, N_ROB_Filename?: string | null, N_Weather?: string | null, N_Wind_direction?: number | null, N_BF_scale?: number | null, N_Swell?: number | null, N_Noon_Course?: number | null, N_Dist_to_go?: number | null, N_Next_port?: string | null, N_ETA?: Date | null, N_ETB?: Date | null, N_ETD?: Date | null, N_ME_Fuel_index?: number | null, N_ME_RPM?: number | null, N_ME_horsepower?: number | null, N_ME_power?: number | null, N_ME_power_measurement_method?: MePowerMeasurementMethod | null, N_Running_hours_SOx_scrubber?: number | null, N_Running_hours_ME_EGR?: number | null, N_Running_hours_GE_SCR: number, N_ROB_FO: number, N_ROB_MGO: number, N_ROB_MECO: number, N_ROB_MESO: number, N_ROB_GESO: number, N_ROB_FW: number, N_FO_CO2_emission_per_unit: number, N_MGO_CO2_emission_per_unit: number, N_FO_CO2_emission: number, N_MGO_CO2_emission: number, N_Remark?: string | null, N_Spare_1?: string | null, N_Spare_1_unit_name?: string | null, N_Spare_2?: string | null, N_Spare_2_unit_name?: string | null, N_Spare_3?: string | null, N_Spare_3_unit_name?: string | null, N_Spare_4?: string | null, N_Spare_4_unit_name?: string | null, N_Spare_5?: string | null, N_Spare_5_unit_name?: string | null, N_Spare_6?: string | null, N_Spare_6_unit_name?: string | null, N_Spare_7?: string | null, N_Spare_7_unit_name?: string | null, N_Spare_8?: string | null, N_Spare_8_unit_name?: string | null, N_Spare_9?: string | null, N_Spare_9_unit_name?: string | null, N_Spare_10?: string | null, N_Spare_10_unit_name?: string | null, N_Spare_11?: string | null, N_Spare_11_unit_name?: string | null, N_Spare_12?: string | null, N_Spare_12_unit_name?: string | null, N_Spare_13?: string | null, N_Spare_13_unit_name?: string | null, N_Spare_14?: string | null, N_Spare_14_unit_name?: string | null, N_Spare_15?: string | null, N_Spare_15_unit_name?: string | null, N_Spare_16?: string | null, N_Spare_16_unit_name?: string | null, N_Spare_17?: string | null, N_Spare_17_unit_name?: string | null, N_Spare_18?: string | null, N_Spare_18_unit_name?: string | null, N_Spare_19?: string | null, N_Spare_19_unit_name?: string | null, N_Spare_20?: string | null, N_Spare_20_unit_name?: string | null, N_Additional_ROB?: Array<{ __typename?: 'AdditionalROB', id: number, N_Fuel_Type: FuelType, N_Fuel_volume: number } | null> | null } | null };

export type GetShipDataQueryVariables = Exact<{
  filter: ShipListFiler;
}>;


export type GetShipDataQuery = { __typename?: 'Query', shipList?: Array<{ __typename?: 'Ship', id: number, IMO_No: string, name: string, summer_deadweight: number, propeller_pitch: number, type_of_ship_cii?: TypeOfShipCii | null, fo_fuel_type: FoFuelType, is_mrv_portal_integration_target: boolean, cargoFormSetting?: { __typename?: 'CargoFormSetting', type_of_ship_cii: TypeOfShipCii, C_Mass: CargoFormRequired, C_TEU_Full: CargoFormRequired, C_TEU_Empty: CargoFormRequired, C_Unit: CargoFormRequired, C_Lane_metres: CargoFormRequired, C_Number_of_Passengers: CargoFormRequired, C_Volume: CargoFormRequired } | null, shipMaster?: { __typename?: 'ShipMaster', IMONo: string, lastUpdated: Date, created_at: Date, updated_at: Date } | null } | null> | null };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: number, name: string } | null };

export type ReferenceDataListQueryVariables = Exact<{
  input: ReferenceDataListInput;
}>;


export type ReferenceDataListQuery = { __typename?: 'Query', referenceDataList?: Array<{ __typename?: 'ReferenceData', Speed_OG: number, fuel_consumption_Ballast?: number | null, fuel_consumption_Laden?: number | null, fuel_consumption_Unique?: number | null, dataType: ReferenceDataType } | null> | null };

export type ReportGraphFilterQueryVariables = Exact<{
  input: ReportListInput;
}>;


export type ReportGraphFilterQuery = { __typename?: 'Query', reportList?: { __typename?: 'reportListResponse', reportList?: Array<{ __typename?: 'Report', id: number, N_Hrs_propelling: number, N_Speed_OG: number, N_DateTime: Date, N_FO_Consumption_per_day_ME: number, N_FO_Consumption_per_day_GE: number, N_FO_Consumption_per_day_BInc: number } | null> | null } | null };

export type ReportListQueryVariables = Exact<{
  input: ReportListInput;
}>;


export type ReportListQuery = { __typename?: 'Query', reportList?: { __typename?: 'reportListResponse', totalPageCount?: number | null, reportList?: Array<{ __typename?: 'Report', id: number, N_Vessel_name: string, N_Voy: string, N_LorB: LorB, N_Noon_Port?: string | null, N_UNLOC?: string | null, N_EU_UK_port?: EUorUk | null, N_Port_L_U?: LorU | null, N_DateTime: Date, N_TimeZone: string, N_LatLong: string, N_Steam_mode: string, N_Hrs_propelling: number, N_Dist_OG: number, N_Speed_OG: number, N_Speed_OW: number, N_ME_rpm_ave: number, N_ME_rpm_total?: number | null, N_ME_Revolution: number, N_Slip: number, N_FO_Consumption_per_day_ME: number, N_FO_Consumption_per_day_GE: number, N_FO_Consumption_per_day_BInc: number, N_FO_Additional_FuelType_1?: FoFuelType | null, N_FO_Additional_Usage_1?: string | null, N_FO_Additional_volume_1?: number | null, N_FO_Additional_FuelType_2?: FoFuelType | null, N_FO_Additional_Usage_2?: string | null, N_FO_Additional_volume_2?: number | null, N_FO_Additional_FuelType_3?: FoFuelType | null, N_FO_Additional_Usage_3?: string | null, N_FO_Additional_volume_3?: number | null, N_FO_Additional_FuelType_4?: FoFuelType | null, N_FO_Additional_Usage_4?: string | null, N_FO_Additional_volume_4?: number | null, N_FO_Additional_FuelType_5?: FoFuelType | null, N_FO_Additional_Usage_5?: string | null, N_FO_Additional_volume_5?: number | null, N_MGO_Consumption_per_day_ME: number, N_MGO_Consumption_per_day_GE: number, N_MGO_Consumption_per_day_Boiler: number, N_MGO_Additional_FuelType_1?: MgoFuelType | null, N_MGO_Additional_Usage_1?: string | null, N_MGO_Additional_volume_1?: number | null, N_MGO_Additional_FuelType_2?: MgoFuelType | null, N_MGO_Additional_Usage_2?: string | null, N_MGO_Additional_volume_2?: number | null, N_MGO_Additional_FuelType_3?: MgoFuelType | null, N_MGO_Additional_Usage_3?: string | null, N_MGO_Additional_volume_3?: number | null, N_MGO_Additional_FuelType_4?: MgoFuelType | null, N_MGO_Additional_Usage_4?: string | null, N_MGO_Additional_volume_4?: number | null, N_MGO_Additional_FuelType_5?: MgoFuelType | null, N_MGO_Additional_Usage_5?: string | null, N_MGO_Additional_volume_5?: number | null, N_LO_Consumption_per_day_MECO: number, N_LO_Consumption_per_day_MESO: number, N_LO_Consumption_per_day_GESO: number, N_Other_Additional_FuelType_1?: OtherFuelType | null, N_Other_Additional_Usage_1?: string | null, N_Other_Additional_volume_1?: number | null, N_Other_Additional_FuelType_2?: OtherFuelType | null, N_Other_Additional_Usage_2?: string | null, N_Other_Additional_volume_2?: number | null, N_Other_Additional_FuelType_3?: OtherFuelType | null, N_Other_Additional_Usage_3?: string | null, N_Other_Additional_volume_3?: number | null, N_Other_Additional_FuelType_4?: OtherFuelType | null, N_Other_Additional_Usage_4?: string | null, N_Other_Additional_volume_4?: number | null, N_Other_Additional_FuelType_5?: OtherFuelType | null, N_Other_Additional_Usage_5?: string | null, N_Other_Additional_volume_5?: number | null, N_Weather?: string | null, N_Wind_direction?: number | null, N_BF_scale?: number | null, N_Swell?: number | null, N_Noon_Course?: number | null, N_Dist_to_go?: number | null, N_Next_port?: string | null, N_ETA?: Date | null, N_ETB?: Date | null, N_ETD?: Date | null, N_ME_Fuel_index?: number | null, N_ME_RPM?: number | null, N_ME_horsepower?: number | null, N_ME_power?: number | null, N_ME_power_measurement_method?: MePowerMeasurementMethod | null, N_Running_hours_SOx_scrubber?: number | null, N_Running_hours_ME_EGR?: number | null, N_Running_hours_GE_SCR: number, N_ROB_FO: number, N_ROB_MGO: number, N_ROB_MECO: number, N_ROB_MESO: number, N_ROB_GESO: number, N_ROB_FW: number, N_FO_CO2_emission_per_unit: number, N_MGO_CO2_emission_per_unit: number, N_FO_CO2_emission: number, N_MGO_CO2_emission: number, N_Remark?: string | null, N_Spare_1?: string | null, N_Spare_1_unit_name?: string | null, N_Spare_2?: string | null, N_Spare_2_unit_name?: string | null, N_Spare_3?: string | null, N_Spare_3_unit_name?: string | null, N_Spare_4?: string | null, N_Spare_4_unit_name?: string | null, N_Spare_5?: string | null, N_Spare_5_unit_name?: string | null, N_Spare_6?: string | null, N_Spare_6_unit_name?: string | null, N_Spare_7?: string | null, N_Spare_7_unit_name?: string | null, N_Spare_8?: string | null, N_Spare_8_unit_name?: string | null, N_Spare_9?: string | null, N_Spare_9_unit_name?: string | null, N_Spare_10?: string | null, N_Spare_10_unit_name?: string | null, N_Spare_11?: string | null, N_Spare_11_unit_name?: string | null, N_Spare_12?: string | null, N_Spare_12_unit_name?: string | null, N_Spare_13?: string | null, N_Spare_13_unit_name?: string | null, N_Spare_14?: string | null, N_Spare_14_unit_name?: string | null, N_Spare_15?: string | null, N_Spare_15_unit_name?: string | null, N_Spare_16?: string | null, N_Spare_16_unit_name?: string | null, N_Spare_17?: string | null, N_Spare_17_unit_name?: string | null, N_Spare_18?: string | null, N_Spare_18_unit_name?: string | null, N_Spare_19?: string | null, N_Spare_19_unit_name?: string | null, N_Spare_20?: string | null, N_Spare_20_unit_name?: string | null, ship_id: number, N_Additional_ROB?: Array<{ __typename?: 'AdditionalROB', id: number, N_Fuel_Type: FuelType, N_Fuel_volume: number } | null> | null } | null> | null } | null };

export type SendReportToMrvMutationVariables = Exact<{
  input: SendReportToMrvInput;
}>;


export type SendReportToMrvMutation = { __typename?: 'Mutation', sendReportToMrv?: { __typename?: 'SendReportToMrvResponse', success?: boolean | null, message?: string | null } | null };

export type ShipListQueryVariables = Exact<{ [key: string]: never; }>;


export type ShipListQuery = { __typename?: 'Query', shipList?: Array<{ __typename?: 'Ship', id: number, IMO_No: string, name: string, summer_deadweight: number, propeller_pitch: number, type_of_ship_cii?: TypeOfShipCii | null, fo_fuel_type: FoFuelType, is_mrv_portal_integration_target: boolean, cargoFormSetting?: { __typename?: 'CargoFormSetting', type_of_ship_cii: TypeOfShipCii, C_Mass: CargoFormRequired, C_TEU_Full: CargoFormRequired, C_TEU_Empty: CargoFormRequired, C_Unit: CargoFormRequired, C_Lane_metres: CargoFormRequired, C_Number_of_Passengers: CargoFormRequired, C_Volume: CargoFormRequired } | null, shipMaster?: { __typename?: 'ShipMaster', IMONo: string, lastUpdated: Date, created_at: Date, updated_at: Date } | null } | null> | null };

export type UpdateAnalysisSearchParameterTitleMutationVariables = Exact<{
  input: AnalysisSearchParameterInput;
}>;


export type UpdateAnalysisSearchParameterTitleMutation = { __typename?: 'Mutation', updateAnalysisSearchParameterTitle?: { __typename?: 'AnalysisSearchParameter', title: string } | null };

export type UpdateArrivalMutationVariables = Exact<{
  input: ArrivalInput;
}>;


export type UpdateArrivalMutation = { __typename?: 'Mutation', updateArrival?: { __typename?: 'UpdateArrivalResponse', Arrival?: { __typename?: 'Arrival', id: number } | null } | null };

export type UpdateBunkeringMutationVariables = Exact<{
  input: BunkeringInput;
}>;


export type UpdateBunkeringMutation = { __typename?: 'Mutation', updateBunkering?: { __typename?: 'UpdateBunkeringResponse', gcsFilePath: string, isFileUpload: boolean, Bunkering?: { __typename?: 'Bunkering', id: number, B_Filename?: string | null } | null } | null };

export type UpdateCargoMutationVariables = Exact<{
  input: CargoInput;
}>;


export type UpdateCargoMutation = { __typename?: 'Mutation', updateCargo?: { __typename?: 'UpdateCargoResponse', gcsFilePath: string, isFileUpload: boolean, Cargo?: { __typename?: 'Cargo', id: number, C_Filename?: string | null } | null } | null };

export type UpdateDepartureMutationVariables = Exact<{
  input: DepartureInput;
}>;


export type UpdateDepartureMutation = { __typename?: 'Mutation', updateDeparture?: { __typename?: 'UpdateDepartureResponse', Departure?: { __typename?: 'Departure', id: number } | null } | null };

export type UpdateReportMutationVariables = Exact<{
  input: ReportInput;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport: { __typename?: 'UpdateReportResponse', UpdateReportStatus: QueryStatus, gcsFilePath: string, isFileUpload: boolean, Report?: { __typename?: 'Report', id: number, N_ROB_Filename?: string | null } | null } };

export type UpsertAnalysisSearchParameterMutationVariables = Exact<{
  input: AnalysisSearchParameterInput;
}>;


export type UpsertAnalysisSearchParameterMutation = { __typename?: 'Mutation', upsertAnalysisSearchParameter: boolean };

export type VesselNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type VesselNamesQuery = { __typename?: 'Query', shipList?: Array<{ __typename?: 'Ship', id: number, name: string, IMO_No: string, is_mrv_portal_integration_target: boolean } | null> | null };


export const CreateReferenceDataDocument = gql`
    mutation createReferenceData($input: CreateReferenceDataInput!) {
  createReferenceData(input: $input) {
    count
    success
  }
}
    `;
export type CreateReferenceDataMutationFn = Apollo.MutationFunction<CreateReferenceDataMutation, CreateReferenceDataMutationVariables>;

/**
 * __useCreateReferenceDataMutation__
 *
 * To run a mutation, you first call `useCreateReferenceDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReferenceDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReferenceDataMutation, { data, loading, error }] = useCreateReferenceDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReferenceDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateReferenceDataMutation, CreateReferenceDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReferenceDataMutation, CreateReferenceDataMutationVariables>(CreateReferenceDataDocument, options);
      }
export type CreateReferenceDataMutationHookResult = ReturnType<typeof useCreateReferenceDataMutation>;
export type CreateReferenceDataMutationResult = Apollo.MutationResult<CreateReferenceDataMutation>;
export type CreateReferenceDataMutationOptions = Apollo.BaseMutationOptions<CreateReferenceDataMutation, CreateReferenceDataMutationVariables>;
export const ArrivalListDocument = gql`
    query arrivalList($input: arrivalListInput!) {
  arrivalList(input: $input) {
    totalPageCount
    arrivalList {
      id
      A_Vessel_Name
      A_Voy
      A_LorB
      A_Arrival_Port
      A_EU_UK_port
      A_Port_L_U
      A_UNLOC
      A_Arrival_Date_Time
      A_SB_or_Stop
      A_Time_Zone
      A_ETB
      A_ETC
      A_ETD
      A_Berthed
      A_ROB_at_Arrival_FO
      A_ROB_at_Arrival_MGO
      A_ROB_at_Arrival_MECO
      A_ROB_at_Arrival_MESO
      A_ROB_at_Arrival_GESO
      A_ROB_at_Arrival_FW
      A_Hrs_since_Last_Noon
      A_Distance_by_OG
      A_FO_Consumption_per_day_ME
      A_FO_Consumption_per_day_GE
      A_FO_Consumption_per_day_B_and_Inc
      A_MGO_Consumption_per_day_ME
      A_MGO_Consumption_per_day_GE
      A_MGO_Consumption_per_day_B_and_Inc
      A_ROB_FO
      A_ROB_MGO
      A_ROB_MECO
      A_ROB_MESO
      A_ROB_GESO
      A_ROB_FW
      A_Additional_ROB {
        id
        A_Fuel_Type
        A_Fuel_volume
      }
      A_Draft_Fore
      A_Draft_Aft
      A_FO_CO2_emission
      A_MGO_CO2_emission
      A_Remark
      A_Spare_1
      A_Spare_1_unit_name
      A_Spare_2
      A_Spare_2_unit_name
      A_Spare_3
      A_Spare_3_unit_name
      A_Spare_4
      A_Spare_4_unit_name
      A_Spare_5
      A_Spare_5_unit_name
      A_Spare_6
      A_Spare_6_unit_name
      A_Spare_7
      A_Spare_7_unit_name
      A_Spare_8
      A_Spare_8_unit_name
      A_Spare_9
      A_Spare_9_unit_name
      A_Spare_10
      A_Spare_10_unit_name
      A_Spare_11
      A_Spare_11_unit_name
      A_Spare_12
      A_Spare_12_unit_name
      A_Spare_13
      A_Spare_13_unit_name
      A_Spare_14
      A_Spare_14_unit_name
      A_Spare_15
      A_Spare_15_unit_name
      A_Spare_16
      A_Spare_16_unit_name
      A_Spare_17
      A_Spare_17_unit_name
      A_Spare_18
      A_Spare_18_unit_name
      A_Spare_19
      A_Spare_19_unit_name
      A_Spare_20
      A_Spare_20_unit_name
    }
  }
}
    `;

/**
 * __useArrivalListQuery__
 *
 * To run a query within a React component, call `useArrivalListQuery` and pass it any options that fit your needs.
 * When your component renders, `useArrivalListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArrivalListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArrivalListQuery(baseOptions: Apollo.QueryHookOptions<ArrivalListQuery, ArrivalListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArrivalListQuery, ArrivalListQueryVariables>(ArrivalListDocument, options);
      }
export function useArrivalListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArrivalListQuery, ArrivalListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArrivalListQuery, ArrivalListQueryVariables>(ArrivalListDocument, options);
        }
export type ArrivalListQueryHookResult = ReturnType<typeof useArrivalListQuery>;
export type ArrivalListLazyQueryHookResult = ReturnType<typeof useArrivalListLazyQuery>;
export type ArrivalListQueryResult = Apollo.QueryResult<ArrivalListQuery, ArrivalListQueryVariables>;
export const BunkeringListDocument = gql`
    query bunkeringList($input: bunkeringListInput!) {
  bunkeringList(input: $input) {
    totalPageCount
    bunkeringList {
      id
      B_Vessel_Name
      B_Voy
      B_Timezone
      B_Bunkering_Date_time
      B_LatLong
      B_PortName
      B_UNLOC
      B_EUorUK
      B_Port_LorU
      B_Fuel_name_1
      B_Mass_1
      B_Volume_1
      B_Density_1
      B_Fuel_name_2
      B_Mass_2
      B_Volume_2
      B_Density_2
      B_Fuel_name_3
      B_Mass_3
      B_Volume_3
      B_Density_3
      B_Fuel_name_4
      B_Mass_4
      B_Volume_4
      B_Density_4
      B_Fuel_name_5
      B_Mass_5
      B_Volume_5
      B_Density_5
      B_Fuel_name_6
      B_Mass_6
      B_Volume_6
      B_Density_6
      B_Fuel_name_7
      B_Mass_7
      B_Volume_7
      B_Density_7
      B_Fuel_name_8
      B_Mass_8
      B_Volume_8
      B_Density_8
      B_Fuel_name_9
      B_Mass_9
      B_Volume_9
      B_Density_9
      B_Fuel_name_10
      B_Mass_10
      B_Volume_10
      B_Density_10
    }
  }
}
    `;

/**
 * __useBunkeringListQuery__
 *
 * To run a query within a React component, call `useBunkeringListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBunkeringListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBunkeringListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBunkeringListQuery(baseOptions: Apollo.QueryHookOptions<BunkeringListQuery, BunkeringListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BunkeringListQuery, BunkeringListQueryVariables>(BunkeringListDocument, options);
      }
export function useBunkeringListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BunkeringListQuery, BunkeringListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BunkeringListQuery, BunkeringListQueryVariables>(BunkeringListDocument, options);
        }
export type BunkeringListQueryHookResult = ReturnType<typeof useBunkeringListQuery>;
export type BunkeringListLazyQueryHookResult = ReturnType<typeof useBunkeringListLazyQuery>;
export type BunkeringListQueryResult = Apollo.QueryResult<BunkeringListQuery, BunkeringListQueryVariables>;
export const CargoListDocument = gql`
    query cargoList($input: cargoListInput!) {
  cargoList(input: $input) {
    totalPageCount
    cargoList {
      id
      imo_no
      C_Timezone
      C_DateTime
      C_Latitude
      C_Longitude
      C_Voyage_No
      C_Cargo_Port
      C_UNLOC
      C_EU_UK_port
      C_Port_L_U
      C_Loading_Mass
      C_Loading_TEU_Full
      C_Loading_TEU_Empty
      C_Loading_Unit
      C_Loading_Lane_metres
      C_Loading_Number_of_Passengers
      C_Loading_Volume
      C_Unloading_Mass
      C_Unloading_TEU_Full
      C_Unloading_TEU_Empty
      C_Unloading_Unit
      C_Unloading_Lane_metres
      C_Unloading_Number_of_Passengers
      C_Unloading_Volume
      C_Total_Mass
      C_Total_TEU_Full
      C_Total_TEU_Empty
      C_Total_Unit
      C_Total_Lane_metres
      C_Total_Number_of_Passengers
      C_Total_Volume
      C_Displacement
      C_Water_density
      C_Total_ROB
      C_Filename
    }
  }
}
    `;

/**
 * __useCargoListQuery__
 *
 * To run a query within a React component, call `useCargoListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCargoListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCargoListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCargoListQuery(baseOptions: Apollo.QueryHookOptions<CargoListQuery, CargoListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CargoListQuery, CargoListQueryVariables>(CargoListDocument, options);
      }
export function useCargoListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CargoListQuery, CargoListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CargoListQuery, CargoListQueryVariables>(CargoListDocument, options);
        }
export type CargoListQueryHookResult = ReturnType<typeof useCargoListQuery>;
export type CargoListLazyQueryHookResult = ReturnType<typeof useCargoListLazyQuery>;
export type CargoListQueryResult = Apollo.QueryResult<CargoListQuery, CargoListQueryVariables>;
export const CheckDuplicateNoonReportListDocument = gql`
    query CheckDuplicateNoonReportList($input: CheckDuplicateNoonReportListInput!) {
  checkDuplicateNoonReportList(input: $input) {
    duplicatedNoonReports {
      ship_id
      N_Voy
      N_DateTime
    }
  }
}
    `;

/**
 * __useCheckDuplicateNoonReportListQuery__
 *
 * To run a query within a React component, call `useCheckDuplicateNoonReportListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckDuplicateNoonReportListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckDuplicateNoonReportListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckDuplicateNoonReportListQuery(baseOptions: Apollo.QueryHookOptions<CheckDuplicateNoonReportListQuery, CheckDuplicateNoonReportListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckDuplicateNoonReportListQuery, CheckDuplicateNoonReportListQueryVariables>(CheckDuplicateNoonReportListDocument, options);
      }
export function useCheckDuplicateNoonReportListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckDuplicateNoonReportListQuery, CheckDuplicateNoonReportListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckDuplicateNoonReportListQuery, CheckDuplicateNoonReportListQueryVariables>(CheckDuplicateNoonReportListDocument, options);
        }
export type CheckDuplicateNoonReportListQueryHookResult = ReturnType<typeof useCheckDuplicateNoonReportListQuery>;
export type CheckDuplicateNoonReportListLazyQueryHookResult = ReturnType<typeof useCheckDuplicateNoonReportListLazyQuery>;
export type CheckDuplicateNoonReportListQueryResult = Apollo.QueryResult<CheckDuplicateNoonReportListQuery, CheckDuplicateNoonReportListQueryVariables>;
export const CheckOnlineDocument = gql`
    query checkOnline {
  checkOnline
}
    `;

/**
 * __useCheckOnlineQuery__
 *
 * To run a query within a React component, call `useCheckOnlineQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckOnlineQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckOnlineQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckOnlineQuery(baseOptions?: Apollo.QueryHookOptions<CheckOnlineQuery, CheckOnlineQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckOnlineQuery, CheckOnlineQueryVariables>(CheckOnlineDocument, options);
      }
export function useCheckOnlineLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckOnlineQuery, CheckOnlineQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckOnlineQuery, CheckOnlineQueryVariables>(CheckOnlineDocument, options);
        }
export type CheckOnlineQueryHookResult = ReturnType<typeof useCheckOnlineQuery>;
export type CheckOnlineLazyQueryHookResult = ReturnType<typeof useCheckOnlineLazyQuery>;
export type CheckOnlineQueryResult = Apollo.QueryResult<CheckOnlineQuery, CheckOnlineQueryVariables>;
export const CreateArrivalListDocument = gql`
    mutation createArrivalList($input: CreateArrivalListInput!) {
  createArrivalList(input: $input) {
    CreateArrivalListStatus
    createdArrivalCount
  }
}
    `;
export type CreateArrivalListMutationFn = Apollo.MutationFunction<CreateArrivalListMutation, CreateArrivalListMutationVariables>;

/**
 * __useCreateArrivalListMutation__
 *
 * To run a mutation, you first call `useCreateArrivalListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateArrivalListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createArrivalListMutation, { data, loading, error }] = useCreateArrivalListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateArrivalListMutation(baseOptions?: Apollo.MutationHookOptions<CreateArrivalListMutation, CreateArrivalListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateArrivalListMutation, CreateArrivalListMutationVariables>(CreateArrivalListDocument, options);
      }
export type CreateArrivalListMutationHookResult = ReturnType<typeof useCreateArrivalListMutation>;
export type CreateArrivalListMutationResult = Apollo.MutationResult<CreateArrivalListMutation>;
export type CreateArrivalListMutationOptions = Apollo.BaseMutationOptions<CreateArrivalListMutation, CreateArrivalListMutationVariables>;
export const CreateBunkeringListDocument = gql`
    mutation createBunkeringList($input: CreateBunkeringListInput!) {
  createBunkeringList(input: $input) {
    createdBunkeringCount
    uploadFilePaths {
      dbFilePath
      gcsFilePath
    }
    CreateBunkeringListStatus
  }
}
    `;
export type CreateBunkeringListMutationFn = Apollo.MutationFunction<CreateBunkeringListMutation, CreateBunkeringListMutationVariables>;

/**
 * __useCreateBunkeringListMutation__
 *
 * To run a mutation, you first call `useCreateBunkeringListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBunkeringListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBunkeringListMutation, { data, loading, error }] = useCreateBunkeringListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBunkeringListMutation(baseOptions?: Apollo.MutationHookOptions<CreateBunkeringListMutation, CreateBunkeringListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBunkeringListMutation, CreateBunkeringListMutationVariables>(CreateBunkeringListDocument, options);
      }
export type CreateBunkeringListMutationHookResult = ReturnType<typeof useCreateBunkeringListMutation>;
export type CreateBunkeringListMutationResult = Apollo.MutationResult<CreateBunkeringListMutation>;
export type CreateBunkeringListMutationOptions = Apollo.BaseMutationOptions<CreateBunkeringListMutation, CreateBunkeringListMutationVariables>;
export const CreateCargoListDocument = gql`
    mutation createCargoList($input: CreateCargoListInput!) {
  createCargoList(input: $input) {
    createdCargoCount
    uploadFilePaths {
      dbFilePath
      gcsFilePath
    }
    CreateCargoListStatus
  }
}
    `;
export type CreateCargoListMutationFn = Apollo.MutationFunction<CreateCargoListMutation, CreateCargoListMutationVariables>;

/**
 * __useCreateCargoListMutation__
 *
 * To run a mutation, you first call `useCreateCargoListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCargoListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCargoListMutation, { data, loading, error }] = useCreateCargoListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCargoListMutation(baseOptions?: Apollo.MutationHookOptions<CreateCargoListMutation, CreateCargoListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCargoListMutation, CreateCargoListMutationVariables>(CreateCargoListDocument, options);
      }
export type CreateCargoListMutationHookResult = ReturnType<typeof useCreateCargoListMutation>;
export type CreateCargoListMutationResult = Apollo.MutationResult<CreateCargoListMutation>;
export type CreateCargoListMutationOptions = Apollo.BaseMutationOptions<CreateCargoListMutation, CreateCargoListMutationVariables>;
export const CreateDepartureListDocument = gql`
    mutation createDepartureList($input: CreateDepartureListInput!) {
  createDepartureList(input: $input) {
    CreateDepartureListStatus
    createdDepartureCount
  }
}
    `;
export type CreateDepartureListMutationFn = Apollo.MutationFunction<CreateDepartureListMutation, CreateDepartureListMutationVariables>;

/**
 * __useCreateDepartureListMutation__
 *
 * To run a mutation, you first call `useCreateDepartureListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDepartureListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDepartureListMutation, { data, loading, error }] = useCreateDepartureListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDepartureListMutation(baseOptions?: Apollo.MutationHookOptions<CreateDepartureListMutation, CreateDepartureListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDepartureListMutation, CreateDepartureListMutationVariables>(CreateDepartureListDocument, options);
      }
export type CreateDepartureListMutationHookResult = ReturnType<typeof useCreateDepartureListMutation>;
export type CreateDepartureListMutationResult = Apollo.MutationResult<CreateDepartureListMutation>;
export type CreateDepartureListMutationOptions = Apollo.BaseMutationOptions<CreateDepartureListMutation, CreateDepartureListMutationVariables>;
export const CreateErrorDataDocument = gql`
    mutation createErrorData($input: CreateErrorDataInput!) {
  createErrorData(input: $input)
}
    `;
export type CreateErrorDataMutationFn = Apollo.MutationFunction<CreateErrorDataMutation, CreateErrorDataMutationVariables>;

/**
 * __useCreateErrorDataMutation__
 *
 * To run a mutation, you first call `useCreateErrorDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateErrorDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createErrorDataMutation, { data, loading, error }] = useCreateErrorDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateErrorDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateErrorDataMutation, CreateErrorDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateErrorDataMutation, CreateErrorDataMutationVariables>(CreateErrorDataDocument, options);
      }
export type CreateErrorDataMutationHookResult = ReturnType<typeof useCreateErrorDataMutation>;
export type CreateErrorDataMutationResult = Apollo.MutationResult<CreateErrorDataMutation>;
export type CreateErrorDataMutationOptions = Apollo.BaseMutationOptions<CreateErrorDataMutation, CreateErrorDataMutationVariables>;
export const CreateFrontendShipDataDocument = gql`
    mutation createFrontendShipData($input: CreateFrontendShipDataInput!) {
  createFrontendShipData(input: $input)
}
    `;
export type CreateFrontendShipDataMutationFn = Apollo.MutationFunction<CreateFrontendShipDataMutation, CreateFrontendShipDataMutationVariables>;

/**
 * __useCreateFrontendShipDataMutation__
 *
 * To run a mutation, you first call `useCreateFrontendShipDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFrontendShipDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFrontendShipDataMutation, { data, loading, error }] = useCreateFrontendShipDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFrontendShipDataMutation(baseOptions?: Apollo.MutationHookOptions<CreateFrontendShipDataMutation, CreateFrontendShipDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFrontendShipDataMutation, CreateFrontendShipDataMutationVariables>(CreateFrontendShipDataDocument, options);
      }
export type CreateFrontendShipDataMutationHookResult = ReturnType<typeof useCreateFrontendShipDataMutation>;
export type CreateFrontendShipDataMutationResult = Apollo.MutationResult<CreateFrontendShipDataMutation>;
export type CreateFrontendShipDataMutationOptions = Apollo.BaseMutationOptions<CreateFrontendShipDataMutation, CreateFrontendShipDataMutationVariables>;
export const CreateReportListDocument = gql`
    mutation createReportList($input: CreateReportListInput!) {
  createReportList(input: $input) {
    CreateReportListStatus
    createdReportCount
    uploadFilePaths {
      dbFilePath
      gcsFilePath
    }
  }
}
    `;
export type CreateReportListMutationFn = Apollo.MutationFunction<CreateReportListMutation, CreateReportListMutationVariables>;

/**
 * __useCreateReportListMutation__
 *
 * To run a mutation, you first call `useCreateReportListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportListMutation, { data, loading, error }] = useCreateReportListMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportListMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportListMutation, CreateReportListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportListMutation, CreateReportListMutationVariables>(CreateReportListDocument, options);
      }
export type CreateReportListMutationHookResult = ReturnType<typeof useCreateReportListMutation>;
export type CreateReportListMutationResult = Apollo.MutationResult<CreateReportListMutation>;
export type CreateReportListMutationOptions = Apollo.BaseMutationOptions<CreateReportListMutation, CreateReportListMutationVariables>;
export const DeleteAnalysisSearchParameterDocument = gql`
    mutation deleteAnalysisSearchParameter($delete_id: Int!) {
  deleteAnalysisSearchParameter(delete_id: $delete_id)
}
    `;
export type DeleteAnalysisSearchParameterMutationFn = Apollo.MutationFunction<DeleteAnalysisSearchParameterMutation, DeleteAnalysisSearchParameterMutationVariables>;

/**
 * __useDeleteAnalysisSearchParameterMutation__
 *
 * To run a mutation, you first call `useDeleteAnalysisSearchParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAnalysisSearchParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAnalysisSearchParameterMutation, { data, loading, error }] = useDeleteAnalysisSearchParameterMutation({
 *   variables: {
 *      delete_id: // value for 'delete_id'
 *   },
 * });
 */
export function useDeleteAnalysisSearchParameterMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAnalysisSearchParameterMutation, DeleteAnalysisSearchParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAnalysisSearchParameterMutation, DeleteAnalysisSearchParameterMutationVariables>(DeleteAnalysisSearchParameterDocument, options);
      }
export type DeleteAnalysisSearchParameterMutationHookResult = ReturnType<typeof useDeleteAnalysisSearchParameterMutation>;
export type DeleteAnalysisSearchParameterMutationResult = Apollo.MutationResult<DeleteAnalysisSearchParameterMutation>;
export type DeleteAnalysisSearchParameterMutationOptions = Apollo.BaseMutationOptions<DeleteAnalysisSearchParameterMutation, DeleteAnalysisSearchParameterMutationVariables>;
export const DepartureListDocument = gql`
    query departureList($input: departureListInput!) {
  departureList(input: $input) {
    totalPageCount
    departureList {
      id
      D_Vessel_Name
      D_Voy
      D_Last_Voy
      D_LorB
      D_Departure_Port
      D_EU_UK_port
      D_Port_L_U
      D_UNLOC
      D_Departure_Date_Time
      D_RU_Date_Time
      D_Time_Zone
      D_ROB_FO
      D_ROB_MGO
      D_ROB_MECO
      D_ROB_MESO
      D_ROB_GESO
      D_ROB_FW
      D_Additional_ROB {
        id
        D_Fuel_Type
        D_Fuel_volume
      }
      D_Cargo_Name
      D_Cargo_Qtty
      D_Draft_Fore
      D_Draft_Aft
      D_Next_Port_Name
      D_ETA
      D_ETB
      D_ETC
      D_ETD
      D_Remark
      D_Spare_1
      D_Spare_1_unit_name
      D_Spare_2
      D_Spare_2_unit_name
      D_Spare_3
      D_Spare_3_unit_name
      D_Spare_4
      D_Spare_4_unit_name
      D_Spare_5
      D_Spare_5_unit_name
      D_Spare_6
      D_Spare_6_unit_name
      D_Spare_7
      D_Spare_7_unit_name
      D_Spare_8
      D_Spare_8_unit_name
      D_Spare_9
      D_Spare_9_unit_name
      D_Spare_10
      D_Spare_10_unit_name
      D_Spare_11
      D_Spare_11_unit_name
      D_Spare_12
      D_Spare_12_unit_name
      D_Spare_13
      D_Spare_13_unit_name
      D_Spare_14
      D_Spare_14_unit_name
      D_Spare_15
      D_Spare_15_unit_name
      D_Spare_16
      D_Spare_16_unit_name
      D_Spare_17
      D_Spare_17_unit_name
      D_Spare_18
      D_Spare_18_unit_name
      D_Spare_19
      D_Spare_19_unit_name
      D_Spare_20
      D_Spare_20_unit_name
    }
  }
}
    `;

/**
 * __useDepartureListQuery__
 *
 * To run a query within a React component, call `useDepartureListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDepartureListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDepartureListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDepartureListQuery(baseOptions: Apollo.QueryHookOptions<DepartureListQuery, DepartureListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DepartureListQuery, DepartureListQueryVariables>(DepartureListDocument, options);
      }
export function useDepartureListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DepartureListQuery, DepartureListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DepartureListQuery, DepartureListQueryVariables>(DepartureListDocument, options);
        }
export type DepartureListQueryHookResult = ReturnType<typeof useDepartureListQuery>;
export type DepartureListLazyQueryHookResult = ReturnType<typeof useDepartureListLazyQuery>;
export type DepartureListQueryResult = Apollo.QueryResult<DepartureListQuery, DepartureListQueryVariables>;
export const DownloadBunkeringFileDocument = gql`
    query downloadBunkeringFile($id: Int!) {
  downloadBunkeringFile(id: $id) {
    bunkeringFileId
    url
  }
}
    `;

/**
 * __useDownloadBunkeringFileQuery__
 *
 * To run a query within a React component, call `useDownloadBunkeringFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadBunkeringFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadBunkeringFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadBunkeringFileQuery(baseOptions: Apollo.QueryHookOptions<DownloadBunkeringFileQuery, DownloadBunkeringFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadBunkeringFileQuery, DownloadBunkeringFileQueryVariables>(DownloadBunkeringFileDocument, options);
      }
export function useDownloadBunkeringFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadBunkeringFileQuery, DownloadBunkeringFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadBunkeringFileQuery, DownloadBunkeringFileQueryVariables>(DownloadBunkeringFileDocument, options);
        }
export type DownloadBunkeringFileQueryHookResult = ReturnType<typeof useDownloadBunkeringFileQuery>;
export type DownloadBunkeringFileLazyQueryHookResult = ReturnType<typeof useDownloadBunkeringFileLazyQuery>;
export type DownloadBunkeringFileQueryResult = Apollo.QueryResult<DownloadBunkeringFileQuery, DownloadBunkeringFileQueryVariables>;
export const DownloadCargoFileDocument = gql`
    query downloadCargoFile($id: Int!) {
  downloadCargoFile(id: $id) {
    cargoFileId
    url
  }
}
    `;

/**
 * __useDownloadCargoFileQuery__
 *
 * To run a query within a React component, call `useDownloadCargoFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadCargoFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadCargoFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadCargoFileQuery(baseOptions: Apollo.QueryHookOptions<DownloadCargoFileQuery, DownloadCargoFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadCargoFileQuery, DownloadCargoFileQueryVariables>(DownloadCargoFileDocument, options);
      }
export function useDownloadCargoFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadCargoFileQuery, DownloadCargoFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadCargoFileQuery, DownloadCargoFileQueryVariables>(DownloadCargoFileDocument, options);
        }
export type DownloadCargoFileQueryHookResult = ReturnType<typeof useDownloadCargoFileQuery>;
export type DownloadCargoFileLazyQueryHookResult = ReturnType<typeof useDownloadCargoFileLazyQuery>;
export type DownloadCargoFileQueryResult = Apollo.QueryResult<DownloadCargoFileQuery, DownloadCargoFileQueryVariables>;
export const DownloadRobFileDocument = gql`
    query downloadRobFile($id: Int!) {
  downloadRobFile(id: $id) {
    robFileId
    url
  }
}
    `;

/**
 * __useDownloadRobFileQuery__
 *
 * To run a query within a React component, call `useDownloadRobFileQuery` and pass it any options that fit your needs.
 * When your component renders, `useDownloadRobFileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDownloadRobFileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDownloadRobFileQuery(baseOptions: Apollo.QueryHookOptions<DownloadRobFileQuery, DownloadRobFileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DownloadRobFileQuery, DownloadRobFileQueryVariables>(DownloadRobFileDocument, options);
      }
export function useDownloadRobFileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DownloadRobFileQuery, DownloadRobFileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DownloadRobFileQuery, DownloadRobFileQueryVariables>(DownloadRobFileDocument, options);
        }
export type DownloadRobFileQueryHookResult = ReturnType<typeof useDownloadRobFileQuery>;
export type DownloadRobFileLazyQueryHookResult = ReturnType<typeof useDownloadRobFileLazyQuery>;
export type DownloadRobFileQueryResult = Apollo.QueryResult<DownloadRobFileQuery, DownloadRobFileQueryVariables>;
export const GetAnalysisSearchParameterDocument = gql`
    query getAnalysisSearchParameter($renderString: String!) {
  getAnalysisSearchParameter(renderString: $renderString) {
    id
    title
    AnalysisSearchParameterDetail {
      filter_type
      imo_no
      n_voy
      from_dateTime
      to_dateTime
      from_bf_scale
      to_bf_scale
      from_me_rpm
      to_me_rpm
      from_hrs_propelling
      to_hrs_propelling
      n_LorB
      n_steam_mode
    }
    created_at
  }
}
    `;

/**
 * __useGetAnalysisSearchParameterQuery__
 *
 * To run a query within a React component, call `useGetAnalysisSearchParameterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAnalysisSearchParameterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAnalysisSearchParameterQuery({
 *   variables: {
 *      renderString: // value for 'renderString'
 *   },
 * });
 */
export function useGetAnalysisSearchParameterQuery(baseOptions: Apollo.QueryHookOptions<GetAnalysisSearchParameterQuery, GetAnalysisSearchParameterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAnalysisSearchParameterQuery, GetAnalysisSearchParameterQueryVariables>(GetAnalysisSearchParameterDocument, options);
      }
export function useGetAnalysisSearchParameterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAnalysisSearchParameterQuery, GetAnalysisSearchParameterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAnalysisSearchParameterQuery, GetAnalysisSearchParameterQueryVariables>(GetAnalysisSearchParameterDocument, options);
        }
export type GetAnalysisSearchParameterQueryHookResult = ReturnType<typeof useGetAnalysisSearchParameterQuery>;
export type GetAnalysisSearchParameterLazyQueryHookResult = ReturnType<typeof useGetAnalysisSearchParameterLazyQuery>;
export type GetAnalysisSearchParameterQueryResult = Apollo.QueryResult<GetAnalysisSearchParameterQuery, GetAnalysisSearchParameterQueryVariables>;
export const GetArrivalDocument = gql`
    query getArrival($input: getArrivalInput!) {
  getArrival(input: $input) {
    id
    ship_id
    A_Vessel_Name
    A_Voy
    A_LorB
    A_Arrival_Port
    A_EU_UK_port
    A_Port_L_U
    A_UNLOC
    A_Arrival_Date_Time
    A_SB_or_Stop
    A_Time_Zone
    A_ETB
    A_ETC
    A_ETD
    A_Berthed
    A_ROB_at_Arrival_FO
    A_ROB_at_Arrival_MGO
    A_ROB_at_Arrival_MECO
    A_ROB_at_Arrival_MESO
    A_ROB_at_Arrival_GESO
    A_ROB_at_Arrival_FW
    A_Hrs_since_Last_Noon
    A_Distance_by_OG
    A_FO_Consumption_per_day_ME
    A_FO_Consumption_per_day_GE
    A_FO_Consumption_per_day_B_and_Inc
    A_MGO_Consumption_per_day_ME
    A_MGO_Consumption_per_day_GE
    A_MGO_Consumption_per_day_B_and_Inc
    A_ROB_FO
    A_ROB_MGO
    A_ROB_MECO
    A_ROB_MESO
    A_ROB_GESO
    A_ROB_FW
    A_Additional_ROB {
      id
      A_Fuel_Type
      A_Fuel_volume
    }
    A_Draft_Fore
    A_Draft_Aft
    A_FO_CO2_emission
    A_MGO_CO2_emission
    A_Remark
    A_Spare_1
    A_Spare_1_unit_name
    A_Spare_2
    A_Spare_2_unit_name
    A_Spare_3
    A_Spare_3_unit_name
    A_Spare_4
    A_Spare_4_unit_name
    A_Spare_5
    A_Spare_5_unit_name
    A_Spare_6
    A_Spare_6_unit_name
    A_Spare_7
    A_Spare_7_unit_name
    A_Spare_8
    A_Spare_8_unit_name
    A_Spare_9
    A_Spare_9_unit_name
    A_Spare_10
    A_Spare_10_unit_name
    A_Spare_11
    A_Spare_11_unit_name
    A_Spare_12
    A_Spare_12_unit_name
    A_Spare_13
    A_Spare_13_unit_name
    A_Spare_14
    A_Spare_14_unit_name
    A_Spare_15
    A_Spare_15_unit_name
    A_Spare_16
    A_Spare_16_unit_name
    A_Spare_17
    A_Spare_17_unit_name
    A_Spare_18
    A_Spare_18_unit_name
    A_Spare_19
    A_Spare_19_unit_name
    A_Spare_20
    A_Spare_20_unit_name
  }
}
    `;

/**
 * __useGetArrivalQuery__
 *
 * To run a query within a React component, call `useGetArrivalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetArrivalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetArrivalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetArrivalQuery(baseOptions: Apollo.QueryHookOptions<GetArrivalQuery, GetArrivalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetArrivalQuery, GetArrivalQueryVariables>(GetArrivalDocument, options);
      }
export function useGetArrivalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetArrivalQuery, GetArrivalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetArrivalQuery, GetArrivalQueryVariables>(GetArrivalDocument, options);
        }
export type GetArrivalQueryHookResult = ReturnType<typeof useGetArrivalQuery>;
export type GetArrivalLazyQueryHookResult = ReturnType<typeof useGetArrivalLazyQuery>;
export type GetArrivalQueryResult = Apollo.QueryResult<GetArrivalQuery, GetArrivalQueryVariables>;
export const GetBunkeringDocument = gql`
    query getBunkering($input: getBunkeringInput!) {
  getBunkering(input: $input) {
    id
    ship_id
    B_Vessel_Name
    B_Voy
    B_Timezone
    B_Bunkering_Date_time
    B_LatLong
    B_PortName
    B_UNLOC
    B_EUorUK
    B_Port_LorU
    B_Fuel_name_1
    B_Mass_1
    B_Volume_1
    B_Density_1
    B_Fuel_name_2
    B_Mass_2
    B_Volume_2
    B_Density_2
    B_Fuel_name_3
    B_Mass_3
    B_Volume_3
    B_Density_3
    B_Fuel_name_4
    B_Mass_4
    B_Volume_4
    B_Density_4
    B_Fuel_name_5
    B_Mass_5
    B_Volume_5
    B_Density_5
    B_Fuel_name_6
    B_Mass_6
    B_Volume_6
    B_Density_6
    B_Fuel_name_7
    B_Mass_7
    B_Volume_7
    B_Density_7
    B_Fuel_name_8
    B_Mass_8
    B_Volume_8
    B_Density_8
    B_Fuel_name_9
    B_Mass_9
    B_Volume_9
    B_Density_9
    B_Fuel_name_10
    B_Mass_10
    B_Volume_10
    B_Density_10
    B_Filename
  }
}
    `;

/**
 * __useGetBunkeringQuery__
 *
 * To run a query within a React component, call `useGetBunkeringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBunkeringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBunkeringQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBunkeringQuery(baseOptions: Apollo.QueryHookOptions<GetBunkeringQuery, GetBunkeringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBunkeringQuery, GetBunkeringQueryVariables>(GetBunkeringDocument, options);
      }
export function useGetBunkeringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBunkeringQuery, GetBunkeringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBunkeringQuery, GetBunkeringQueryVariables>(GetBunkeringDocument, options);
        }
export type GetBunkeringQueryHookResult = ReturnType<typeof useGetBunkeringQuery>;
export type GetBunkeringLazyQueryHookResult = ReturnType<typeof useGetBunkeringLazyQuery>;
export type GetBunkeringQueryResult = Apollo.QueryResult<GetBunkeringQuery, GetBunkeringQueryVariables>;
export const GetCargoFormSettingInfoDocument = gql`
    query getCargoFormSettingInfo($input: getCargoFormSettingInfoInput!) {
  getCargoFormSettingInfo(input: $input) {
    type_of_ship_cii
    fo_fuel_type
    cargoFormSetting {
      type_of_ship_cii
      C_Mass
      C_TEU_Full
      C_TEU_Empty
      C_Unit
      C_Lane_metres
      C_Number_of_Passengers
      C_Volume
    }
    is_mrv_portal_integration_target
  }
}
    `;

/**
 * __useGetCargoFormSettingInfoQuery__
 *
 * To run a query within a React component, call `useGetCargoFormSettingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCargoFormSettingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCargoFormSettingInfoQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCargoFormSettingInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCargoFormSettingInfoQuery, GetCargoFormSettingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCargoFormSettingInfoQuery, GetCargoFormSettingInfoQueryVariables>(GetCargoFormSettingInfoDocument, options);
      }
export function useGetCargoFormSettingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCargoFormSettingInfoQuery, GetCargoFormSettingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCargoFormSettingInfoQuery, GetCargoFormSettingInfoQueryVariables>(GetCargoFormSettingInfoDocument, options);
        }
export type GetCargoFormSettingInfoQueryHookResult = ReturnType<typeof useGetCargoFormSettingInfoQuery>;
export type GetCargoFormSettingInfoLazyQueryHookResult = ReturnType<typeof useGetCargoFormSettingInfoLazyQuery>;
export type GetCargoFormSettingInfoQueryResult = Apollo.QueryResult<GetCargoFormSettingInfoQuery, GetCargoFormSettingInfoQueryVariables>;
export const GetDepartureDocument = gql`
    query getDeparture($input: getDepartureInput!) {
  getDeparture(input: $input) {
    id
    ship_id
    D_Vessel_Name
    D_Voy
    D_Last_Voy
    D_LorB
    D_Departure_Port
    D_EU_UK_port
    D_Port_L_U
    D_UNLOC
    D_Departure_Date_Time
    D_RU_Date_Time
    D_Time_Zone
    D_ROB_FO
    D_ROB_MGO
    D_ROB_MECO
    D_ROB_MESO
    D_ROB_GESO
    D_ROB_FW
    D_Additional_ROB {
      id
      D_Fuel_Type
      D_Fuel_volume
    }
    D_Cargo_Name
    D_Cargo_Qtty
    D_Draft_Fore
    D_Draft_Aft
    D_Next_Port_Name
    D_ETA
    D_ETB
    D_ETC
    D_ETD
    D_Remark
    D_Spare_1
    D_Spare_1_unit_name
    D_Spare_2
    D_Spare_2_unit_name
    D_Spare_3
    D_Spare_3_unit_name
    D_Spare_4
    D_Spare_4_unit_name
    D_Spare_5
    D_Spare_5_unit_name
    D_Spare_6
    D_Spare_6_unit_name
    D_Spare_7
    D_Spare_7_unit_name
    D_Spare_8
    D_Spare_8_unit_name
    D_Spare_9
    D_Spare_9_unit_name
    D_Spare_10
    D_Spare_10_unit_name
    D_Spare_11
    D_Spare_11_unit_name
    D_Spare_12
    D_Spare_12_unit_name
    D_Spare_13
    D_Spare_13_unit_name
    D_Spare_14
    D_Spare_14_unit_name
    D_Spare_15
    D_Spare_15_unit_name
    D_Spare_16
    D_Spare_16_unit_name
    D_Spare_17
    D_Spare_17_unit_name
    D_Spare_18
    D_Spare_18_unit_name
    D_Spare_19
    D_Spare_19_unit_name
    D_Spare_20
    D_Spare_20_unit_name
  }
}
    `;

/**
 * __useGetDepartureQuery__
 *
 * To run a query within a React component, call `useGetDepartureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartureQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetDepartureQuery(baseOptions: Apollo.QueryHookOptions<GetDepartureQuery, GetDepartureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartureQuery, GetDepartureQueryVariables>(GetDepartureDocument, options);
      }
export function useGetDepartureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartureQuery, GetDepartureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartureQuery, GetDepartureQueryVariables>(GetDepartureDocument, options);
        }
export type GetDepartureQueryHookResult = ReturnType<typeof useGetDepartureQuery>;
export type GetDepartureLazyQueryHookResult = ReturnType<typeof useGetDepartureLazyQuery>;
export type GetDepartureQueryResult = Apollo.QueryResult<GetDepartureQuery, GetDepartureQueryVariables>;
export const GetOwnerArrivalDocument = gql`
    query getOwnerArrival($input: getOwnerArrivalInput!) {
  getOwnerArrival(input: $input) {
    id
    ship_id
    A_Vessel_Name
    A_Voy
    A_LorB
    A_Arrival_Port
    A_EU_UK_port
    A_Port_L_U
    A_UNLOC
    A_Arrival_Date_Time
    A_SB_or_Stop
    A_Time_Zone
    A_ETB
    A_ETC
    A_ETD
    A_Berthed
    A_ROB_at_Arrival_FO
    A_ROB_at_Arrival_MGO
    A_ROB_at_Arrival_MECO
    A_ROB_at_Arrival_MESO
    A_ROB_at_Arrival_GESO
    A_ROB_at_Arrival_FW
    A_Hrs_since_Last_Noon
    A_Distance_by_OG
    A_FO_Consumption_per_day_ME
    A_FO_Consumption_per_day_GE
    A_FO_Consumption_per_day_B_and_Inc
    A_MGO_Consumption_per_day_ME
    A_MGO_Consumption_per_day_GE
    A_MGO_Consumption_per_day_B_and_Inc
    A_ROB_FO
    A_ROB_MGO
    A_ROB_MECO
    A_ROB_MESO
    A_ROB_GESO
    A_ROB_FW
    A_Additional_ROB {
      id
      A_Fuel_Type
      A_Fuel_volume
    }
    A_Draft_Fore
    A_Draft_Aft
    A_FO_CO2_emission
    A_MGO_CO2_emission
    A_Remark
    A_Spare_1
    A_Spare_1_unit_name
    A_Spare_2
    A_Spare_2_unit_name
    A_Spare_3
    A_Spare_3_unit_name
    A_Spare_4
    A_Spare_4_unit_name
    A_Spare_5
    A_Spare_5_unit_name
    A_Spare_6
    A_Spare_6_unit_name
    A_Spare_7
    A_Spare_7_unit_name
    A_Spare_8
    A_Spare_8_unit_name
    A_Spare_9
    A_Spare_9_unit_name
    A_Spare_10
    A_Spare_10_unit_name
    A_Spare_11
    A_Spare_11_unit_name
    A_Spare_12
    A_Spare_12_unit_name
    A_Spare_13
    A_Spare_13_unit_name
    A_Spare_14
    A_Spare_14_unit_name
    A_Spare_15
    A_Spare_15_unit_name
    A_Spare_16
    A_Spare_16_unit_name
    A_Spare_17
    A_Spare_17_unit_name
    A_Spare_18
    A_Spare_18_unit_name
    A_Spare_19
    A_Spare_19_unit_name
    A_Spare_20
    A_Spare_20_unit_name
  }
}
    `;

/**
 * __useGetOwnerArrivalQuery__
 *
 * To run a query within a React component, call `useGetOwnerArrivalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerArrivalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerArrivalQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOwnerArrivalQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerArrivalQuery, GetOwnerArrivalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerArrivalQuery, GetOwnerArrivalQueryVariables>(GetOwnerArrivalDocument, options);
      }
export function useGetOwnerArrivalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerArrivalQuery, GetOwnerArrivalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerArrivalQuery, GetOwnerArrivalQueryVariables>(GetOwnerArrivalDocument, options);
        }
export type GetOwnerArrivalQueryHookResult = ReturnType<typeof useGetOwnerArrivalQuery>;
export type GetOwnerArrivalLazyQueryHookResult = ReturnType<typeof useGetOwnerArrivalLazyQuery>;
export type GetOwnerArrivalQueryResult = Apollo.QueryResult<GetOwnerArrivalQuery, GetOwnerArrivalQueryVariables>;
export const GetOwnerBunkeringDocument = gql`
    query getOwnerBunkering($input: getOwnerBunkeringInput!) {
  getOwnerBunkering(input: $input) {
    id
    ship_id
    B_Vessel_Name
    B_Voy
    B_Timezone
    B_Bunkering_Date_time
    B_LatLong
    B_PortName
    B_UNLOC
    B_EUorUK
    B_Port_LorU
    B_Fuel_name_1
    B_Mass_1
    B_Volume_1
    B_Density_1
    B_Fuel_name_2
    B_Mass_2
    B_Volume_2
    B_Density_2
    B_Fuel_name_3
    B_Mass_3
    B_Volume_3
    B_Density_3
    B_Fuel_name_4
    B_Mass_4
    B_Volume_4
    B_Density_4
    B_Fuel_name_5
    B_Mass_5
    B_Volume_5
    B_Density_5
    B_Fuel_name_6
    B_Mass_6
    B_Volume_6
    B_Density_6
    B_Fuel_name_7
    B_Mass_7
    B_Volume_7
    B_Density_7
    B_Fuel_name_8
    B_Mass_8
    B_Volume_8
    B_Density_8
    B_Fuel_name_9
    B_Mass_9
    B_Volume_9
    B_Density_9
    B_Fuel_name_10
    B_Mass_10
    B_Volume_10
    B_Density_10
    B_Filename
  }
}
    `;

/**
 * __useGetOwnerBunkeringQuery__
 *
 * To run a query within a React component, call `useGetOwnerBunkeringQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerBunkeringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerBunkeringQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOwnerBunkeringQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerBunkeringQuery, GetOwnerBunkeringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerBunkeringQuery, GetOwnerBunkeringQueryVariables>(GetOwnerBunkeringDocument, options);
      }
export function useGetOwnerBunkeringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerBunkeringQuery, GetOwnerBunkeringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerBunkeringQuery, GetOwnerBunkeringQueryVariables>(GetOwnerBunkeringDocument, options);
        }
export type GetOwnerBunkeringQueryHookResult = ReturnType<typeof useGetOwnerBunkeringQuery>;
export type GetOwnerBunkeringLazyQueryHookResult = ReturnType<typeof useGetOwnerBunkeringLazyQuery>;
export type GetOwnerBunkeringQueryResult = Apollo.QueryResult<GetOwnerBunkeringQuery, GetOwnerBunkeringQueryVariables>;
export const GetOwnerDepartureDocument = gql`
    query getOwnerDeparture($input: getOwnerDepartureInput!) {
  getOwnerDeparture(input: $input) {
    id
    ship_id
    D_Vessel_Name
    D_Voy
    D_Last_Voy
    D_LorB
    D_Departure_Port
    D_EU_UK_port
    D_Port_L_U
    D_UNLOC
    D_Departure_Date_Time
    D_RU_Date_Time
    D_Time_Zone
    D_ROB_FO
    D_ROB_MGO
    D_ROB_MECO
    D_ROB_MESO
    D_ROB_GESO
    D_ROB_FW
    D_Additional_ROB {
      id
      D_Fuel_Type
      D_Fuel_volume
    }
    D_Cargo_Name
    D_Cargo_Qtty
    D_Draft_Fore
    D_Draft_Aft
    D_Next_Port_Name
    D_ETA
    D_ETB
    D_ETC
    D_ETD
    D_Remark
    D_Spare_1
    D_Spare_1_unit_name
    D_Spare_2
    D_Spare_2_unit_name
    D_Spare_3
    D_Spare_3_unit_name
    D_Spare_4
    D_Spare_4_unit_name
    D_Spare_5
    D_Spare_5_unit_name
    D_Spare_6
    D_Spare_6_unit_name
    D_Spare_7
    D_Spare_7_unit_name
    D_Spare_8
    D_Spare_8_unit_name
    D_Spare_9
    D_Spare_9_unit_name
    D_Spare_10
    D_Spare_10_unit_name
    D_Spare_11
    D_Spare_11_unit_name
    D_Spare_12
    D_Spare_12_unit_name
    D_Spare_13
    D_Spare_13_unit_name
    D_Spare_14
    D_Spare_14_unit_name
    D_Spare_15
    D_Spare_15_unit_name
    D_Spare_16
    D_Spare_16_unit_name
    D_Spare_17
    D_Spare_17_unit_name
    D_Spare_18
    D_Spare_18_unit_name
    D_Spare_19
    D_Spare_19_unit_name
    D_Spare_20
    D_Spare_20_unit_name
  }
}
    `;

/**
 * __useGetOwnerDepartureQuery__
 *
 * To run a query within a React component, call `useGetOwnerDepartureQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerDepartureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerDepartureQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOwnerDepartureQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerDepartureQuery, GetOwnerDepartureQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerDepartureQuery, GetOwnerDepartureQueryVariables>(GetOwnerDepartureDocument, options);
      }
export function useGetOwnerDepartureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerDepartureQuery, GetOwnerDepartureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerDepartureQuery, GetOwnerDepartureQueryVariables>(GetOwnerDepartureDocument, options);
        }
export type GetOwnerDepartureQueryHookResult = ReturnType<typeof useGetOwnerDepartureQuery>;
export type GetOwnerDepartureLazyQueryHookResult = ReturnType<typeof useGetOwnerDepartureLazyQuery>;
export type GetOwnerDepartureQueryResult = Apollo.QueryResult<GetOwnerDepartureQuery, GetOwnerDepartureQueryVariables>;
export const GetOwnerReportDocument = gql`
    query getOwnerReport($input: getOwnerReportInput!) {
  getOwnerReport(input: $input) {
    id
    ship_id
    ship {
      fo_fuel_type
    }
    N_Vessel_name
    N_Voy
    N_LorB
    N_Noon_Port
    N_UNLOC
    N_EU_UK_port
    N_Port_L_U
    N_DateTime
    N_TimeZone
    N_LatLong
    N_Steam_mode
    N_Hrs_propelling
    N_Dist_OG
    N_Speed_OG
    N_Speed_OW
    N_ME_rpm_ave
    N_ME_rpm_total
    N_ME_Revolution
    N_Slip
    N_FO_Consumption_per_day_ME
    N_FO_Consumption_per_day_GE
    N_FO_Consumption_per_day_BInc
    N_FO_Additional_FuelType_1
    N_FO_Additional_Usage_1
    N_FO_Additional_volume_1
    N_FO_Additional_FuelType_2
    N_FO_Additional_Usage_2
    N_FO_Additional_volume_2
    N_FO_Additional_FuelType_3
    N_FO_Additional_Usage_3
    N_FO_Additional_volume_3
    N_FO_Additional_FuelType_4
    N_FO_Additional_Usage_4
    N_FO_Additional_volume_4
    N_FO_Additional_FuelType_5
    N_FO_Additional_Usage_5
    N_FO_Additional_volume_5
    N_MGO_Consumption_per_day_ME
    N_MGO_Consumption_per_day_GE
    N_MGO_Consumption_per_day_Boiler
    N_MGO_Additional_FuelType_1
    N_MGO_Additional_Usage_1
    N_MGO_Additional_volume_1
    N_MGO_Additional_FuelType_2
    N_MGO_Additional_Usage_2
    N_MGO_Additional_volume_2
    N_MGO_Additional_FuelType_3
    N_MGO_Additional_Usage_3
    N_MGO_Additional_volume_3
    N_MGO_Additional_FuelType_4
    N_MGO_Additional_Usage_4
    N_MGO_Additional_volume_4
    N_MGO_Additional_FuelType_5
    N_MGO_Additional_Usage_5
    N_MGO_Additional_volume_5
    N_LO_Consumption_per_day_MECO
    N_LO_Consumption_per_day_MESO
    N_LO_Consumption_per_day_GESO
    N_Other_Additional_FuelType_1
    N_Other_Additional_Usage_1
    N_Other_Additional_volume_1
    N_Other_Additional_FuelType_2
    N_Other_Additional_Usage_2
    N_Other_Additional_volume_2
    N_Other_Additional_FuelType_3
    N_Other_Additional_Usage_3
    N_Other_Additional_volume_3
    N_Other_Additional_FuelType_4
    N_Other_Additional_Usage_4
    N_Other_Additional_volume_4
    N_Other_Additional_FuelType_5
    N_Other_Additional_Usage_5
    N_Other_Additional_volume_5
    N_Additional_ROB {
      id
      N_Fuel_Type
      N_Fuel_volume
    }
    N_ROB_Filename
    N_Weather
    N_Wind_direction
    N_BF_scale
    N_Swell
    N_Noon_Course
    N_Dist_to_go
    N_Next_port
    N_ETA
    N_ETB
    N_ETD
    N_ME_Fuel_index
    N_ME_RPM
    N_ME_horsepower
    N_ME_power
    N_ME_power_measurement_method
    N_Running_hours_SOx_scrubber
    N_Running_hours_ME_EGR
    N_Running_hours_GE_SCR
    N_ROB_FO
    N_ROB_MGO
    N_ROB_MECO
    N_ROB_MESO
    N_ROB_GESO
    N_ROB_FW
    N_FO_CO2_emission_per_unit
    N_MGO_CO2_emission_per_unit
    N_FO_CO2_emission
    N_MGO_CO2_emission
    N_Remark
    N_Spare_1
    N_Spare_1_unit_name
    N_Spare_2
    N_Spare_2_unit_name
    N_Spare_3
    N_Spare_3_unit_name
    N_Spare_4
    N_Spare_4_unit_name
    N_Spare_5
    N_Spare_5_unit_name
    N_Spare_6
    N_Spare_6_unit_name
    N_Spare_7
    N_Spare_7_unit_name
    N_Spare_8
    N_Spare_8_unit_name
    N_Spare_9
    N_Spare_9_unit_name
    N_Spare_10
    N_Spare_10_unit_name
    N_Spare_11
    N_Spare_11_unit_name
    N_Spare_12
    N_Spare_12_unit_name
    N_Spare_13
    N_Spare_13_unit_name
    N_Spare_14
    N_Spare_14_unit_name
    N_Spare_15
    N_Spare_15_unit_name
    N_Spare_16
    N_Spare_16_unit_name
    N_Spare_17
    N_Spare_17_unit_name
    N_Spare_18
    N_Spare_18_unit_name
    N_Spare_19
    N_Spare_19_unit_name
    N_Spare_20
    N_Spare_20_unit_name
  }
}
    `;

/**
 * __useGetOwnerReportQuery__
 *
 * To run a query within a React component, call `useGetOwnerReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOwnerReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOwnerReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOwnerReportQuery(baseOptions: Apollo.QueryHookOptions<GetOwnerReportQuery, GetOwnerReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOwnerReportQuery, GetOwnerReportQueryVariables>(GetOwnerReportDocument, options);
      }
export function useGetOwnerReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOwnerReportQuery, GetOwnerReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOwnerReportQuery, GetOwnerReportQueryVariables>(GetOwnerReportDocument, options);
        }
export type GetOwnerReportQueryHookResult = ReturnType<typeof useGetOwnerReportQuery>;
export type GetOwnerReportLazyQueryHookResult = ReturnType<typeof useGetOwnerReportLazyQuery>;
export type GetOwnerReportQueryResult = Apollo.QueryResult<GetOwnerReportQuery, GetOwnerReportQueryVariables>;
export const GetReportDocument = gql`
    query getReport($input: getReportInput!) {
  getReport(input: $input) {
    id
    ship_id
    N_Vessel_name
    N_Voy
    N_LorB
    N_Noon_Port
    N_UNLOC
    N_EU_UK_port
    N_Port_L_U
    N_DateTime
    N_TimeZone
    N_LatLong
    N_Steam_mode
    N_Hrs_propelling
    N_Dist_OG
    N_Speed_OG
    N_Speed_OW
    N_ME_rpm_ave
    N_ME_rpm_total
    N_ME_Revolution
    N_Slip
    N_FO_Consumption_per_day_ME
    N_FO_Consumption_per_day_GE
    N_FO_Consumption_per_day_BInc
    N_FO_Additional_FuelType_1
    N_FO_Additional_Usage_1
    N_FO_Additional_volume_1
    N_FO_Additional_FuelType_2
    N_FO_Additional_Usage_2
    N_FO_Additional_volume_2
    N_FO_Additional_FuelType_3
    N_FO_Additional_Usage_3
    N_FO_Additional_volume_3
    N_FO_Additional_FuelType_4
    N_FO_Additional_Usage_4
    N_FO_Additional_volume_4
    N_FO_Additional_FuelType_5
    N_FO_Additional_Usage_5
    N_FO_Additional_volume_5
    N_MGO_Consumption_per_day_ME
    N_MGO_Consumption_per_day_GE
    N_MGO_Consumption_per_day_Boiler
    N_MGO_Additional_FuelType_1
    N_MGO_Additional_Usage_1
    N_MGO_Additional_volume_1
    N_MGO_Additional_FuelType_2
    N_MGO_Additional_Usage_2
    N_MGO_Additional_volume_2
    N_MGO_Additional_FuelType_3
    N_MGO_Additional_Usage_3
    N_MGO_Additional_volume_3
    N_MGO_Additional_FuelType_4
    N_MGO_Additional_Usage_4
    N_MGO_Additional_volume_4
    N_MGO_Additional_FuelType_5
    N_MGO_Additional_Usage_5
    N_MGO_Additional_volume_5
    N_LO_Consumption_per_day_MECO
    N_LO_Consumption_per_day_MESO
    N_LO_Consumption_per_day_GESO
    N_Other_Additional_FuelType_1
    N_Other_Additional_Usage_1
    N_Other_Additional_volume_1
    N_Other_Additional_FuelType_2
    N_Other_Additional_Usage_2
    N_Other_Additional_volume_2
    N_Other_Additional_FuelType_3
    N_Other_Additional_Usage_3
    N_Other_Additional_volume_3
    N_Other_Additional_FuelType_4
    N_Other_Additional_Usage_4
    N_Other_Additional_volume_4
    N_Other_Additional_FuelType_5
    N_Other_Additional_Usage_5
    N_Other_Additional_volume_5
    N_Additional_ROB {
      id
      N_Fuel_Type
      N_Fuel_volume
    }
    N_ROB_Filename
    N_Weather
    N_Wind_direction
    N_BF_scale
    N_Swell
    N_Noon_Course
    N_Dist_to_go
    N_Next_port
    N_ETA
    N_ETB
    N_ETD
    N_ME_Fuel_index
    N_ME_RPM
    N_ME_horsepower
    N_ME_power
    N_ME_power_measurement_method
    N_Running_hours_SOx_scrubber
    N_Running_hours_ME_EGR
    N_Running_hours_GE_SCR
    N_ROB_FO
    N_ROB_MGO
    N_ROB_MECO
    N_ROB_MESO
    N_ROB_GESO
    N_ROB_FW
    N_FO_CO2_emission_per_unit
    N_MGO_CO2_emission_per_unit
    N_FO_CO2_emission
    N_MGO_CO2_emission
    N_Remark
    N_Spare_1
    N_Spare_1_unit_name
    N_Spare_2
    N_Spare_2_unit_name
    N_Spare_3
    N_Spare_3_unit_name
    N_Spare_4
    N_Spare_4_unit_name
    N_Spare_5
    N_Spare_5_unit_name
    N_Spare_6
    N_Spare_6_unit_name
    N_Spare_7
    N_Spare_7_unit_name
    N_Spare_8
    N_Spare_8_unit_name
    N_Spare_9
    N_Spare_9_unit_name
    N_Spare_10
    N_Spare_10_unit_name
    N_Spare_11
    N_Spare_11_unit_name
    N_Spare_12
    N_Spare_12_unit_name
    N_Spare_13
    N_Spare_13_unit_name
    N_Spare_14
    N_Spare_14_unit_name
    N_Spare_15
    N_Spare_15_unit_name
    N_Spare_16
    N_Spare_16_unit_name
    N_Spare_17
    N_Spare_17_unit_name
    N_Spare_18
    N_Spare_18_unit_name
    N_Spare_19
    N_Spare_19_unit_name
    N_Spare_20
    N_Spare_20_unit_name
  }
}
    `;

/**
 * __useGetReportQuery__
 *
 * To run a query within a React component, call `useGetReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReportQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetReportQuery(baseOptions: Apollo.QueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
      }
export function useGetReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetReportQuery, GetReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetReportQuery, GetReportQueryVariables>(GetReportDocument, options);
        }
export type GetReportQueryHookResult = ReturnType<typeof useGetReportQuery>;
export type GetReportLazyQueryHookResult = ReturnType<typeof useGetReportLazyQuery>;
export type GetReportQueryResult = Apollo.QueryResult<GetReportQuery, GetReportQueryVariables>;
export const GetShipDataDocument = gql`
    query getShipData($filter: shipListFiler!) {
  shipList(filter: $filter) {
    id
    IMO_No
    name
    summer_deadweight
    propeller_pitch
    type_of_ship_cii
    fo_fuel_type
    is_mrv_portal_integration_target
    cargoFormSetting {
      type_of_ship_cii
      C_Mass
      C_TEU_Full
      C_TEU_Empty
      C_Unit
      C_Lane_metres
      C_Number_of_Passengers
      C_Volume
    }
    shipMaster {
      IMONo
      lastUpdated
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useGetShipDataQuery__
 *
 * To run a query within a React component, call `useGetShipDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipDataQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetShipDataQuery(baseOptions: Apollo.QueryHookOptions<GetShipDataQuery, GetShipDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetShipDataQuery, GetShipDataQueryVariables>(GetShipDataDocument, options);
      }
export function useGetShipDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetShipDataQuery, GetShipDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetShipDataQuery, GetShipDataQueryVariables>(GetShipDataDocument, options);
        }
export type GetShipDataQueryHookResult = ReturnType<typeof useGetShipDataQuery>;
export type GetShipDataLazyQueryHookResult = ReturnType<typeof useGetShipDataLazyQuery>;
export type GetShipDataQueryResult = Apollo.QueryResult<GetShipDataQuery, GetShipDataQueryVariables>;
export const OrganizationDocument = gql`
    query organization {
  organization {
    id
    name
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const ReferenceDataListDocument = gql`
    query referenceDataList($input: referenceDataListInput!) {
  referenceDataList(input: $input) {
    Speed_OG
    fuel_consumption_Ballast
    fuel_consumption_Laden
    fuel_consumption_Unique
    dataType
  }
}
    `;

/**
 * __useReferenceDataListQuery__
 *
 * To run a query within a React component, call `useReferenceDataListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferenceDataListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferenceDataListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReferenceDataListQuery(baseOptions: Apollo.QueryHookOptions<ReferenceDataListQuery, ReferenceDataListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferenceDataListQuery, ReferenceDataListQueryVariables>(ReferenceDataListDocument, options);
      }
export function useReferenceDataListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferenceDataListQuery, ReferenceDataListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferenceDataListQuery, ReferenceDataListQueryVariables>(ReferenceDataListDocument, options);
        }
export type ReferenceDataListQueryHookResult = ReturnType<typeof useReferenceDataListQuery>;
export type ReferenceDataListLazyQueryHookResult = ReturnType<typeof useReferenceDataListLazyQuery>;
export type ReferenceDataListQueryResult = Apollo.QueryResult<ReferenceDataListQuery, ReferenceDataListQueryVariables>;
export const ReportGraphFilterDocument = gql`
    query reportGraphFilter($input: reportListInput!) {
  reportList(input: $input) {
    reportList {
      id
      N_Hrs_propelling
      N_Speed_OG
      N_DateTime
      N_FO_Consumption_per_day_ME
      N_FO_Consumption_per_day_GE
      N_FO_Consumption_per_day_BInc
    }
  }
}
    `;

/**
 * __useReportGraphFilterQuery__
 *
 * To run a query within a React component, call `useReportGraphFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportGraphFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportGraphFilterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportGraphFilterQuery(baseOptions: Apollo.QueryHookOptions<ReportGraphFilterQuery, ReportGraphFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportGraphFilterQuery, ReportGraphFilterQueryVariables>(ReportGraphFilterDocument, options);
      }
export function useReportGraphFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportGraphFilterQuery, ReportGraphFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportGraphFilterQuery, ReportGraphFilterQueryVariables>(ReportGraphFilterDocument, options);
        }
export type ReportGraphFilterQueryHookResult = ReturnType<typeof useReportGraphFilterQuery>;
export type ReportGraphFilterLazyQueryHookResult = ReturnType<typeof useReportGraphFilterLazyQuery>;
export type ReportGraphFilterQueryResult = Apollo.QueryResult<ReportGraphFilterQuery, ReportGraphFilterQueryVariables>;
export const ReportListDocument = gql`
    query reportList($input: reportListInput!) {
  reportList(input: $input) {
    totalPageCount
    reportList {
      id
      N_Vessel_name
      N_Voy
      N_LorB
      N_Noon_Port
      N_UNLOC
      N_EU_UK_port
      N_Port_L_U
      N_DateTime
      N_DateTime
      N_TimeZone
      N_LatLong
      N_Steam_mode
      N_Hrs_propelling
      N_Dist_OG
      N_Speed_OG
      N_Speed_OW
      N_ME_rpm_ave
      N_ME_rpm_total
      N_ME_Revolution
      N_Slip
      N_FO_Consumption_per_day_ME
      N_FO_Consumption_per_day_GE
      N_FO_Consumption_per_day_BInc
      N_FO_Additional_FuelType_1
      N_FO_Additional_Usage_1
      N_FO_Additional_volume_1
      N_FO_Additional_FuelType_2
      N_FO_Additional_Usage_2
      N_FO_Additional_volume_2
      N_FO_Additional_FuelType_3
      N_FO_Additional_Usage_3
      N_FO_Additional_volume_3
      N_FO_Additional_FuelType_4
      N_FO_Additional_Usage_4
      N_FO_Additional_volume_4
      N_FO_Additional_FuelType_5
      N_FO_Additional_Usage_5
      N_FO_Additional_volume_5
      N_MGO_Consumption_per_day_ME
      N_MGO_Consumption_per_day_GE
      N_MGO_Consumption_per_day_Boiler
      N_MGO_Additional_FuelType_1
      N_MGO_Additional_Usage_1
      N_MGO_Additional_volume_1
      N_MGO_Additional_FuelType_2
      N_MGO_Additional_Usage_2
      N_MGO_Additional_volume_2
      N_MGO_Additional_FuelType_3
      N_MGO_Additional_Usage_3
      N_MGO_Additional_volume_3
      N_MGO_Additional_FuelType_4
      N_MGO_Additional_Usage_4
      N_MGO_Additional_volume_4
      N_MGO_Additional_FuelType_5
      N_MGO_Additional_Usage_5
      N_MGO_Additional_volume_5
      N_LO_Consumption_per_day_MECO
      N_LO_Consumption_per_day_MESO
      N_LO_Consumption_per_day_GESO
      N_Other_Additional_FuelType_1
      N_Other_Additional_Usage_1
      N_Other_Additional_volume_1
      N_Other_Additional_FuelType_2
      N_Other_Additional_Usage_2
      N_Other_Additional_volume_2
      N_Other_Additional_FuelType_3
      N_Other_Additional_Usage_3
      N_Other_Additional_volume_3
      N_Other_Additional_FuelType_4
      N_Other_Additional_Usage_4
      N_Other_Additional_volume_4
      N_Other_Additional_FuelType_5
      N_Other_Additional_Usage_5
      N_Other_Additional_volume_5
      N_Additional_ROB {
        id
        N_Fuel_Type
        N_Fuel_volume
      }
      N_Weather
      N_Wind_direction
      N_BF_scale
      N_Swell
      N_Noon_Course
      N_Dist_to_go
      N_Next_port
      N_ETA
      N_ETB
      N_ETD
      N_ME_Fuel_index
      N_ME_RPM
      N_ME_horsepower
      N_ME_power
      N_ME_power_measurement_method
      N_Running_hours_SOx_scrubber
      N_Running_hours_ME_EGR
      N_Running_hours_GE_SCR
      N_ROB_FO
      N_ROB_MGO
      N_ROB_MECO
      N_ROB_MESO
      N_ROB_GESO
      N_ROB_FW
      N_FO_CO2_emission_per_unit
      N_MGO_CO2_emission_per_unit
      N_FO_CO2_emission
      N_MGO_CO2_emission
      N_Remark
      N_Spare_1
      N_Spare_1_unit_name
      N_Spare_2
      N_Spare_2_unit_name
      N_Spare_3
      N_Spare_3_unit_name
      N_Spare_4
      N_Spare_4_unit_name
      N_Spare_5
      N_Spare_5_unit_name
      N_Spare_6
      N_Spare_6_unit_name
      N_Spare_7
      N_Spare_7_unit_name
      N_Spare_8
      N_Spare_8_unit_name
      N_Spare_9
      N_Spare_9_unit_name
      N_Spare_10
      N_Spare_10_unit_name
      N_Spare_11
      N_Spare_11_unit_name
      N_Spare_12
      N_Spare_12_unit_name
      N_Spare_13
      N_Spare_13_unit_name
      N_Spare_14
      N_Spare_14_unit_name
      N_Spare_15
      N_Spare_15_unit_name
      N_Spare_16
      N_Spare_16_unit_name
      N_Spare_17
      N_Spare_17_unit_name
      N_Spare_18
      N_Spare_18_unit_name
      N_Spare_19
      N_Spare_19_unit_name
      N_Spare_20
      N_Spare_20_unit_name
      ship_id
    }
  }
}
    `;

/**
 * __useReportListQuery__
 *
 * To run a query within a React component, call `useReportListQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReportListQuery(baseOptions: Apollo.QueryHookOptions<ReportListQuery, ReportListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportListQuery, ReportListQueryVariables>(ReportListDocument, options);
      }
export function useReportListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportListQuery, ReportListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportListQuery, ReportListQueryVariables>(ReportListDocument, options);
        }
export type ReportListQueryHookResult = ReturnType<typeof useReportListQuery>;
export type ReportListLazyQueryHookResult = ReturnType<typeof useReportListLazyQuery>;
export type ReportListQueryResult = Apollo.QueryResult<ReportListQuery, ReportListQueryVariables>;
export const SendReportToMrvDocument = gql`
    mutation sendReportToMrv($input: SendReportToMrvInput!) {
  sendReportToMrv(input: $input) {
    success
    message
  }
}
    `;
export type SendReportToMrvMutationFn = Apollo.MutationFunction<SendReportToMrvMutation, SendReportToMrvMutationVariables>;

/**
 * __useSendReportToMrvMutation__
 *
 * To run a mutation, you first call `useSendReportToMrvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendReportToMrvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendReportToMrvMutation, { data, loading, error }] = useSendReportToMrvMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendReportToMrvMutation(baseOptions?: Apollo.MutationHookOptions<SendReportToMrvMutation, SendReportToMrvMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendReportToMrvMutation, SendReportToMrvMutationVariables>(SendReportToMrvDocument, options);
      }
export type SendReportToMrvMutationHookResult = ReturnType<typeof useSendReportToMrvMutation>;
export type SendReportToMrvMutationResult = Apollo.MutationResult<SendReportToMrvMutation>;
export type SendReportToMrvMutationOptions = Apollo.BaseMutationOptions<SendReportToMrvMutation, SendReportToMrvMutationVariables>;
export const ShipListDocument = gql`
    query shipList {
  shipList {
    id
    IMO_No
    name
    summer_deadweight
    propeller_pitch
    type_of_ship_cii
    fo_fuel_type
    is_mrv_portal_integration_target
    cargoFormSetting {
      type_of_ship_cii
      C_Mass
      C_TEU_Full
      C_TEU_Empty
      C_Unit
      C_Lane_metres
      C_Number_of_Passengers
      C_Volume
    }
    shipMaster {
      IMONo
      lastUpdated
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useShipListQuery__
 *
 * To run a query within a React component, call `useShipListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShipListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShipListQuery({
 *   variables: {
 *   },
 * });
 */
export function useShipListQuery(baseOptions?: Apollo.QueryHookOptions<ShipListQuery, ShipListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShipListQuery, ShipListQueryVariables>(ShipListDocument, options);
      }
export function useShipListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShipListQuery, ShipListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShipListQuery, ShipListQueryVariables>(ShipListDocument, options);
        }
export type ShipListQueryHookResult = ReturnType<typeof useShipListQuery>;
export type ShipListLazyQueryHookResult = ReturnType<typeof useShipListLazyQuery>;
export type ShipListQueryResult = Apollo.QueryResult<ShipListQuery, ShipListQueryVariables>;
export const UpdateAnalysisSearchParameterTitleDocument = gql`
    mutation updateAnalysisSearchParameterTitle($input: AnalysisSearchParameterInput!) {
  updateAnalysisSearchParameterTitle(input: $input) {
    title
  }
}
    `;
export type UpdateAnalysisSearchParameterTitleMutationFn = Apollo.MutationFunction<UpdateAnalysisSearchParameterTitleMutation, UpdateAnalysisSearchParameterTitleMutationVariables>;

/**
 * __useUpdateAnalysisSearchParameterTitleMutation__
 *
 * To run a mutation, you first call `useUpdateAnalysisSearchParameterTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAnalysisSearchParameterTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAnalysisSearchParameterTitleMutation, { data, loading, error }] = useUpdateAnalysisSearchParameterTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAnalysisSearchParameterTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAnalysisSearchParameterTitleMutation, UpdateAnalysisSearchParameterTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAnalysisSearchParameterTitleMutation, UpdateAnalysisSearchParameterTitleMutationVariables>(UpdateAnalysisSearchParameterTitleDocument, options);
      }
export type UpdateAnalysisSearchParameterTitleMutationHookResult = ReturnType<typeof useUpdateAnalysisSearchParameterTitleMutation>;
export type UpdateAnalysisSearchParameterTitleMutationResult = Apollo.MutationResult<UpdateAnalysisSearchParameterTitleMutation>;
export type UpdateAnalysisSearchParameterTitleMutationOptions = Apollo.BaseMutationOptions<UpdateAnalysisSearchParameterTitleMutation, UpdateAnalysisSearchParameterTitleMutationVariables>;
export const UpdateArrivalDocument = gql`
    mutation updateArrival($input: ArrivalInput!) {
  updateArrival(input: $input) {
    Arrival {
      id
    }
  }
}
    `;
export type UpdateArrivalMutationFn = Apollo.MutationFunction<UpdateArrivalMutation, UpdateArrivalMutationVariables>;

/**
 * __useUpdateArrivalMutation__
 *
 * To run a mutation, you first call `useUpdateArrivalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateArrivalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateArrivalMutation, { data, loading, error }] = useUpdateArrivalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateArrivalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateArrivalMutation, UpdateArrivalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateArrivalMutation, UpdateArrivalMutationVariables>(UpdateArrivalDocument, options);
      }
export type UpdateArrivalMutationHookResult = ReturnType<typeof useUpdateArrivalMutation>;
export type UpdateArrivalMutationResult = Apollo.MutationResult<UpdateArrivalMutation>;
export type UpdateArrivalMutationOptions = Apollo.BaseMutationOptions<UpdateArrivalMutation, UpdateArrivalMutationVariables>;
export const UpdateBunkeringDocument = gql`
    mutation updateBunkering($input: BunkeringInput!) {
  updateBunkering(input: $input) {
    Bunkering {
      id
      B_Filename
    }
    gcsFilePath
    isFileUpload
  }
}
    `;
export type UpdateBunkeringMutationFn = Apollo.MutationFunction<UpdateBunkeringMutation, UpdateBunkeringMutationVariables>;

/**
 * __useUpdateBunkeringMutation__
 *
 * To run a mutation, you first call `useUpdateBunkeringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBunkeringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBunkeringMutation, { data, loading, error }] = useUpdateBunkeringMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBunkeringMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBunkeringMutation, UpdateBunkeringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBunkeringMutation, UpdateBunkeringMutationVariables>(UpdateBunkeringDocument, options);
      }
export type UpdateBunkeringMutationHookResult = ReturnType<typeof useUpdateBunkeringMutation>;
export type UpdateBunkeringMutationResult = Apollo.MutationResult<UpdateBunkeringMutation>;
export type UpdateBunkeringMutationOptions = Apollo.BaseMutationOptions<UpdateBunkeringMutation, UpdateBunkeringMutationVariables>;
export const UpdateCargoDocument = gql`
    mutation updateCargo($input: CargoInput!) {
  updateCargo(input: $input) {
    Cargo {
      id
      C_Filename
    }
    gcsFilePath
    isFileUpload
  }
}
    `;
export type UpdateCargoMutationFn = Apollo.MutationFunction<UpdateCargoMutation, UpdateCargoMutationVariables>;

/**
 * __useUpdateCargoMutation__
 *
 * To run a mutation, you first call `useUpdateCargoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCargoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCargoMutation, { data, loading, error }] = useUpdateCargoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCargoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCargoMutation, UpdateCargoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCargoMutation, UpdateCargoMutationVariables>(UpdateCargoDocument, options);
      }
export type UpdateCargoMutationHookResult = ReturnType<typeof useUpdateCargoMutation>;
export type UpdateCargoMutationResult = Apollo.MutationResult<UpdateCargoMutation>;
export type UpdateCargoMutationOptions = Apollo.BaseMutationOptions<UpdateCargoMutation, UpdateCargoMutationVariables>;
export const UpdateDepartureDocument = gql`
    mutation updateDeparture($input: DepartureInput!) {
  updateDeparture(input: $input) {
    Departure {
      id
    }
  }
}
    `;
export type UpdateDepartureMutationFn = Apollo.MutationFunction<UpdateDepartureMutation, UpdateDepartureMutationVariables>;

/**
 * __useUpdateDepartureMutation__
 *
 * To run a mutation, you first call `useUpdateDepartureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDepartureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDepartureMutation, { data, loading, error }] = useUpdateDepartureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDepartureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDepartureMutation, UpdateDepartureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDepartureMutation, UpdateDepartureMutationVariables>(UpdateDepartureDocument, options);
      }
export type UpdateDepartureMutationHookResult = ReturnType<typeof useUpdateDepartureMutation>;
export type UpdateDepartureMutationResult = Apollo.MutationResult<UpdateDepartureMutation>;
export type UpdateDepartureMutationOptions = Apollo.BaseMutationOptions<UpdateDepartureMutation, UpdateDepartureMutationVariables>;
export const UpdateReportDocument = gql`
    mutation updateReport($input: ReportInput!) {
  updateReport(input: $input) {
    UpdateReportStatus
    Report {
      id
      N_ROB_Filename
    }
    gcsFilePath
    isFileUpload
  }
}
    `;
export type UpdateReportMutationFn = Apollo.MutationFunction<UpdateReportMutation, UpdateReportMutationVariables>;

/**
 * __useUpdateReportMutation__
 *
 * To run a mutation, you first call `useUpdateReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportMutation, { data, loading, error }] = useUpdateReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportMutation, UpdateReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportMutation, UpdateReportMutationVariables>(UpdateReportDocument, options);
      }
export type UpdateReportMutationHookResult = ReturnType<typeof useUpdateReportMutation>;
export type UpdateReportMutationResult = Apollo.MutationResult<UpdateReportMutation>;
export type UpdateReportMutationOptions = Apollo.BaseMutationOptions<UpdateReportMutation, UpdateReportMutationVariables>;
export const UpsertAnalysisSearchParameterDocument = gql`
    mutation upsertAnalysisSearchParameter($input: AnalysisSearchParameterInput!) {
  upsertAnalysisSearchParameter(input: $input)
}
    `;
export type UpsertAnalysisSearchParameterMutationFn = Apollo.MutationFunction<UpsertAnalysisSearchParameterMutation, UpsertAnalysisSearchParameterMutationVariables>;

/**
 * __useUpsertAnalysisSearchParameterMutation__
 *
 * To run a mutation, you first call `useUpsertAnalysisSearchParameterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAnalysisSearchParameterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAnalysisSearchParameterMutation, { data, loading, error }] = useUpsertAnalysisSearchParameterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertAnalysisSearchParameterMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAnalysisSearchParameterMutation, UpsertAnalysisSearchParameterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertAnalysisSearchParameterMutation, UpsertAnalysisSearchParameterMutationVariables>(UpsertAnalysisSearchParameterDocument, options);
      }
export type UpsertAnalysisSearchParameterMutationHookResult = ReturnType<typeof useUpsertAnalysisSearchParameterMutation>;
export type UpsertAnalysisSearchParameterMutationResult = Apollo.MutationResult<UpsertAnalysisSearchParameterMutation>;
export type UpsertAnalysisSearchParameterMutationOptions = Apollo.BaseMutationOptions<UpsertAnalysisSearchParameterMutation, UpsertAnalysisSearchParameterMutationVariables>;
export const VesselNamesDocument = gql`
    query vesselNames {
  shipList {
    id
    name
    IMO_No
    is_mrv_portal_integration_target
  }
}
    `;

/**
 * __useVesselNamesQuery__
 *
 * To run a query within a React component, call `useVesselNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVesselNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVesselNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVesselNamesQuery(baseOptions?: Apollo.QueryHookOptions<VesselNamesQuery, VesselNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VesselNamesQuery, VesselNamesQueryVariables>(VesselNamesDocument, options);
      }
export function useVesselNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VesselNamesQuery, VesselNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VesselNamesQuery, VesselNamesQueryVariables>(VesselNamesDocument, options);
        }
export type VesselNamesQueryHookResult = ReturnType<typeof useVesselNamesQuery>;
export type VesselNamesLazyQueryHookResult = ReturnType<typeof useVesselNamesLazyQuery>;
export type VesselNamesQueryResult = Apollo.QueryResult<VesselNamesQuery, VesselNamesQueryVariables>;